webpackJsonp([205441848602771],{

/***/ 4198:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(235);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  label: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  label: 'Close'
	};
	
	var CloseButton = function (_React$Component) {
	  (0, _inherits3.default)(CloseButton, _React$Component);
	
	  function CloseButton() {
	    (0, _classCallCheck3.default)(this, CloseButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CloseButton.prototype.render = function render() {
	    var _props = this.props,
	        label = _props.label,
	        onClick = _props.onClick;
	
	    return _react2.default.createElement(
	      'button',
	      { type: 'button', className: 'close', onClick: onClick },
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': 'true' },
	        '\xD7'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      )
	    );
	  };
	
	  return CloseButton;
	}(_react2.default.Component);
	
	CloseButton.propTypes = propTypes;
	CloseButton.defaultProps = defaultProps;
	
	exports.default = CloseButton;
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _fadeStyles;
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(159);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  appear: _propTypes2.default.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false
	};
	
	var fadeStyles = (_fadeStyles = {}, _fadeStyles[_Transition.ENTERING] = 'in', _fadeStyles[_Transition.ENTERED] = 'in', _fadeStyles);
	
	var Fade = function (_React$Component) {
	  (0, _inherits3.default)(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3.default)(this, Fade);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	
	    return _react2.default.createElement(
	      _Transition2.default,
	      props,
	      function (status, innerProps) {
	        return _react2.default.cloneElement(children, (0, _extends3.default)({}, innerProps, {
	          className: (0, _classnames2.default)('fade', className, children.props.className, fadeStyles[status])
	        }));
	      }
	    );
	  };
	
	  return Fade;
	}(_react2.default.Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports.default = Fade;
	module.exports = exports['default'];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(308);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(49);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(97);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(152);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(60);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(18);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(143);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(144);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(145);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(146);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(147);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(148);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(13);
	
	var _createChainedFunction = __webpack_require__(87);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(149);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Modal2.default.propTypes, _ModalDialog2.default.propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2.default.oneOf(['static', true, false]),
	
	  /**
	   * Add an optional extra class name to .modal-backdrop
	   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2.default.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * @private
	   */
	  container: _Modal2.default.propTypes.container
	});
	
	var defaultProps = (0, _extends3.default)({}, _Modal2.default.defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2.default
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	/* eslint-disable no-use-before-define, react/no-multi-comp */
	function DialogTransition(props) {
	  return _react2.default.createElement(_Fade2.default, (0, _extends3.default)({}, props, { timeout: Modal.TRANSITION_DURATION }));
	}
	
	function BackdropTransition(props) {
	  return _react2.default.createElement(_Fade2.default, (0, _extends3.default)({}, props, { timeout: Modal.BACKDROP_TRANSITION_DURATION }));
	}
	
	/* eslint-enable no-use-before-define */
	
	var Modal = function (_React$Component) {
	  (0, _inherits3.default)(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3.default)(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	    _this.setModalRef = _this.setModalRef.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.setModalRef = function setModalRef(ref) {
	    this._modal = ref;
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2.default) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2.default)(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2.default)(_reactDom2.default.findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        backdropClassName = _props.backdropClassName,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Modal2.default),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      (0, _extends3.default)({}, baseModalProps, {
	        ref: this.setModalRef,
	        show: show,
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? DialogTransition : undefined,
	        backdrop: backdrop,
	        backdropTransition: animation ? BackdropTransition : undefined,
	        backdropClassName: (0, _classnames2.default)((0, _bootstrapUtils.prefix)(props, 'backdrop'), backdropClassName, inClassName),
	        onEntering: (0, _createChainedFunction2.default)(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2.default)(onExited, this.handleExited)
	      }),
	      _react2.default.createElement(
	        Dialog,
	        (0, _extends3.default)({}, dialogProps, {
	          style: (0, _extends3.default)({}, this.state.style, style),
	          className: (0, _classnames2.default)(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2.default;
	Modal.Header = _ModalHeader2.default;
	Modal.Title = _ModalTitle2.default;
	Modal.Footer = _ModalFooter2.default;
	
	Modal.Dialog = _ModalDialog2.default;
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(18);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3.default)(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3.default)(this, ModalBody);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, { className: (0, _classnames2.default)(className, classes) }));
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(8);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(13);
	
	var _StyleConfig = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2.default.string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3.default)(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3.default)(this, ModalDialog);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4.default)({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2.default)(className, bsClassName)
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(dialogClassName, dialogClasses) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2.default.Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(18);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3.default)(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3.default)(this, ModalFooter);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, { className: (0, _classnames2.default)(className, classes) }));
	  };
	
	  return ModalFooter;
	}(_react2.default.Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(13);
	
	var _createChainedFunction = __webpack_require__(87);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _CloseButton = __webpack_require__(77);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * Provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  closeLabel: _propTypes2.default.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2.default.func
	};
	
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3.default)(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3.default)(this, ModalHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        closeLabel = _props.closeLabel,
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, { className: (0, _classnames2.default)(className, classes) }),
	      closeButton && _react2.default.createElement(_CloseButton2.default, {
	        label: closeLabel,
	        onClick: (0, _createChainedFunction2.default)(modal && modal.onHide, onHide)
	      }),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2.default.Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(10);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(18);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3.default)(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3.default)(this, ModalTitle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, { className: (0, _classnames2.default)(className, classes) }));
	  };
	
	  return ModalTitle;
	}(_react2.default.Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(194);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports.default = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ }),

/***/ 4387:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withContentRect = __webpack_require__(714);
	
	var _withContentRect2 = _interopRequireDefault(_withContentRect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Measure(_ref) {
	  var measure = _ref.measure,
	      measureRef = _ref.measureRef,
	      contentRect = _ref.contentRect,
	      children = _ref.children;
	
	  return children({ measure: measure, measureRef: measureRef, contentRect: contentRect });
	}
	
	exports.default = (0, _withContentRect2.default)()(Measure);
	module.exports = exports['default'];

/***/ }),

/***/ 4388:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function getContentRect(node, types) {
	  var calculations = {};
	
	  if (types.indexOf('client') > -1) {
	    calculations.client = {
	      top: node.clientTop,
	      left: node.clientLeft,
	      width: node.clientWidth,
	      height: node.clientHeight
	    };
	  }
	
	  if (types.indexOf('offset') > -1) {
	    calculations.offset = {
	      top: node.offsetTop,
	      left: node.offsetLeft,
	      width: node.offsetWidth,
	      height: node.offsetHeight
	    };
	  }
	
	  if (types.indexOf('scroll') > -1) {
	    calculations.scroll = {
	      top: node.scrollTop,
	      left: node.scrollLeft,
	      width: node.scrollWidth,
	      height: node.scrollHeight
	    };
	  }
	
	  if (types.indexOf('bounds') > -1) {
	    var rect = node.getBoundingClientRect();
	    calculations.bounds = {
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left,
	      width: rect.width,
	      height: rect.height
	    };
	  }
	
	  if (types.indexOf('margin') > -1) {
	    var styles = getComputedStyle(node);
	    calculations.margin = {
	      top: parseInt(styles.marginTop),
	      right: parseInt(styles.marginRight),
	      bottom: parseInt(styles.marginBottom),
	      left: parseInt(styles.marginLeft)
	    };
	  }
	
	  return calculations;
	}
	
	exports.default = getContentRect;
	module.exports = exports['default'];

/***/ }),

/***/ 4389:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTypes;
	var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];
	
	function getTypes(props) {
	  var allowedTypes = [];
	  types.forEach(function (type) {
	    if (props[type]) {
	      allowedTypes.push(type);
	    }
	  });
	  return allowedTypes;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 4390:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withContentRect = exports.default = undefined;
	
	var _Measure = __webpack_require__(4387);
	
	var _Measure2 = _interopRequireDefault(_Measure);
	
	var _withContentRect = __webpack_require__(714);
	
	var _withContentRect2 = _interopRequireDefault(_withContentRect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Measure2.default;
	exports.withContentRect = _withContentRect2.default;

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(4457);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _getTypes = __webpack_require__(4389);
	
	var _getTypes2 = _interopRequireDefault(_getTypes);
	
	var _getContentRect = __webpack_require__(4388);
	
	var _getContentRect2 = _interopRequireDefault(_getContentRect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withContentRect(types) {
	  return function (WrappedComponent) {
	    var _class, _temp2;
	
	    return _temp2 = _class = function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          contentRect: {
	            entry: {},
	            client: {},
	            offset: {},
	            scroll: {},
	            bounds: {},
	            margin: {}
	          }
	        }, _this.measure = function (entries) {
	          var contentRect = (0, _getContentRect2.default)(_this._node, types || (0, _getTypes2.default)(_this.props));
	
	          if (entries) {
	            contentRect.entry = entries[0].contentRect;
	          }
	
	          _this.setState({ contentRect: contentRect });
	
	          if (typeof _this.props.onResize === 'function') {
	            _this.props.onResize(contentRect);
	          }
	        }, _this._handleRef = function (node) {
	          if (_this._resizeObserver) {
	            if (node) {
	              _this._resizeObserver.observe(node);
	            } else {
	              _this._resizeObserver.disconnect(_this._node);
	            }
	          }
	          _this._node = node;
	
	          if (typeof _this.props.innerRef === 'function') {
	            _this.props.innerRef(node);
	          }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(_class, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          this._resizeObserver = new _resizeObserverPolyfill2.default(this.measure);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              innerRef = _props.innerRef,
	              onResize = _props.onResize,
	              props = _objectWithoutProperties(_props, ['innerRef', 'onResize']);
	
	          return (0, _react.createElement)(WrappedComponent, _extends({}, props, {
	            measureRef: this._handleRef,
	            measure: this.measure,
	            contentRect: this.state.contentRect
	          }));
	        }
	      }]);
	
	      return _class;
	    }(_react.Component), _class.propTypes = {
	      client: _propTypes2.default.bool,
	      offset: _propTypes2.default.bool,
	      scroll: _propTypes2.default.bool,
	      bounds: _propTypes2.default.bool,
	      margin: _propTypes2.default.bool,
	      innerRef: _propTypes2.default.func,
	      onResize: _propTypes2.default.func,
	      children: _propTypes2.default.func
	    }, _temp2;
	  };
	}
	
	exports.default = withContentRect;
	module.exports = exports['default'];

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function noop() {}
	
	var MonacoDiffEditor = function (_React$Component) {
	  _inherits(MonacoDiffEditor, _React$Component);
	
	  function MonacoDiffEditor(props) {
	    _classCallCheck(this, MonacoDiffEditor);
	
	    var _this = _possibleConstructorReturn(this, (MonacoDiffEditor.__proto__ || Object.getPrototypeOf(MonacoDiffEditor)).call(this, props));
	
	    _this.assignRef = function (component) {
	      _this.containerElement = component;
	    };
	
	    _this.containerElement = undefined;
	    _this.__current_value = props.value;
	    _this.__current_original = props.original;
	    return _this;
	  }
	
	  _createClass(MonacoDiffEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.afterViewInit();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var context = this.props.context || window;
	      if (this.props.value !== this.__current_value || this.props.original !== this.__current_original) {
	        // Always refer to the latest value
	        this.__current_value = this.props.value;
	        this.__current_original = this.props.original;
	        // Consider the situation of rendering 1+ times before the editor mounted
	        if (this.editor) {
	          this.__prevent_trigger_change_event = true;
	          this.updateModel(this.__current_value, this.__current_original);
	          this.__prevent_trigger_change_event = false;
	        }
	      }
	      if (prevProps.language !== this.props.language) {
	        context.monaco.editor.setModelLanguage(this.editor.getModel(), this.props.language);
	      }
	      if (prevProps.theme !== this.props.theme) {
	        context.monaco.editor.setTheme(this.props.theme);
	      }
	      if (this.editor && (this.props.width !== prevProps.width || this.props.height !== prevProps.height)) {
	        this.editor.layout();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.destroyMonaco();
	    }
	  }, {
	    key: 'editorWillMount',
	    value: function editorWillMount(monaco) {
	      var editorWillMount = this.props.editorWillMount;
	
	      editorWillMount(monaco);
	    }
	  }, {
	    key: 'editorDidMount',
	    value: function editorDidMount(editor, monaco) {
	      var _this2 = this;
	
	      this.props.editorDidMount(editor, monaco);
	      editor.onDidUpdateDiff(function (event) {
	        var value = editor.getValue();
	
	        // Always refer to the latest value
	        _this2.__current_value = value;
	
	        // Only invoking when user input changed
	        if (!_this2.__prevent_trigger_change_event) {
	          _this2.props.onChange(value, event);
	        }
	      });
	    }
	  }, {
	    key: 'afterViewInit',
	    value: function afterViewInit() {
	      var _this3 = this;
	
	      var context = this.props.context || window;
	      if (context.monaco !== undefined) {
	        this.initMonaco();
	        return;
	      }
	      var requireConfig = this.props.requireConfig;
	
	      var loaderUrl = requireConfig.url || 'vs/loader.js';
	      var onGotAmdLoader = function onGotAmdLoader() {
	        if (context.__REACT_MONACO_EDITOR_LOADER_ISPENDING__) {
	          // Do not use webpack
	          if (requireConfig.paths && requireConfig.paths.vs) {
	            context.require.config(requireConfig);
	          }
	        }
	
	        // Load monaco
	        context.require(['vs/editor/editor.main'], function () {
	          _this3.initMonaco();
	        });
	
	        // Call the delayed callbacks when AMD loader has been loaded
	        if (context.__REACT_MONACO_EDITOR_LOADER_ISPENDING__) {
	          context.__REACT_MONACO_EDITOR_LOADER_ISPENDING__ = false;
	          var loaderCallbacks = context.__REACT_MONACO_EDITOR_LOADER_CALLBACKS__;
	          if (loaderCallbacks && loaderCallbacks.length) {
	            var currentCallback = loaderCallbacks.shift();
	            while (currentCallback) {
	              currentCallback.fn.call(currentCallback.context);
	              currentCallback = loaderCallbacks.shift();
	            }
	          }
	        }
	      };
	
	      // Load AMD loader if necessary
	      if (context.__REACT_MONACO_EDITOR_LOADER_ISPENDING__) {
	        // We need to avoid loading multiple loader.js when there are multiple editors loading
	        // concurrently, delay to call callbacks except the first one
	        // eslint-disable-next-line max-len
	        context.__REACT_MONACO_EDITOR_LOADER_CALLBACKS__ = context.__REACT_MONACO_EDITOR_LOADER_CALLBACKS__ || [];
	        context.__REACT_MONACO_EDITOR_LOADER_CALLBACKS__.push({
	          context: this,
	          fn: onGotAmdLoader
	        });
	      } else if (typeof context.require === 'undefined') {
	        var loaderScript = context.document.createElement('script');
	        loaderScript.type = 'text/javascript';
	        loaderScript.src = loaderUrl;
	        loaderScript.addEventListener('load', onGotAmdLoader);
	        context.document.body.appendChild(loaderScript);
	        context.__REACT_MONACO_EDITOR_LOADER_ISPENDING__ = true;
	      } else {
	        onGotAmdLoader();
	      }
	    }
	  }, {
	    key: 'updateModel',
	    value: function updateModel(value, original) {
	      var context = this.props.context || window;
	      var language = this.props.language;
	
	      var originalModel = context.monaco.editor.createModel(original, language);
	      var modifiedModel = context.monaco.editor.createModel(value, language);
	      this.editor.setModel({
	        original: originalModel,
	        modified: modifiedModel
	      });
	    }
	  }, {
	    key: 'initMonaco',
	    value: function initMonaco() {
	      var value = this.props.value !== null ? this.props.value : this.props.defaultValue;
	      var _props = this.props,
	          original = _props.original,
	          theme = _props.theme,
	          options = _props.options;
	
	      var context = this.props.context || window;
	      if (this.containerElement && typeof context.monaco !== 'undefined') {
	        // Before initializing monaco editor
	        this.editorWillMount(context.monaco);
	        this.editor = context.monaco.editor.createDiffEditor(this.containerElement, options);
	        if (theme) {
	          context.monaco.editor.setTheme(theme);
	        }
	        // After initializing monaco editor
	        this.updateModel(value, original);
	        this.editorDidMount(this.editor, context.monaco);
	      }
	    }
	  }, {
	    key: 'destroyMonaco',
	    value: function destroyMonaco() {
	      if (typeof this.editor !== 'undefined') {
	        this.editor.dispose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height;
	
	      var fixedWidth = width.toString().indexOf('%') !== -1 ? width : width + 'px';
	      var fixedHeight = height.toString().indexOf('%') !== -1 ? height : height + 'px';
	      var style = {
	        width: fixedWidth,
	        height: fixedHeight
	      };
	
	      return _react2.default.createElement('div', { ref: this.assignRef, style: style, className: 'react-monaco-editor-container' });
	    }
	  }]);
	
	  return MonacoDiffEditor;
	}(_react2.default.Component);
	
	MonacoDiffEditor.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  original: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	  defaultValue: _propTypes2.default.string,
	  language: _propTypes2.default.string,
	  theme: _propTypes2.default.string,
	  options: _propTypes2.default.object,
	  editorDidMount: _propTypes2.default.func,
	  editorWillMount: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  requireConfig: _propTypes2.default.object,
	  context: _propTypes2.default.object // eslint-disable-line react/require-default-props
	};
	
	MonacoDiffEditor.defaultProps = {
	  width: '100%',
	  height: '100%',
	  original: null,
	  value: null,
	  defaultValue: '',
	  language: 'javascript',
	  theme: null,
	  options: {},
	  editorDidMount: noop,
	  editorWillMount: noop,
	  onChange: noop,
	  requireConfig: {}
	};
	
	exports.default = MonacoDiffEditor;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function noop() {}
	
	var MonacoEditor = function (_React$Component) {
	  _inherits(MonacoEditor, _React$Component);
	
	  function MonacoEditor(props) {
	    _classCallCheck(this, MonacoEditor);
	
	    var _this = _possibleConstructorReturn(this, (MonacoEditor.__proto__ || Object.getPrototypeOf(MonacoEditor)).call(this, props));
	
	    _this.afterViewInit = function () {
	      var context = _this.props.context || window;
	      if (context.monaco !== undefined) {
	        _this.initMonaco();
	        return;
	      }
	      var requireConfig = _this.props.requireConfig;
	
	      // Checking that the process is a renderer may be overly specific
	
	      var inElectron = context.process && context.process.type === 'renderer';
	
	      var loaderUrl = requireConfig.url || 'vs/loader.js';
	
	      if (inElectron) {
	        // Running in electron, need to deal with the difference between node require and AMDRequire
	        // Save a reference to node's require to set back up later
	        context.electronNodeRequire = context.require;
	        loaderUrl = requireConfig.url || '../node_modules/monaco-editor/min/vs/loader.js';
	      }
	
	      var onGotAmdLoader = function onGotAmdLoader() {
	        if (context.__REACT_MONACO_EDITOR_LOADER_ISPENDING__) {
	          // Do not use webpack
	          if (inElectron) {
	            // Have just loaded loader.js and now context.require is not node's require
	            var amdRequireBaseUrl = requireConfig.baseUrl;
	
	            if (!amdRequireBaseUrl) {
	              var path = context.electronNodeRequire('path');
	              var monacoPath = path.join(context.__dirname, '../node_modules/monaco-editor/min');
	
	              amdRequireBaseUrl = path.resolve(monacoPath).replace(/\\/g, '/');
	              if (amdRequireBaseUrl.length > 0 && amdRequireBaseUrl.charAt(0) !== '/') {
	                amdRequireBaseUrl = '/' + amdRequireBaseUrl;
	              }
	              amdRequireBaseUrl = encodeURI('file://' + amdRequireBaseUrl);
	            }
	
	            context.require.config({
	              baseUrl: amdRequireBaseUrl
	            });
	
	            context.window.module = undefined;
	            // workaround monaco-typescript not understanding the environment
	            context.window.process.browser = true;
	          }
	
	          if (requireConfig.paths && requireConfig.paths.vs && !inElectron) {
	            // will need to switch to nodeRequire here
	            context.require.config(requireConfig);
	          }
	        }
	
	        // Load monaco
	        context.require(['vs/editor/editor.main'], function () {
	          _this.initMonaco();
	        });
	
	        // Call the delayed callbacks when AMD loader has been loaded
	        if (context.__REACT_MONACO_EDITOR_LOADER_ISPENDING__) {
	          context.__REACT_MONACO_EDITOR_LOADER_ISPENDING__ = false;
	          var loaderCallbacks = context.__REACT_MONACO_EDITOR_LOADER_CALLBACKS__;
	
	          if (loaderCallbacks && loaderCallbacks.length) {
	            var currentCallback = loaderCallbacks.shift();
	
	            while (currentCallback) {
	              currentCallback.fn.call(currentCallback.context);
	              currentCallback = loaderCallbacks.shift();
	            }
	          }
	        }
	      };
	
	      // Load AMD loader if necessary
	      if (context.__REACT_MONACO_EDITOR_LOADER_ISPENDING__) {
	        // We need to avoid loading multiple loader.js when there are multiple editors loading
	        // concurrently, delay to call callbacks except the first one
	        // eslint-disable-next-line max-len
	        context.__REACT_MONACO_EDITOR_LOADER_CALLBACKS__ = context.__REACT_MONACO_EDITOR_LOADER_CALLBACKS__ || [];
	        context.__REACT_MONACO_EDITOR_LOADER_CALLBACKS__.push({
	          context: _this,
	          fn: onGotAmdLoader
	        });
	      } else if (typeof context.require === 'undefined' || inElectron) {
	        var loaderScript = context.document.createElement('script');
	        loaderScript.type = 'text/javascript';
	        loaderScript.src = loaderUrl;
	        loaderScript.addEventListener('load', onGotAmdLoader);
	        context.document.body.appendChild(loaderScript);
	        context.__REACT_MONACO_EDITOR_LOADER_ISPENDING__ = true;
	      } else {
	        onGotAmdLoader();
	      }
	    };
	
	    _this.assignRef = function (component) {
	      _this.containerElement = component;
	    };
	
	    _this.containerElement = undefined;
	    _this.__current_value = props.value;
	    return _this;
	  }
	
	  _createClass(MonacoEditor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.afterViewInit();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var context = this.props.context || window;
	      if (this.props.value !== this.__current_value) {
	        // Always refer to the latest value
	        this.__current_value = this.props.value;
	        // Consider the situation of rendering 1+ times before the editor mounted
	        if (this.editor) {
	          this.__prevent_trigger_change_event = true;
	          this.editor.setValue(this.__current_value);
	          this.__prevent_trigger_change_event = false;
	        }
	      }
	      if (prevProps.language !== this.props.language) {
	        context.monaco.editor.setModelLanguage(this.editor.getModel(), this.props.language);
	      }
	      if (prevProps.theme !== this.props.theme) {
	        context.monaco.editor.setTheme(this.props.theme);
	      }
	      if (this.editor && (this.props.width !== prevProps.width || this.props.height !== prevProps.height)) {
	        this.editor.layout();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.destroyMonaco();
	    }
	  }, {
	    key: 'editorWillMount',
	    value: function editorWillMount(monaco) {
	      var editorWillMount = this.props.editorWillMount;
	
	      editorWillMount(monaco);
	    }
	  }, {
	    key: 'editorDidMount',
	    value: function editorDidMount(editor, monaco) {
	      var _this2 = this;
	
	      this.props.editorDidMount(editor, monaco);
	      editor.onDidChangeModelContent(function (event) {
	        var value = editor.getValue();
	
	        // Always refer to the latest value
	        _this2.__current_value = value;
	
	        // Only invoking when user input changed
	        if (!_this2.__prevent_trigger_change_event) {
	          _this2.props.onChange(value, event);
	        }
	      });
	    }
	  }, {
	    key: 'initMonaco',
	    value: function initMonaco() {
	      var value = this.props.value !== null ? this.props.value : this.props.defaultValue;
	      var _props = this.props,
	          language = _props.language,
	          theme = _props.theme,
	          options = _props.options;
	
	      var context = this.props.context || window;
	      if (this.containerElement && typeof context.monaco !== 'undefined') {
	        // Before initializing monaco editor
	        this.editorWillMount(context.monaco);
	        this.editor = context.monaco.editor.create(this.containerElement, _extends({
	          value: value,
	          language: language
	        }, options));
	        if (theme) {
	          context.monaco.editor.setTheme(theme);
	        }
	        // After initializing monaco editor
	        this.editorDidMount(this.editor, context.monaco);
	      }
	    }
	  }, {
	    key: 'destroyMonaco',
	    value: function destroyMonaco() {
	      if (typeof this.editor !== 'undefined') {
	        this.editor.dispose();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height;
	
	      var fixedWidth = width.toString().indexOf('%') !== -1 ? width : width + 'px';
	      var fixedHeight = height.toString().indexOf('%') !== -1 ? height : height + 'px';
	      var style = {
	        width: fixedWidth,
	        height: fixedHeight
	      };
	
	      return _react2.default.createElement('div', { ref: this.assignRef, style: style, className: 'react-monaco-editor-container' });
	    }
	  }]);
	
	  return MonacoEditor;
	}(_react2.default.Component);
	
	MonacoEditor.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  value: _propTypes2.default.string,
	  defaultValue: _propTypes2.default.string,
	  language: _propTypes2.default.string,
	  theme: _propTypes2.default.string,
	  options: _propTypes2.default.object,
	  editorDidMount: _propTypes2.default.func,
	  editorWillMount: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  requireConfig: _propTypes2.default.object,
	  context: _propTypes2.default.object // eslint-disable-line react/require-default-props
	};
	
	MonacoEditor.defaultProps = {
	  width: '100%',
	  height: '100%',
	  value: null,
	  defaultValue: '',
	  language: 'javascript',
	  theme: null,
	  options: {},
	  editorDidMount: noop,
	  editorWillMount: noop,
	  onChange: noop,
	  requireConfig: {}
	};
	
	exports.default = MonacoEditor;

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MonacoDiffEditor = exports.default = undefined;
	
	var _editor = __webpack_require__(493);
	
	var _editor2 = _interopRequireDefault(_editor);
	
	var _diff = __webpack_require__(492);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _editor2.default;
	exports.MonacoDiffEditor = _diff2.default;

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(36);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(38);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(39);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	
	        var initialRender = !_this._overlayInstance;
	
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
	          if (initialRender && _this.props.onRendered) {
	            _this.props.onRendered();
	          }
	        });
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(306);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(213);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(35);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(36);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(141);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(18);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ModalManager = __webpack_require__(153);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Portal = __webpack_require__(154);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _RefHolder = __webpack_require__(155);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _addEventListener = __webpack_require__(156);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(157);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(38);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(39);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          appear: true,
	          unmountOnExit: true,
	          'in': show,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container,
	        onRendered: this.onPortalRendered
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNodeRef,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        _react2.default.createElement(
	          _RefHolder2.default,
	          { ref: this.setDialogRef },
	          dialog
	        )
	      )
	    );
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  Modal.prototype.autoFocus = function autoFocus() {
	    if (!this.props.autoFocus) {
	      return;
	    }
	
	    var dialogElement = this.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      this.lastFocus = currentActiveElement;
	
	      if (!dialogElement.hasAttribute('tabIndex')) {
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
	
	        dialogElement.setAttribute('tabIndex', -1);
	      }
	
	      dialogElement.focus();
	    }
	  };
	
	  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  };
	
	  Modal.prototype.getDialogElement = function getDialogElement() {
	    return _reactDom2.default.findDOMNode(this.dialog);
	  };
	
	  Modal.prototype.isTopModal = function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the dialog component.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the backdrop components.
	   */
	  backdropTransition: _elementType2.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.backdropTransition;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        {
	          appear: true,
	          'in': _this2.props.show
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onPortalRendered = function () {
	    _this2.autoFocus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNodeRef = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.setDialogRef = function (ref) {
	    _this2.dialog = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.enforceFocus = function () {
	    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var dialogElement = _this2.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      dialogElement.focus();
	    }
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(307);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(309);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(97);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(60);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(36);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(38);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(39);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _LegacyPortal = __webpack_require__(151);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	
	      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
	    }, _this.getMountNode = function () {
	      return _this._portalContainerNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this.setContainer();
	    this.forceUpdate(this.props.onRendered);
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.container !== this.props.container) {
	      this.setContainer(nextProps);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._portalContainerNode = null;
	  };
	
	  Portal.prototype.render = function render() {
	    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.node
	};
	
	/**
	 * Internal helper component to allow attaching a non-conflicting ref to a
	 * child element that may not accept refs.
	 */
	
	var RefHolder = function (_React$Component) {
	  _inherits(RefHolder, _React$Component);
	
	  function RefHolder() {
	    _classCallCheck(this, RefHolder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RefHolder.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes = propTypes;
	
	exports.default = RefHolder;
	module.exports = exports['default'];

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(133);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(132);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(175);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(49);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(49);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(196);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/////////////////////////////////////////////////////////
	// Browser Utils
	//
	/////////////////////////////////////////////////////////
	var Browser = function () {
	  function Browser() {
	    (0, _classCallCheck3.default)(this, Browser);
	  }
	
	  (0, _createClass3.default)(Browser, null, [{
	    key: 'isBrowser',
	
	
	    // Check if not running on server
	    value: function isBrowser() {
	      return typeof window !== 'undefined';
	    }
	
	    // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
	
	  }, {
	    key: 'isOpera',
	    value: function isOpera() {
	      return Browser.isBrowser() && (!!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0);
	    }
	
	    // Firefox 1.0+
	
	  }, {
	    key: 'isFirefox',
	    value: function isFirefox() {
	      return Browser.isBrowser() && typeof InstallTrigger !== 'undefined';
	    }
	
	    // Safari 3.0+
	
	  }, {
	    key: 'isSafari',
	    value: function isSafari() {
	
	      if (!Browser.isBrowser()) {
	        return false;
	      }
	
	      return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
	      );
	    }
	
	    // Internet Explorer 6-11
	
	  }, {
	    key: 'isIE',
	    value: function isIE() {
	      /*@cc_on!@*/
	      return Browser.isBrowser() && !!document.documentMode;
	    }
	
	    // Edge 20+
	
	  }, {
	    key: 'isEdge',
	    value: function isEdge() {
	      return Browser.isBrowser() && !Browser.isIE() && !!window.StyleMedia;
	    }
	
	    // Chrome 1+
	
	  }, {
	    key: 'isChrome',
	    value: function isChrome() {
	      return Browser.isBrowser() && !!window.chrome && !!window.chrome.webstore;
	    }
	
	    // Blink engine detection
	
	  }, {
	    key: 'isBlink',
	    value: function isBlink() {
	      return Browser.isBrowser() && (Browser.isChrome() || Browser.isOpera()) && !!window.CSS;
	    }
	  }, {
	    key: 'getUserAgent',
	    value: function getUserAgent() {
	      return typeof navigator === 'undefined' ? '' : navigator.userAgent;
	    }
	  }, {
	    key: 'isAndroid',
	    value: function isAndroid() {
	      return Browser.isBrowser() && Browser.getUserAgent().match(/Android/i);
	    }
	  }, {
	    key: 'isBlackBerry',
	    value: function isBlackBerry() {
	      return Browser.isBrowser() && Browser.getUserAgent().match(/BlackBerry/i);
	    }
	  }, {
	    key: 'isIOS',
	    value: function isIOS() {
	      return Browser.isBrowser() && Browser.getUserAgent().match(/iPhone|iPad|iPod/i);
	    }
	  }, {
	    key: 'isOpera',
	    value: function isOpera() {
	      return Browser.isBrowser() && Browser.getUserAgent().match(/Opera Mini/i);
	    }
	  }, {
	    key: 'isWindows',
	    value: function isWindows() {
	      return Browser.isBrowser() && Browser.isWindowsDesktop() || Browser.isWindowsMobile();
	    }
	  }, {
	    key: 'isWindowsMobile',
	    value: function isWindowsMobile() {
	      return Browser.isBrowser() && Browser.getUserAgent().match(/IEMobile/i);
	    }
	  }, {
	    key: 'isWindowsDesktop',
	    value: function isWindowsDesktop() {
	      return Browser.isBrowser() && Browser.getUserAgent().match(/WPDesktop/i);
	    }
	  }, {
	    key: 'isMobile',
	    value: function isMobile() {
	
	      return Browser.isBrowser() && (Browser.isWindowsMobile() || Browser.isBlackBerry() || Browser.isAndroid() || Browser.isIOS());
	    }
	  }]);
	  return Browser;
	}();
	
	exports.default = Browser;

/***/ }),

/***/ 4403:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(378);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _sign = __webpack_require__(955);
	
	var _sign2 = _interopRequireDefault(_sign);
	
	var _assign = __webpack_require__(376);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _promise = __webpack_require__(545);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(377);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(196);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ReflexSplitter = __webpack_require__(721);
	
	var _ReflexSplitter2 = _interopRequireDefault(_ReflexSplitter);
	
	var _ReflexElement = __webpack_require__(720);
	
	var _ReflexElement2 = _interopRequireDefault(_ReflexElement);
	
	var _ReflexEvents = __webpack_require__(4404);
	
	var _ReflexEvents2 = _interopRequireDefault(_ReflexEvents);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	///////////////////////////////////////////////////////////
	// ReflexContainer
	// By Philippe Leefsma
	// December 2016
	//
	///////////////////////////////////////////////////////////
	var ReflexContainer = function (_React$Component) {
	  (0, _inherits3.default)(ReflexContainer, _React$Component);
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	  function ReflexContainer(props) {
	    (0, _classCallCheck3.default)(this, ReflexContainer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ReflexContainer.__proto__ || (0, _getPrototypeOf2.default)(ReflexContainer)).call(this, props));
	
	    _this.state = {
	      flexData: []
	    };
	
	    _this.events = new _ReflexEvents2.default();
	
	    _this.onSplitterStartResize = _this.onSplitterStartResize.bind(_this);
	
	    _this.onSplitterStopResize = _this.onSplitterStopResize.bind(_this);
	
	    _this.onSplitterResize = _this.onSplitterResize.bind(_this);
	
	    _this.onElementSize = _this.onElementSize.bind(_this);
	
	    _this.children = [];
	    return _this;
	  }
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	
	
	  (0, _createClass3.default)(ReflexContainer, [{
	    key: 'setPartialState',
	    value: function setPartialState(partialState) {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve) {
	
	        _this2.setState((0, _assign2.default)({}, _this2.state, partialState), function () {
	          resolve();
	        });
	      });
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var flexData = this.computeFlexData();
	
	      this.setPartialState({
	        flexData: flexData
	      });
	
	      this.events.on('splitter.startResize', this.onSplitterStartResize);
	
	      this.events.on('splitter.stopResize', this.onSplitterStopResize);
	
	      this.events.on('splitter.resize', this.onSplitterResize);
	
	      this.events.on('element.size', this.onElementSize);
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	
	      this.events.off();
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'getValidChildren',
	    value: function getValidChildren() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	
	      return this.toArray(props.children).filter(function (child) {
	
	        return !!child;
	      });
	    }
	
	    /////////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////////
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	
	      var children = this.getValidChildren(props);
	
	      if (children.length !== this.state.flexData.length || this.flexHasChanged(props)) {
	
	        var flexData = this.computeFlexData(children);
	
	        this.setPartialState({
	          flexData: flexData
	        });
	      }
	    }
	
	    /////////////////////////////////////////////////////////
	    // Check if flex has changed: this allows updating the
	    // component when different flex is passed as property
	    // to one or several children
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'flexHasChanged',
	    value: function flexHasChanged(props) {
	
	      var nextChildrenFlex = this.getValidChildren(props).map(function (child) {
	
	        return child.props.flex || 0;
	      });
	
	      var childrenFlex = this.getValidChildren().map(function (child) {
	
	        return child.props.flex || 0;
	      });
	
	      return !childrenFlex.every(function (flex, idx) {
	
	        return flex === nextChildrenFlex[idx];
	      });
	    }
	
	    /////////////////////////////////////////////////////////
	    // Returns size of a ReflexElement
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'getSize',
	    value: function getSize(element) {
	
	      var ref = element.ref ? this.refs[element.ref] : element;
	
	      var domElement = _reactDom2.default.findDOMNode(ref);
	
	      switch (this.props.orientation) {
	
	        case 'horizontal':
	          return domElement.offsetHeight;
	
	        case 'vertical':
	        default:
	          return domElement.offsetWidth;
	      }
	    }
	
	    /////////////////////////////////////////////////////////
	    // Computes offset from pointer position
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'getOffset',
	    value: function getOffset(event) {
	
	      var pos = event.changedTouches ? event.changedTouches[0] : event;
	
	      switch (this.props.orientation) {
	
	        case 'horizontal':
	          return pos.pageY - this.previousPos;
	
	        case 'vertical':
	        default:
	          return pos.pageX - this.previousPos;
	      }
	    }
	
	    /////////////////////////////////////////////////////////
	    // Handles splitter startResize event
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'onSplitterStartResize',
	    value: function onSplitterStartResize(data) {
	
	      var pos = data.event.changedTouches ? data.event.changedTouches[0] : data.event;
	
	      switch (this.props.orientation) {
	
	        case 'horizontal':
	          document.body.style.cursor = 'row-resize';
	          this.previousPos = pos.pageY;
	          break;
	
	        case 'vertical':
	        default:
	          document.body.style.cursor = 'col-resize';
	          this.previousPos = pos.pageX;
	          break;
	      }
	
	      var idx = data.splitter.props.index;
	
	      this.elements = [this.children[idx - 1], this.children[idx + 1]];
	
	      this.emitElementsEvent(this.elements, 'onStartResize');
	    }
	
	    /////////////////////////////////////////////////////////
	    // Handles splitter resize event
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'onSplitterResize',
	    value: function onSplitterResize(data) {
	      var _this3 = this;
	
	      var idx = data.splitter.props.index;
	
	      var offset = this.getOffset(data.event);
	
	      var availableOffset = this.computeAvailableOffset(idx, offset);
	
	      if (availableOffset) {
	
	        var pos = data.event.changedTouches ? data.event.changedTouches[0] : data.event;
	
	        switch (this.props.orientation) {
	
	          case 'horizontal':
	            this.previousPos = pos.pageY;
	            break;
	
	          case 'vertical':
	          default:
	            this.previousPos = pos.pageX;
	            break;
	        }
	
	        this.elements = this.dispatchOffset(idx, availableOffset);
	
	        this.adjustFlex(this.elements);
	
	        this.setPartialState(this.state).then(function () {
	
	          _this3.emitElementsEvent(_this3.elements, 'onResize');
	        });
	      }
	    }
	
	    /////////////////////////////////////////////////////////
	    // Determines if element is a splitter
	    // or wraps a splitter
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'isSplitterElement',
	    value: function isSplitterElement(element) {
	
	      return element.type === _ReflexSplitter2.default;
	    }
	
	    /////////////////////////////////////////////////////////
	    // Handles splitter stopResize event
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'onSplitterStopResize',
	    value: function onSplitterStopResize(data) {
	      var _this4 = this;
	
	      document.body.style.cursor = 'auto';
	
	      var resizedRefs = this.elements.map(function (element) {
	
	        return element.ref;
	      });
	
	      var elements = this.children.filter(function (child) {
	
	        return !_this4.isSplitterElement(child) && resizedRefs.includes(child.ref);
	      });
	
	      this.emitElementsEvent(elements, 'onStopResize');
	    }
	
	    /////////////////////////////////////////////////////////
	    // Handles element size modified event
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'onElementSize',
	    value: function onElementSize(data) {
	      var _this5 = this;
	
	      return new _promise2.default(function (resolve) {
	
	        try {
	
	          var idx = data.element.props.index;
	
	          var size = _this5.getSize(_this5.children[idx]);
	
	          var offset = data.size - size;
	
	          var dir = data.direction;
	
	          var splitterIdx = idx + dir;
	
	          var availableOffset = _this5.computeAvailableOffset(splitterIdx, dir * offset);
	
	          _this5.elements = null;
	
	          if (availableOffset) {
	
	            _this5.elements = _this5.dispatchOffset(splitterIdx, availableOffset);
	
	            _this5.adjustFlex(_this5.elements);
	          }
	
	          _this5.setPartialState(_this5.state).then(function () {
	
	            _this5.emitElementsEvent(_this5.elements, 'onResize');
	
	            resolve();
	          });
	        } catch (ex) {
	
	          // TODO handle exception ...
	        }
	      });
	    }
	
	    /////////////////////////////////////////////////////////
	    // Adjusts flex after a dispatch to make sure
	    // total flex of modified elements remains the same
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'adjustFlex',
	    value: function adjustFlex(elements) {
	      var _this6 = this;
	
	      var diffFlex = elements.reduce(function (sum, element) {
	
	        var idx = element.props.index;
	
	        var previousFlex = element.props.flex;
	
	        var nextFlex = _this6.state.flexData[idx].flex;
	
	        return sum + (previousFlex - nextFlex) / elements.length;
	      }, 0);
	
	      elements.forEach(function (element) {
	        _this6.state.flexData[element.props.index].flex += diffFlex;
	      });
	    }
	
	    /////////////////////////////////////////////////////////
	    // Returns available offset for a given raw offset value
	    // This checks how much the panes can be stretched and
	    // shrink, then returns the min
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'computeAvailableOffset',
	    value: function computeAvailableOffset(idx, offset) {
	
	      var stretch = this.computeAvailableStretch(idx, offset);
	
	      var shrink = this.computeAvailableShrink(idx, offset);
	
	      var availableOffset = Math.min(stretch, shrink) * (0, _sign2.default)(offset);
	
	      return availableOffset;
	    }
	
	    /////////////////////////////////////////////////////////
	    // Returns true if the next splitter than the one at idx
	    // can propagate the drag. This can happen if that
	    // next element is actually a splitter and it has
	    // propagate=true property set
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'checkPropagate',
	    value: function checkPropagate(idx, direction) {
	
	      if (direction > 0) {
	
	        if (idx < this.children.length - 2) {
	
	          var child = this.children[idx + 2];
	
	          var typeCheck = this.isSplitterElement(child);
	
	          return typeCheck && child.props.propagate;
	        }
	      } else {
	
	        if (idx > 2) {
	
	          var _child = this.children[idx - 2];
	
	          var _typeCheck = this.isSplitterElement(_child);
	
	          return _typeCheck && _child.props.propagate;
	        }
	      }
	
	      return false;
	    }
	
	    /////////////////////////////////////////////////////////
	    // Recursively computes available stretch at splitter
	    // idx for given raw offset
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'computeAvailableStretch',
	    value: function computeAvailableStretch(idx, offset) {
	
	      var childIdx = offset < 0 ? idx + 1 : idx - 1;
	
	      var child = this.children[childIdx];
	
	      var size = this.getSize(child);
	
	      var maxSize = child.props.maxSize;
	
	      var availableStretch = maxSize - size;
	
	      if (availableStretch < Math.abs(offset)) {
	
	        if (this.checkPropagate(idx, -1 * offset)) {
	
	          var nextOffset = (0, _sign2.default)(offset) * (Math.abs(offset) - availableStretch);
	
	          return availableStretch + this.computeAvailableStretch(offset < 0 ? idx + 2 : idx - 2, nextOffset);
	        }
	      }
	
	      return Math.min(availableStretch, Math.abs(offset));
	    }
	
	    /////////////////////////////////////////////////////////
	    // Recursively computes available shrink at splitter
	    // idx for given raw offset
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'computeAvailableShrink',
	    value: function computeAvailableShrink(idx, offset) {
	
	      var childIdx = offset > 0 ? idx + 1 : idx - 1;
	
	      var child = this.children[childIdx];
	
	      var size = this.getSize(child);
	
	      var minSize = Math.max(child.props.minSize, 0);
	
	      var availableShrink = size - minSize;
	
	      if (availableShrink < Math.abs(offset)) {
	
	        if (this.checkPropagate(idx, offset)) {
	
	          var nextOffset = (0, _sign2.default)(offset) * (Math.abs(offset) - availableShrink);
	
	          return availableShrink + this.computeAvailableShrink(offset > 0 ? idx + 2 : idx - 2, nextOffset);
	        }
	      }
	
	      return Math.min(availableShrink, Math.abs(offset));
	    }
	
	    /////////////////////////////////////////////////////////
	    // Returns flex value for unit pixel
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'computePixelFlex',
	    value: function computePixelFlex() {
	
	      var domElement = _reactDom2.default.findDOMNode(this);
	
	      switch (this.props.orientation) {
	
	        case 'horizontal':
	
	          if (domElement.offsetHeight === 0.0) {
	            console.warning('Found ReflexContainer with height=0, ' + 'this will cause invalid behavior...');
	            console.warning(domElement);
	            return 0.0;
	          }
	
	          return 1.0 / domElement.offsetHeight;
	
	        case 'vertical':
	        default:
	
	          if (domElement.offsetWidth === 0.0) {
	            console.warning('Found ReflexContainer with width=0, ' + 'this will cause invalid behavior...');
	            console.warning(domElement);
	            return 0.0;
	          }
	
	          return 1.0 / domElement.offsetWidth;
	      }
	    }
	
	    /////////////////////////////////////////////////////////
	    // Adds offset to a given ReflexElement
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'addOffset',
	    value: function addOffset(element, offset) {
	
	      var size = this.getSize(element);
	
	      var idx = element.props.index;
	
	      var newSize = Math.max(size + offset, 0);
	
	      var currentFlex = this.state.flexData[idx].flex;
	
	      var newFlex = currentFlex > 0 ? currentFlex * newSize / size : this.computePixelFlex() * newSize;
	
	      this.state.flexData[idx].flex = !isFinite(newFlex) || isNaN(newFlex) ? 0 : newFlex;
	    }
	
	    /////////////////////////////////////////////////////////
	    // Recursively dispatches stretch offset across
	    // children elements starting at splitter idx
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'dispatchStretch',
	    value: function dispatchStretch(idx, offset) {
	
	      var childIdx = offset < 0 ? idx + 1 : idx - 1;
	
	      if (childIdx < 0 || childIdx > this.children.length - 1) {
	
	        return [];
	      }
	
	      var child = this.children[childIdx];
	
	      var size = this.getSize(child);
	
	      var newSize = Math.min(child.props.maxSize, size + Math.abs(offset));
	
	      var dispatchedStretch = newSize - size;
	
	      this.addOffset(child, dispatchedStretch);
	
	      if (dispatchedStretch < Math.abs(offset)) {
	
	        var nextIdx = idx - (0, _sign2.default)(offset) * 2;
	
	        var nextOffset = (0, _sign2.default)(offset) * (Math.abs(offset) - dispatchedStretch);
	
	        return [child].concat((0, _toConsumableArray3.default)(this.dispatchStretch(nextIdx, nextOffset)));
	      }
	
	      return [child];
	    }
	
	    /////////////////////////////////////////////////////////
	    // Recursively dispatches shrink offset across
	    // children elements starting at splitter idx
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'dispatchShrink',
	    value: function dispatchShrink(idx, offset) {
	
	      var childIdx = offset > 0 ? idx + 1 : idx - 1;
	
	      if (childIdx < 0 || childIdx > this.children.length - 1) {
	
	        return [];
	      }
	
	      var child = this.children[childIdx];
	
	      var size = this.getSize(child);
	
	      var newSize = Math.max(child.props.minSize, size - Math.abs(offset));
	
	      var dispatchedShrink = newSize - size;
	
	      this.addOffset(child, dispatchedShrink);
	
	      if (Math.abs(dispatchedShrink) < Math.abs(offset)) {
	
	        var nextIdx = idx + (0, _sign2.default)(offset) * 2;
	
	        var nextOffset = (0, _sign2.default)(offset) * (Math.abs(offset) + dispatchedShrink);
	
	        return [child].concat((0, _toConsumableArray3.default)(this.dispatchShrink(nextIdx, nextOffset)));
	      }
	
	      return [child];
	    }
	
	    /////////////////////////////////////////////////////////
	    // Dispatch offset at splitter idx
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'dispatchOffset',
	    value: function dispatchOffset(idx, offset) {
	
	      return [].concat((0, _toConsumableArray3.default)(this.dispatchStretch(idx, offset)), (0, _toConsumableArray3.default)(this.dispatchShrink(idx, offset)));
	    }
	
	    /////////////////////////////////////////////////////////
	    // Emits given if event for each given element
	    // if present in the component props
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'emitElementsEvent',
	    value: function emitElementsEvent(elements, event) {
	      var _this7 = this;
	
	      this.toArray(elements).forEach(function (element) {
	
	        if (element.props[event]) {
	
	          var ref = _this7.refs[element.ref];
	
	          element.props[event]({
	            domElement: _reactDom2.default.findDOMNode(ref),
	            component: element
	          });
	        }
	      });
	    }
	
	    /////////////////////////////////////////////////////////
	    // Computes initial flex data based on provided flex
	    // properties. By default each ReflexElement gets
	    // evenly arranged within its container
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'computeFlexData',
	    value: function computeFlexData() {
	      var _this8 = this;
	
	      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getValidChildren();
	
	
	      var pixelFlex = this.computePixelFlex();
	
	      var computeFreeFlex = function computeFreeFlex(flexData) {
	        return flexData.reduce(function (sum, entry) {
	          if (!_this8.isSplitterElement(entry) && entry.constrained) {
	            return sum - entry.flex;
	          }
	          return sum;
	        }, 1);
	      };
	
	      var computeFreeElements = function computeFreeElements(flexData) {
	        return flexData.reduce(function (sum, entry) {
	          if (!_this8.isSplitterElement(entry) && !entry.constrained) {
	            return sum + 1;
	          }
	          return sum;
	        }, 0);
	      };
	
	      var flexDataInit = children.map(function (child) {
	
	        var props = child.props;
	
	        return {
	          maxFlex: (props.maxSize || Number.MAX_VALUE) * pixelFlex,
	          sizeFlex: (props.size || Number.MAX_VALUE) * pixelFlex,
	          minFlex: (props.minSize || 1) * pixelFlex,
	          constrained: props.flex !== undefined,
	          guid: props.ref || _this8.guid(),
	          flex: props.flex || 0,
	          type: child.type
	        };
	      });
	
	      var computeFlexDataRec = function computeFlexDataRec(flexDataIn) {
	
	        var hasContrain = false;
	
	        var freeElements = computeFreeElements(flexDataIn);
	
	        var freeFlex = computeFreeFlex(flexDataIn);
	
	        var flexDataOut = flexDataIn.map(function (entry) {
	
	          if (_this8.isSplitterElement(entry)) {
	            return entry;
	          }
	
	          var proposedFlex = !entry.constrained ? freeFlex / freeElements : entry.flex;
	
	          var constrainedFlex = Math.min(entry.sizeFlex, Math.min(entry.maxFlex, Math.max(entry.minFlex, proposedFlex)));
	
	          var constrained = constrainedFlex !== proposedFlex;
	
	          hasContrain = hasContrain || constrained;
	
	          return (0, _assign2.default)({}, entry, {
	            flex: constrainedFlex,
	            constrained: constrained
	          });
	        });
	
	        return hasContrain ? computeFlexDataRec(flexDataOut) : flexDataOut;
	      };
	
	      var flexData = computeFlexDataRec(flexDataInit);
	
	      return flexData.map(function (entry) {
	
	        return {
	          flex: !_this8.isSplitterElement(entry) ? entry.flex : 0.0,
	          guid: entry.guid
	        };
	      });
	    }
	
	    /////////////////////////////////////////////////////////
	    // Utility method that generates a new unique GUID
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'guid',
	    value: function guid() {
	      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'xxxx-xxxx';
	
	
	      var d = new Date().getTime();
	
	      return format.replace(/[xy]/g, function (c) {
	        var r = (d + Math.random() * 16) % 16 | 0;
	        d = Math.floor(d / 16);
	        return (c == 'x' ? r : r & 0x7 | 0x8).toString(16);
	      });
	    }
	
	    /////////////////////////////////////////////////////////
	    // Utility method to ensure given argument is
	    // returned as an array
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'toArray',
	    value: function toArray(obj) {
	
	      return obj ? Array.isArray(obj) ? obj : [obj] : [];
	    }
	
	    /////////////////////////////////////////////////////////
	    // Render container. This will clone all original child
	    // components in order to pass some internal properties
	    // used to handle resizing logic
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this9 = this;
	
	      var classNames = ['reflex-layout', 'reflex-container', this.props.orientation].concat((0, _toConsumableArray3.default)(this.props.className.split(' ')));
	
	      this.children = _react2.default.Children.map(this.getValidChildren(), function (child, idx) {
	
	        if (idx > _this9.state.flexData.length - 1) {
	          return _react2.default.createElement('div', null);
	        }
	
	        var flexData = _this9.state.flexData[idx];
	
	        var newProps = (0, _assign2.default)({}, child.props, {
	          maxSize: child.props.maxSize || Number.MAX_VALUE,
	          orientation: _this9.props.orientation,
	          minSize: child.props.minSize || 1,
	          events: _this9.events,
	          flex: flexData.flex,
	          ref: flexData.guid,
	          index: idx
	        });
	
	        return _react2.default.cloneElement(child, newProps);
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' '),
	          style: this.props.style },
	        this.children
	      );
	    }
	  }]);
	  return ReflexContainer;
	}(_react2.default.Component);
	
	/////////////////////////////////////////////////////////
	//
	//
	/////////////////////////////////////////////////////////
	
	
	ReflexContainer.propTypes = {
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	};ReflexContainer.defaultProps = {
	  orientation: 'horizontal',
	  className: '',
	  style: {}
	};
	
	exports.default = ReflexContainer;

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(378);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(376);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(8);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(964);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _getIterator2 = __webpack_require__(14);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _asyncToGenerator2 = __webpack_require__(963);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(377);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(196);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _lodash = __webpack_require__(4198);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactMeasure = __webpack_require__(4390);
	
	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Browser = __webpack_require__(719);
	
	var _Browser2 = _interopRequireDefault(_Browser);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	///////////////////////////////////////////////////////////
	// ReflexElement
	// By Philippe Leefsma
	// December 2016
	//
	///////////////////////////////////////////////////////////
	var ReflexElement = function (_React$Component) {
	  (0, _inherits3.default)(ReflexElement, _React$Component);
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	  function ReflexElement(props) {
	    (0, _classCallCheck3.default)(this, ReflexElement);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ReflexElement.__proto__ || (0, _getPrototypeOf2.default)(ReflexElement)).call(this, props));
	
	    _this.onResize = _this.onResize.bind(_this);
	
	    _this.setStateThrottled = (0, _lodash2.default)(function (state) {
	      _this.setState(state);
	    }, _this.props.renderOnResizeRate);
	
	    _this.state = {
	      dimensions: {
	        height: "100%",
	        width: "100%"
	      }
	    };
	    return _this;
	  }
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	
	
	  (0, _createClass3.default)(ReflexElement, [{
	    key: 'componentWillReceiveProps',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(props) {
	        var directions, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, dir;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                if (!(props.size !== this.props.size)) {
	                  _context.next = 28;
	                  break;
	                }
	
	                directions = this.toArray(props.direction);
	                _iteratorNormalCompletion = true;
	                _didIteratorError = false;
	                _iteratorError = undefined;
	                _context.prev = 5;
	                _iterator = (0, _getIterator3.default)(directions);
	
	              case 7:
	                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                  _context.next = 14;
	                  break;
	                }
	
	                dir = _step.value;
	                _context.next = 11;
	                return this.props.events.emit('element.size', {
	                  size: props.size,
	                  direction: dir,
	                  element: this
	                });
	
	              case 11:
	                _iteratorNormalCompletion = true;
	                _context.next = 7;
	                break;
	
	              case 14:
	                _context.next = 20;
	                break;
	
	              case 16:
	                _context.prev = 16;
	                _context.t0 = _context['catch'](5);
	                _didIteratorError = true;
	                _iteratorError = _context.t0;
	
	              case 20:
	                _context.prev = 20;
	                _context.prev = 21;
	
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	
	              case 23:
	                _context.prev = 23;
	
	                if (!_didIteratorError) {
	                  _context.next = 26;
	                  break;
	                }
	
	                throw _iteratorError;
	
	              case 26:
	                return _context.finish(23);
	
	              case 27:
	                return _context.finish(20);
	
	              case 28:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[5, 16, 20, 28], [21,, 23, 27]]);
	      }));
	
	      function componentWillReceiveProps(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentWillReceiveProps;
	    }()
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'toArray',
	    value: function toArray(obj) {
	
	      return obj ? Array.isArray(obj) ? obj : [obj] : [];
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'onResize',
	    value: function onResize(rect) {
	      var _props = this.props,
	          renderOnResize = _props.renderOnResize,
	          resizeHeight = _props.resizeHeight,
	          resizeWidth = _props.resizeWidth;
	
	
	      if (renderOnResize) {
	
	        this.setStateThrottled({
	          dimensions: (0, _extends3.default)({}, resizeHeight && { height: Math.floor(rect.bounds.height) }, resizeWidth && { width: Math.floor(rect.bounds.width) })
	        });
	      }
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var _this2 = this;
	
	      if (this.props.propagateDimensions) {
	
	        return _react2.default.Children.map(this.props.children, function (child) {
	
	          var newProps = (0, _assign2.default)({}, child.props, {
	            dimensions: _this2.state.dimensions
	          });
	
	          return _react2.default.cloneElement(child, newProps);
	        });
	      }
	
	      return this.props.children;
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var classNames = ['reflex-element'].concat((0, _toConsumableArray3.default)(this.props.className.split(' ')));
	
	      var className = classNames.join(' ');
	
	      var outerStyle = (0, _assign2.default)({}, {
	        WebkitBoxFlex: this.props.flex,
	        FlexElement: this.props.flex,
	        MozBoxFlex: this.props.flex,
	        WebkitFlex: this.props.flex,
	        flex: this.props.flex
	      }, this.props.style);
	
	      var innerStyle = {
	        height: this.state.dimensions.height,
	        width: this.state.dimensions.width
	      };
	
	      return _react2.default.createElement(
	        _reactMeasure2.default,
	        { bounds: true, onResize: this.onResize },
	        function (_ref2) {
	          var measureRef = _ref2.measureRef;
	          return _react2.default.createElement(
	            'div',
	            { ref: measureRef, className: className, style: outerStyle },
	            _react2.default.createElement(
	              'div',
	              { style: innerStyle },
	              _this3.renderChildren()
	            )
	          );
	        }
	      );
	    }
	  }]);
	  return ReflexElement;
	}(_react2.default.Component);
	
	ReflexElement.propTypes = {
	  renderOnResizeRate: _propTypes2.default.number,
	  propagateDimensions: _propTypes2.default.bool,
	  renderOnResize: _propTypes2.default.bool,
	  resizeHeight: _propTypes2.default.bool,
	  resizeWidth: _propTypes2.default.bool,
	  className: _propTypes2.default.string };
	ReflexElement.defaultProps = {
	  renderOnResize: _Browser2.default.isSafari(), // Safari is creepy ...
	  propagateDimensions: false,
	  renderOnResizeRate: 60,
	  resizeHeight: true,
	  resizeWidth: true,
	  className: '' };
	exports.default = ReflexElement;

/***/ }),

/***/ 4404:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(196);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	///////////////////////////////////////////////////////////
	// ReflexEvents
	// By Philippe Leefsma
	// December 2016
	//
	///////////////////////////////////////////////////////////
	var ReflexEvents = function () {
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	  function ReflexEvents() {
	    (0, _classCallCheck3.default)(this, ReflexEvents);
	
	
	    this._events = {};
	  }
	
	  /////////////////////////////////////////////////////////
	  // Supports multiple events space-separated
	  //
	  /////////////////////////////////////////////////////////
	
	
	  (0, _createClass3.default)(ReflexEvents, [{
	    key: 'on',
	    value: function on(events, fct) {
	      var _this = this;
	
	      events.split(' ').forEach(function (event) {
	
	        _this._events[event] = _this._events[event] || [];
	        _this._events[event].push(fct);
	      });
	
	      return this;
	    }
	
	    /////////////////////////////////////////////////////////
	    // Supports multiple events space-separated
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'off',
	    value: function off(events, fct) {
	      var _this2 = this;
	
	      if (events == undefined) {
	
	        this._events = {};
	        return;
	      }
	
	      events.split(' ').forEach(function (event) {
	
	        if (event in _this2._events === false) return;
	
	        if (fct) {
	
	          _this2._events[event].splice(_this2._events[event].indexOf(fct), 1);
	        } else {
	
	          _this2._events[event] = [];
	        }
	      });
	
	      return this;
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'emit',
	    value: function emit(event /* , args... */) {
	
	      if (this._events[event] === undefined) return;
	
	      var tmpArray = this._events[event].slice();
	
	      for (var i = 0; i < tmpArray.length; ++i) {
	
	        var result = tmpArray[i].apply(this, Array.prototype.slice.call(arguments, 1));
	
	        if (result !== undefined) {
	
	          return result;
	        }
	      }
	
	      return undefined;
	    }
	  }]);
	  return ReflexEvents;
	}();
	
	exports.default = ReflexEvents;

/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(378);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(377);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(196);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(7);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(6);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Browser = __webpack_require__(719);
	
	var _Browser2 = _interopRequireDefault(_Browser);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	///////////////////////////////////////////////////////////
	// ReflexSplitter
	// By Philippe Leefsma
	// December 2016
	//
	///////////////////////////////////////////////////////////
	var ReflexSplitter = function (_React$Component) {
	  (0, _inherits3.default)(ReflexSplitter, _React$Component);
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	  function ReflexSplitter(props) {
	    (0, _classCallCheck3.default)(this, ReflexSplitter);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ReflexSplitter.__proto__ || (0, _getPrototypeOf2.default)(ReflexSplitter)).call(this, props));
	
	    _this.state = {
	      active: false
	    };
	
	    _this.onMouseMove = _this.onMouseMove.bind(_this);
	    _this.onMouseDown = _this.onMouseDown.bind(_this);
	    _this.onMouseUp = _this.onMouseUp.bind(_this);
	
	    _this.document = props.document;
	    return _this;
	  }
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	
	
	  /////////////////////////////////////////////////////////
	  //
	  //
	  /////////////////////////////////////////////////////////
	
	
	  (0, _createClass3.default)(ReflexSplitter, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.document) {
	        return;
	      }
	
	      this.document.addEventListener('touchend', this.onMouseUp);
	
	      this.document.addEventListener('mouseup', this.onMouseUp);
	
	      this.document.addEventListener('mousemove', this.onMouseMove, {
	        passive: false
	      });
	
	      this.document.addEventListener('touchmove', this.onMouseMove, {
	        passive: false
	      });
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.document) {
	        return;
	      }
	
	      this.document.removeEventListener('mouseup', this.onMouseUp);
	
	      this.document.removeEventListener('touchend', this.onMouseUp);
	
	      this.document.removeEventListener('mousemove', this.onMouseMove);
	
	      this.document.removeEventListener('touchmove', this.onMouseMove);
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'onMouseMove',
	    value: function onMouseMove(event) {
	
	      if (this.state.active) {
	
	        this.props.events.emit('splitter.resize', {
	          splitter: this,
	          event: event
	        });
	
	        if (this.props.onResize) {
	
	          this.props.onResize({
	            domElement: _reactDom2.default.findDOMNode(this),
	            component: this
	          });
	        }
	
	        event.stopPropagation();
	        event.preventDefault();
	      }
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'onMouseDown',
	    value: function onMouseDown(event) {
	
	      this.setState({
	        active: true
	      });
	
	      if (this.props.onStartResize) {
	
	        // cancels resize from controller
	        // if needed by returning true
	        // to onStartResize
	        if (this.props.onStartResize({
	          domElement: _reactDom2.default.findDOMNode(this),
	          component: this
	        })) {
	
	          return;
	        }
	      }
	
	      this.props.events.emit('splitter.startResize', {
	        splitter: this,
	        event: event
	      });
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'onMouseUp',
	    value: function onMouseUp(event) {
	
	      if (this.state.active) {
	
	        this.setState({
	          active: false
	        });
	
	        if (this.props.onStopResize) {
	
	          this.props.onStopResize({
	            domElement: _reactDom2.default.findDOMNode(this),
	            component: this
	          });
	        }
	
	        this.props.events.emit('splitter.stopResize', {
	          splitter: this,
	          event: event
	        });
	      }
	    }
	
	    /////////////////////////////////////////////////////////
	    //
	    //
	    /////////////////////////////////////////////////////////
	
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var classNames = ['reflex-splitter'].concat((0, _toConsumableArray3.default)(this.props.className.split(' ')));
	
	      if (_Browser2.default.isMobile()) {
	
	        classNames.push('reflex-thin');
	      }
	
	      if (this.state.active) {
	
	        classNames.push('active');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classNames.join(' '),
	          onTouchStart: this.onMouseDown,
	          onMouseDown: this.onMouseDown,
	          style: this.props.style,
	          id: this.props.id },
	        this.props.children
	      );
	    }
	  }]);
	  return ReflexSplitter;
	}(_react2.default.Component);
	
	ReflexSplitter.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  onStartResize: _propTypes2.default.func,
	  onStopResize: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  propagate: _propTypes2.default.bool,
	  onResize: _propTypes2.default.func,
	  style: _propTypes2.default.object };
	ReflexSplitter.defaultProps = {
	  document: typeof document === 'undefined' ? null : document,
	  onStartResize: null,
	  onStopResize: null,
	  propagate: false,
	  onResize: null,
	  className: '',
	  style: {} };
	exports.default = ReflexSplitter;

/***/ }),

/***/ 4405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReflexElement = exports.ReflexSplitter = exports.ReflexContainer = undefined;
	
	var _ReflexContainer = __webpack_require__(4403);
	
	var _ReflexContainer2 = _interopRequireDefault(_ReflexContainer);
	
	var _ReflexSplitter = __webpack_require__(721);
	
	var _ReflexSplitter2 = _interopRequireDefault(_ReflexSplitter);
	
	var _ReflexElement = __webpack_require__(720);
	
	var _ReflexElement2 = _interopRequireDefault(_ReflexElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ReflexContainer = _ReflexContainer2.default;
	exports.ReflexSplitter = _ReflexSplitter2.default;
	exports.ReflexElement = _ReflexElement2.default;

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(4);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 4445:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(4446);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 4446:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 4457:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 180:
/***/ (function(module, exports) {

	module.exports = [{"english":"Responsive Web Design","chinese":"Responsive Web Design"},{"english":"Javascript Algorithms And Data Structures","chinese":"Javascript Algorithms And Data Structures"},{"english":"Front End Libraries","chinese":"Front End Libraries"},{"english":"Data Visualization","chinese":"Data Visualization"},{"english":"Apis And Microservices","chinese":"Apis And Microservices"},{"english":"Information Security And Quality Assurance","chinese":"Information Security And Quality Assurance"},{"english":"Coding Interview Prep","chinese":"Coding Interview Prep"},{"english":"Basic HTML and HTML5","chinese":"Basic HTML and HTML5"},{"english":"Basic CSS","chinese":"Basic CSS"},{"english":"Applied Visual Design","chinese":"Applied Visual Design"},{"english":"Applied Accessibility","chinese":"Applied Accessibility"},{"english":"Responsive Web Design Principles","chinese":"Responsive Web Design Principles"},{"english":"CSS Flexbox","chinese":"CSS Flexbox"},{"english":"CSS Grid","chinese":"CSS Grid"},{"english":"Responsive Web Design Projects","chinese":"Responsive Web Design Projects"},{"english":"Basic JavaScript","chinese":"Basic JavaScript"},{"english":"ES6","chinese":"ES6"},{"english":"Regular Expressions","chinese":"Regular Expressions"},{"english":"Debugging","chinese":"Debugging"},{"english":"Basic Data Structures","chinese":"Basic Data Structures"},{"english":"Basic Algorithm Scripting","chinese":"Basic Algorithm Scripting"},{"english":"Object Oriented Programming","chinese":"Object Oriented Programming"},{"english":"Functional Programming","chinese":"Functional Programming"},{"english":"Intermediate Algorithm Scripting","chinese":"Intermediate Algorithm Scripting"},{"english":"JavaScript Algorithms and Data Structures Projects","chinese":"JavaScript Algorithms and Data Structures Projects"},{"english":"Bootstrap","chinese":"Bootstrap"},{"english":"jQuery","chinese":"jQuery"},{"english":"Sass","chinese":"Sass"},{"english":"React","chinese":"React"},{"english":"Redux","chinese":"Redux"},{"english":"React and Redux","chinese":"React and Redux"},{"english":"Front End Libraries Projects","chinese":"Front End Libraries Projects"},{"english":"Data Visualization with D3","chinese":"Data Visualization with D3"},{"english":"JSON APIs and Ajax","chinese":"JSON APIs and Ajax"},{"english":"Data Visualization Projects","chinese":"Data Visualization Projects"},{"english":"Managing Packages with Npm","chinese":"Managing Packages with Npm"},{"english":"Basic Node and Express","chinese":"Basic Node and Express"},{"english":"MongoDB and Mongoose","chinese":"MongoDB and Mongoose"},{"english":"Apis and Microservices Projects","chinese":"Apis and Microservices Projects"},{"english":"Information Security with HelmetJS","chinese":"Information Security with HelmetJS"},{"english":"Quality Assurance and Testing with Chai","chinese":"Quality Assurance and Testing with Chai"},{"english":"Advanced Node and Express","chinese":"Advanced Node and Express"},{"english":"Information Security and Quality Assurance Projects","chinese":"Information Security and Quality Assurance Projects"},{"english":"Algorithms","chinese":"Algorithms"},{"english":"Data Structures","chinese":"Data Structures"},{"english":"Take Home Projects","chinese":"Take Home Projects"},{"english":"Rosetta Code","chinese":"Rosetta Code"},{"english":"Project Euler","chinese":"Project Euler"},{"english":"Introduction to Basic HTML and HTML5","chinese":"Introduction to Basic HTML and HTML5"},{"english":"Say Hello to HTML Elements","chinese":"Say Hello to HTML Elements"},{"english":"Headline with the h2 Element","chinese":"Headline with the h2 Element"},{"english":"Inform with the Paragraph Element","chinese":"Inform with the Paragraph Element"},{"english":"Fill in the Blank with Placeholder Text","chinese":"Fill in the Blank with Placeholder Text"},{"english":"Uncomment HTML","chinese":"Uncomment HTML"},{"english":"Comment out HTML","chinese":"Comment out HTML"},{"english":"Delete HTML Elements","chinese":"Delete HTML Elements"},{"english":"Introduction to HTML5 Elements","chinese":"Introduction to HTML5 Elements"},{"english":"Add Images to Your Website","chinese":"Add Images to Your Website"},{"english":"Link to External Pages with Anchor Elements","chinese":"Link to External Pages with Anchor Elements"},{"english":"Link to Internal Sections of a Page with Anchor Elements","chinese":"Link to Internal Sections of a Page with Anchor Elements"},{"english":"Nest an Anchor Element within a Paragraph","chinese":"Nest an Anchor Element within a Paragraph"},{"english":"Make Dead Links Using the Hash Symbol","chinese":"Make Dead Links Using the Hash Symbol"},{"english":"Turn an Image into a Link","chinese":"Turn an Image into a Link"},{"english":"Create a Bulleted Unordered List","chinese":"Create a Bulleted Unordered List"},{"english":"Create an Ordered List","chinese":"Create an Ordered List"},{"english":"Create a Text Field","chinese":"Create a Text Field"},{"english":"Add Placeholder Text to a Text Field","chinese":"Add Placeholder Text to a Text Field"},{"english":"Create a Form Element","chinese":"Create a Form Element"},{"english":"Add a Submit Button to a Form","chinese":"Add a Submit Button to a Form"},{"english":"Use HTML5 to Require a Field","chinese":"Use HTML5 to Require a Field"},{"english":"Create a Set of Radio Buttons","chinese":"Create a Set of Radio Buttons"},{"english":"Create a Set of Checkboxes","chinese":"Create a Set of Checkboxes"},{"english":"Check Radio Buttons and Checkboxes by Default","chinese":"Check Radio Buttons and Checkboxes by Default"},{"english":"Nest Many Elements within a Single div Element","chinese":"Nest Many Elements within a Single div Element"},{"english":"Declare the Doctype of an HTML Document","chinese":"Declare the Doctype of an HTML Document"},{"english":"Define the Head and Body of an HTML Document","chinese":"Define the Head and Body of an HTML Document"},{"english":"Introduction to Basic CSS","chinese":"Introduction to Basic CSS"},{"english":"Change the Color of Text","chinese":"Change the Color of Text"},{"english":"Use CSS Selectors to Style Elements","chinese":"Use CSS Selectors to Style Elements"},{"english":"Use a CSS Class to Style an Element","chinese":"Use a CSS Class to Style an Element"},{"english":"Style Multiple Elements with a CSS Class","chinese":"Style Multiple Elements with a CSS Class"},{"english":"Change the Font Size of an Element","chinese":"Change the Font Size of an Element"},{"english":"Set the Font Family of an Element","chinese":"Set the Font Family of an Element"},{"english":"Import a Google Font","chinese":"Import a Google Font"},{"english":"Specify How Fonts Should Degrade","chinese":"Specify How Fonts Should Degrade"},{"english":"Size Your Images","chinese":"Size Your Images"},{"english":"Add Borders Around Your Elements","chinese":"Add Borders Around Your Elements"},{"english":"Add Rounded Corners with border-radius","chinese":"Add Rounded Corners with border-radius"},{"english":"Make Circular Images with a border-radius","chinese":"Make Circular Images with a border-radius"},{"english":"Give a Background Color to a div Element","chinese":"Give a Background Color to a div Element"},{"english":"Set the id of an Element","chinese":"Set the id of an Element"},{"english":"Use an id Attribute to Style an Element","chinese":"se an id Attribute to Style an Element"},{"english":"Adjust the Padding of an Element","chinese":"Adjust the Padding of an Element"},{"english":"Adjust the Margin of an Element","chinese":"Adjust the Margin of an Element"},{"english":"Add a Negative Margin to an Element","chinese":"Add a Negative Margin to an Element"},{"english":"Add Different Padding to Each Side of an Element","chinese":"Add Different Padding to Each Side of an Element"},{"english":"Add Different Margins to Each Side of an Element","chinese":"Add Different Margins to Each Side of an Element"},{"english":"Use Clockwise Notation to Specify the Padding of an Element","chinese":"Use Clockwise Notation to Specify the Padding of an Element"},{"english":"Use Clockwise Notation to Specify the Margin of an Element","chinese":"Use Clockwise Notation to Specify the Margin of an Element"},{"english":"Use Attribute Selectors to Style Elements","chinese":"Use Attribute Selectors to Style Elements"},{"english":"Understand Absolute versus Relative Units","chinese":"Understand Absolute versus Relative Units"},{"english":"Style the HTML Body Element","chinese":"Style the HTML Body Element"},{"english":"Inherit Styles from the Body Element","chinese":"Inherit Styles from the Body Element"},{"english":"Prioritize One Style Over Another","chinese":"Prioritize One Style Over Another"},{"english":"Override Styles in Subsequent CSS","chinese":"Override Styles in Subsequent CSS"},{"english":"Override Class Declarations by Styling ID Attributes","chinese":"Override Class Declarations by Styling ID Attributes"},{"english":"Override Class Declarations with Inline Styles","chinese":"Override Class Declarations with Inline Styles"},{"english":"Override All Other Styles by using Important","chinese":"Override All Other Styles by using Important"},{"english":"Use Hex Code for Specific Colors","chinese":"Use Hex Code for Specific Colors"},{"english":"Use Hex Code to Mix Colors","chinese":"Use Hex Code to Mix Colors"},{"english":"Use Abbreviated Hex Code","chinese":"Use Abbreviated Hex Code"},{"english":"Use RGB values to Color Elements","chinese":"Use RGB values to Color Elements"},{"english":"Use RGB to Mix Colors","chinese":"Use RGB to Mix Colors"},{"english":"Use CSS Variables to change several elements at once","chinese":"Use CSS Variables to change several elements at once"},{"english":"Create a custom CSS Variable","chinese":"Create a custom CSS Variable"},{"english":"Use a custom CSS Variable","chinese":"Use a custom CSS Variable"},{"english":"Attach a Fallback value to a CSS Variable","chinese":"Attach a Fallback value to a CSS Variable"},{"english":"Cascading CSS variables","chinese":"Cascading CSS variables"},{"english":"Change a variable for a specific area","chinese":"Change a variable for a specific area"},{"english":"Use a media query to change a variable","chinese":"Use a media query to change a variable"},{"english":"Introduction to the Applied Visual Design Challenges","chinese":"Introduction to the Applied Visual Design Challenges"},{"english":"Create Visual Balance Using the text-align Property","chinese":"Create Visual Balance Using the text-align Property"},{"english":"Adjust the Width of an Element Using the width Property","chinese":"Adjust the Width of an Element Using the width Property"},{"english":"Adjust the Height of an Element Using the height Property","chinese":"Adjust the Height of an Element Using the height Property"},{"english":"Use the strong Tag to Make Text Bold","chinese":"Use the strong Tag to Make Text Bold"},{"english":"Use the u Tag to Underline Text","chinese":"Use the u Tag to Underline Text"},{"english":"Use the em Tag to Italicize Text","chinese":"Use the em Tag to Italicize Text"},{"english":"Use the s Tag to Strikethrough Text","chinese":"Use the s Tag to Strikethrough Text"},{"english":"Create a Horizontal Line Using the hr Element","chinese":"Create a Horizontal Line Using the hr Element"},{"english":"Adjust the background-color Property of Text","chinese":"Adjust the background-color Property of Text"},{"english":"Adjust the Size of a Header Versus a Paragraph Tag","chinese":"Adjust the Size of a Header Versus a Paragraph Tag"},{"english":"Add a box-shadow to a Card-like Element","chinese":"Add a box-shadow to a Card-like Element"},{"english":"Decrease the Opacity of an Element","chinese":"Decrease the Opacity of an Element"},{"english":"Use the text-transform Property to Make Text Uppercase","chinese":"Use the text-transform Property to Make Text Uppercase"},{"english":"Set the font-size for Multiple Heading Elements","chinese":"Set the font-size for Multiple Heading Elements"},{"english":"Set the font-weight for Multiple Heading Elements","chinese":"Set the font-weight for Multiple Heading Elements"},{"english":"Set the font-size of Paragraph Text","chinese":"Set the font-size of Paragraph Text"},{"english":"Set the line-height of Paragraphs","chinese":"Set the line-height of Paragraphs"},{"english":"Adjust the Hover State of an Anchor Tag","chinese":"Adjust the Hover State of an Anchor Tag"},{"english":"Change an Element's Relative Position","chinese":"Change an Element's Relative Position"},{"english":"Move a Relatively Positioned Element with CSS Offsets","chinese":"Move a Relatively Positioned Element with CSS Offsets"},{"english":"Lock an Element to its Parent with Absolute Positioning","chinese":"Lock an Element to its Parent with Absolute Positioning"},{"english":"Lock an Element to the Browser Window with Fixed Positioning","chinese":"Lock an Element to the Browser Window with Fixed Positioning"},{"english":"Push Elements Left or Right with the float Property","chinese":"Push Elements Left or Right with the float Property"},{"english":"Change the Position of Overlapping Elements with the z-index Property","chinese":"Change the Position of Overlapping Elements with the z-index Property"},{"english":"Center an Element Horizontally Using the margin Property","chinese":"Center an Element Horizontally Using the margin Property"},{"english":"Learn about Complementary Colors","chinese":"Learn about Complementary Colors"},{"english":"Learn about Tertiary Colors","chinese":"Learn about Tertiary Colors"},{"english":"Adjust the Color of Various Elements to Complementary Colors","chinese":"Adjust the Color of Various Elements to Complementary Colors"},{"english":"Adjust the Hue of a Color","chinese":"Adjust the Hue of a Color"},{"english":"Adjust the Tone of a Color","chinese":"Adjust the Tone of a Color"},{"english":"Create a Gradual CSS Linear Gradient","chinese":"Create a Gradual CSS Linear Gradient"},{"english":"Use a CSS Linear Gradient to Create a Striped Element","chinese":"Use a CSS Linear Gradient to Create a Striped Element"},{"english":"Create Texture by Adding a Subtle Pattern as a Background Image","chinese":"Create Texture by Adding a Subtle Pattern as a Background Image"},{"english":"Use the CSS Transform scale Property to Change the Size of an Element","chinese":"Use the CSS Transform scale Property to Change the Size of an Element"},{"english":"Use the CSS Transform scale Property to Scale an Element on Hover","chinese":"Use the CSS Transform scale Property to Scale an Element on Hover"},{"english":"Use the CSS Transform Property skewX to Skew an Element Along the X-Axis","chinese":"Use the CSS Transform Property skewX to Skew an Element Along the X-Axis"},{"english":"Use the CSS Transform Property skewY to Skew an Element Along the Y-Axis","chinese":"Use the CSS Transform Property skewY to Skew an Element Along the Y-Axis"},{"english":"Create a Graphic Using CSS","chinese":"Create a Graphic Using CSS"},{"english":"Create a More Complex Shape Using CSS and HTML","chinese":"Create a More Complex Shape Using CSS and HTML"},{"english":"Learn How the CSS @keyframes and animation Properties Work","chinese":"Learn How the CSS @keyframes and animation Properties Work"},{"english":"Use CSS Animation to Change the Hover State of a Button","chinese":"Use CSS Animation to Change the Hover State of a Button"},{"english":"Modify Fill Mode of an Animation","chinese":"Modify Fill Mode of an Animation"},{"english":"Create Movement Using CSS Animation","chinese":"Create Movement Using CSS Animation"},{"english":"Create Visual Direction by Fading an Element from Left to Right","chinese":"Create Visual Direction by Fading an Element from Left to Right"},{"english":"Animate Elements Continually Using an Infinite Animation Count","chinese":"Animate Elements Continually Using an Infinite Animation Count"},{"english":"Make a CSS Heartbeat using an Infinite Animation Count","chinese":"Make a CSS Heartbeat using an Infinite Animation Count"},{"english":"Animate Elements at Variable Rates","chinese":"Animate Elements at Variable Rates"},{"english":"Animate Multiple Elements at Variable Rates","chinese":"Animate Multiple Elements at Variable Rates"},{"english":"Change Animation Timing with Keywords","chinese":"Change Animation Timing with Keywords"},{"english":"Learn How Bezier Curves Work","chinese":"Learn How Bezier Curves Work"},{"english":"Use a Bezier Curve to Move a Graphic","chinese":"Use a Bezier Curve to Move a Graphic"},{"english":"Make Motion More Natural Using a Bezier Curve","chinese":"Make Motion More Natural Using a Bezier Curve"},{"english":"Introduction to the Applied Accessibility Challenges","chinese":"Introduction to the Applied Accessibility Challenges"},{"english":"Add a Text Alternative to Images for Visually Impaired Accessibility","chinese":"Add a Text Alternative to Images for Visually Impaired Accessibility"},{"english":"Know When Alt Text Should be Left Blank","chinese":"Know When Alt Text Should be Left Blank"},{"english":"Use Headings to Show Hierarchical Relationships of Content","chinese":"Use Headings to Show Hierarchical Relationships of Content"},{"english":"Jump Straight to the Content Using the main Element","chinese":"Jump Straight to the Content Using the main Element"},{"english":"Wrap Content in the article Element","chinese":"Wrap Content in the article Element"},{"english":"Make Screen Reader Navigation Easier with the header Landmark","chinese":"Make Screen Reader Navigation Easier with the header Landmark"},{"english":"Make Screen Reader Navigation Easier with the nav Landmark","chinese":"Make Screen Reader Navigation Easier with the nav Landmark"},{"english":"Make Screen Reader Navigation Easier with the footer Landmark","chinese":"Make Screen Reader Navigation Easier with the footer Landmark"},{"english":"Improve Accessibility of Audio Content with the audio Element","chinese":"Improve Accessibility of Audio Content with the audio Element"},{"english":"Improve Chart Accessibility with the figure Element","chinese":"Improve Chart Accessibility with the figure Element"},{"english":"Improve Form Field Accessibility with the label Element","chinese":"Improve Form Field Accessibility with the label Element"},{"english":"Wrap Radio Buttons in a fieldset Element for Better Accessibility","chinese":"Wrap Radio Buttons in a fieldset Element for Better Accessibility"},{"english":"Add an Accessible Date Picker","chinese":"Add an Accessible Date Picker"},{"english":"Standardize Times with the HTML5 datetime Attribute","chinese":"Standardize Times with the HTML5 datetime Attribute"},{"english":"Make Elements Only Visible to a Screen Reader by Using Custom CSS","chinese":"Make Elements Only Visible to a Screen Reader by Using Custom CSS"},{"english":"Improve Readability with High Contrast Text","chinese":"Improve Readability with High Contrast Text"},{"english":"Avoid Colorblindness Issues by Using Sufficient Contrast","chinese":"Avoid Colorblindness Issues by Using Sufficient Contrast"},{"english":"Avoid Colorblindness Issues by Carefully Choosing Colors that Convey Information","chinese":"Avoid Colorblindness Issues by Carefully Choosing Colors that Convey Information"},{"english":"Give Links Meaning by Using Descriptive Link Text","chinese":"Give Links Meaning by Using Descriptive Link Text"},{"english":"Make Links Navigatable with HTML Access Keys","chinese":"Make Links Navigatable with HTML Access Keys"},{"english":"Use tabindex to Add Keyboard Focus to an Element","chinese":"Use tabindex to Add Keyboard Focus to an Element"},{"english":"Use tabindex to Specify the Order of Keyboard Focus for Several Elements","chinese":"Use tabindex to Specify the Order of Keyboard Focus for Several Elements"},{"english":"Introduction to the Responsive Web Design Challenges","chinese":"Introduction to the Responsive Web Design Challenges"},{"english":"Create a Media Query","chinese":"Create a Media Query"},{"english":"Make an Image Responsive","chinese":"Make an Image Responsive"},{"english":"Use a Retina Image for Higher Resolution Displays","chinese":"Use a Retina Image for Higher Resolution Displays"},{"english":"Make Typography Responsive","chinese":"Make Typography Responsive"},{"english":"Introduction to the CSS Flexbox Challenges","chinese":"Introduction to the CSS Flexbox Challenges"},{"english":"Use display: flex to Position Two Boxes","chinese":"Use display: flex to Position Two Boxes"},{"english":"Add Flex Superpowers to the Tweet Embed","chinese":"Add Flex Superpowers to the Tweet Embed"},{"english":"Use the flex-direction Property to Make a Row","chinese":"Use the flex-direction Property to Make a Row"},{"english":"Apply the flex-direction Property to Create Rows in the Tweet Embed","chinese":"Apply the flex-direction Property to Create Rows in the Tweet Embed"},{"english":"Use the flex-direction Property to Make a Column","chinese":"Use the flex-direction Property to Make a Column"},{"english":"Apply the flex-direction Property to Create a Column in the Tweet Embed","chinese":"Apply the flex-direction Property to Create a Column in the Tweet Embed"},{"english":"Align Elements Using the justify-content Property","chinese":"Align Elements Using the justify-content Property"},{"english":"Use the justify-content Property in the Tweet Embed","chinese":"Use the justify-content Property in the Tweet Embed"},{"english":"Align Elements Using the align-items Property","chinese":"Align Elements Using the align-items Property"},{"english":"Use the align-items Property in the Tweet Embed","chinese":"Use the align-items Property in the Tweet Embed"},{"english":"Use the flex-wrap Property to Wrap a Row or Column","chinese":"Use the flex-wrap Property to Wrap a Row or Column"},{"english":"Use the flex-shrink Property to Shrink Items","chinese":"Use the flex-shrink Property to Shrink Items"},{"english":"Use the flex-grow Property to Expand Items","chinese":"Use the flex-grow Property to Expand Items"},{"english":"Use the flex-basis Property to Set the Initial Size of an Item","chinese":"Use the flex-basis Property to Set the Initial Size of an Item"},{"english":"Use the flex Shorthand Property","chinese":"Use the flex Shorthand Property"},{"english":"Use the order Property to Rearrange Items","chinese":"Use the order Property to Rearrange Items"},{"english":"Use the align-self Property","chinese":"Use the align-self Property"},{"english":"Introduction to the CSS Grid Challenges","chinese":"Introduction to the CSS Grid Challenges"},{"english":"Create Your First CSS Grid","chinese":"Create Your First CSS Grid"},{"english":"Add Columns with grid-template-columns","chinese":"Add Columns with grid-template-columns"},{"english":"Add Rows with grid-template-rows","chinese":"Add Rows with grid-template-rows"},{"english":"Use CSS Grid units to Change the Size of Columns and Rows","chinese":"Use CSS Grid units to Change the Size of Columns and Rows"},{"english":"Create a Column Gap Using grid-column-gap","chinese":"Create a Column Gap Using grid-column-gap"},{"english":"Create a Row Gap using grid-row-gap","chinese":"Create a Row Gap using grid-row-gap"},{"english":"Add Gaps Faster with grid-gap","chinese":"Add Gaps Faster with grid-gap"},{"english":"Use grid-column to Control Spacing","chinese":"Use grid-column to Control Spacing"},{"english":"Use grid-row to Control Spacing","chinese":"Use grid-row to Control Spacing"},{"english":"Align an Item Horizontally using justify-self","chinese":"Align an Item Horizontally using justify-self"},{"english":"Align an Item Vertically using align-self","chinese":"Align an Item Vertically using align-self"},{"english":"Align All Items Horizontally using justify-items","chinese":"Align All Items Horizontally using justify-items"},{"english":"Align All Items Vertically using align-items","chinese":"Align All Items Vertically using align-items"},{"english":"Divide the Grid Into an Area Template","chinese":"Divide the Grid Into an Area Template"},{"english":"Place Items in Grid Areas Using the grid-area Property","chinese":"Place Items in Grid Areas Using the grid-area Property"},{"english":"Use grid-area Without Creating an Areas Template","chinese":"Use grid-area Without Creating an Areas Template"},{"english":"Reduce Repetition Using the repeat Function","chinese":"Reduce Repetition Using the repeat Function"},{"english":"Limit Item Size Using the minmax Function","chinese":"Limit Item Size Using the minmax Function"},{"english":"Create Flexible Layouts Using auto-fill","chinese":"Create Flexible Layouts Using auto-fill"},{"english":"Create Flexible Layouts Using auto-fit","chinese":"Create Flexible Layouts Using auto-fit"},{"english":"Use Media Queries to Create Responsive Layouts","chinese":"Use Media Queries to Create Responsive Layouts"},{"english":"Create Grids within Grids","chinese":"Create Grids within Grids"},{"english":"Introduction to the Responsive Web Design Projects","chinese":"Introduction to the Responsive Web Design Projects"},{"english":"Build a Tribute Page","chinese":"Build a Tribute Page"},{"english":"Build a Survey Form","chinese":"Build a Survey Form"},{"english":"Build a Product Landing Page","chinese":"Build a Product Landing Page"},{"english":"Build a Technical Documentation Page","chinese":"Build a Technical Documentation Page"},{"english":"Build a Personal Portfolio Webpage","chinese":"Build a Personal Portfolio Webpage"},{"english":"Introduction to JavaScript","chinese":"Introduction to JavaScript"},{"english":"Comment Your JavaScript Code","chinese":"Comment Your JavaScript Code"},{"english":"Declare JavaScript Variables","chinese":"Declare JavaScript Variables"},{"english":"Storing Values with the Assignment Operator","chinese":"Storing Values with the Assignment Operator"},{"english":"Initializing Variables with the Assignment Operator","chinese":"Initializing Variables with the Assignment Operator"},{"english":"Understanding Uninitialized Variables","chinese":"Understanding Uninitialized Variables"},{"english":"Understanding Case Sensitivity in Variables","chinese":"Understanding Case Sensitivity in Variables"},{"english":"Add Two Numbers with JavaScript","chinese":"Add Two Numbers with JavaScript"},{"english":"Subtract One Number from Another with JavaScript","chinese":"Subtract One Number from Another with JavaScript"},{"english":"Multiply Two Numbers with JavaScript","chinese":"Multiply Two Numbers with JavaScript"},{"english":"Divide One Number by Another with JavaScript","chinese":"Divide One Number by Another with JavaScript"},{"english":"Increment a Number with JavaScript","chinese":"Increment a Number with JavaScript"},{"english":"Decrement a Number with JavaScript","chinese":"Decrement a Number with JavaScript"},{"english":"Create Decimal Numbers with JavaScript","chinese":"Create Decimal Numbers with JavaScript"},{"english":"Multiply Two Decimals with JavaScript","chinese":"Multiply Two Decimals with JavaScript"},{"english":"Divide One Decimal by Another with JavaScript","chinese":"Divide One Decimal by Another with JavaScript"},{"english":"Finding a Remainder in JavaScript","chinese":"Finding a Remainder in JavaScript"},{"english":"Compound Assignment With Augmented Addition","chinese":"Compound Assignment With Augmented Addition"},{"english":"Compound Assignment With Augmented Subtraction","chinese":"Compound Assignment With Augmented Subtraction"},{"english":"Compound Assignment With Augmented Multiplication","chinese":"Compound Assignment With Augmented Multiplication"},{"english":"Compound Assignment With Augmented Division","chinese":"Compound Assignment With Augmented Division"},{"english":"Declare String Variables","chinese":"Declare String Variables"},{"english":"Escaping Literal Quotes in Strings","chinese":"Escaping Literal Quotes in Strings"},{"english":"Quoting Strings with Single Quotes","chinese":"Quoting Strings with Single Quotes"},{"english":"Escape Sequences in Strings","chinese":"Escape Sequences in Strings"},{"english":"Concatenating Strings with Plus Operator","chinese":"Concatenating Strings with Plus Operator"},{"english":"Concatenating Strings with the Plus Equals Operator","chinese":"Concatenating Strings with the Plus Equals Operator"},{"english":"Constructing Strings with Variables","chinese":"Constructing Strings with Variables"},{"english":"Appending Variables to Strings","chinese":"Appending Variables to Strings"},{"english":"Find the Length of a String","chinese":"Find the Length of a String"},{"english":"Use Bracket Notation to Find the First Character in a String","chinese":"Use Bracket Notation to Find the First Character in a String"},{"english":"Understand String Immutability","chinese":"Understand String Immutability"},{"english":"Use Bracket Notation to Find the Nth Character in a String","chinese":"Use Bracket Notation to Find the Nth Character in a String"},{"english":"Use Bracket Notation to Find the Last Character in a String","chinese":"Use Bracket Notation to Find the Last Character in a String"},{"english":"Use Bracket Notation to Find the Nth-to-Last Character in a String","chinese":"Use Bracket Notation to Find the Nth-to-Last Character in a String"},{"english":"Word Blanks","chinese":"Word Blanks"},{"english":"Store Multiple Values in one Variable using JavaScript Arrays","chinese":"Store Multiple Values in one Variable using JavaScript Arrays"},{"english":"Nest one Array within Another Array","chinese":"Nest one Array within Another Array"},{"english":"Access Array Data with Indexes","chinese":"Access Array Data with Indexes"},{"english":"Modify Array Data With Indexes","chinese":"Modify Array Data With Indexes"},{"english":"Access Multi-Dimensional Arrays With Indexes","chinese":"Access Multi-Dimensional Arrays With Indexes"},{"english":"Manipulate Arrays With push()","chinese":"Manipulate Arrays With push()"},{"english":"Manipulate Arrays With pop()","chinese":"Manipulate Arrays With pop()"},{"english":"Manipulate Arrays With shift()","chinese":"Manipulate Arrays With shift()"},{"english":"Manipulate Arrays With unshift()","chinese":"Manipulate Arrays With unshift()"},{"english":"Shopping List","chinese":"Shopping List"},{"english":"Write Reusable JavaScript with Functions","chinese":"Write Reusable JavaScript with Functions"},{"english":"Passing Values to Functions with Arguments","chinese":"Passing Values to Functions with Arguments"},{"english":"Global Scope and Functions","chinese":"Global Scope and Functions"},{"english":"Local Scope and Functions","chinese":"Local Scope and Functions"},{"english":"Global vs. Local Scope in Functions","chinese":"Global vs. Local Scope in Functions"},{"english":"Return a Value from a Function with Return","chinese":"Return a Value from a Function with Return"},{"english":"Understanding Undefined Value returned from a Function","chinese":"Understanding Undefined Value returned from a Function"},{"english":"Assignment with a Returned Value","chinese":"Assignment with a Returned Value"},{"english":"Stand in Line","chinese":"Stand in Line"},{"english":"Understanding Boolean Values","chinese":"Understanding Boolean Values"},{"english":"Use Conditional Logic with If Statements","chinese":"Use Conditional Logic with If Statements"},{"english":"Comparison with the Equality Operator","chinese":"Comparison with the Equality Operator"},{"english":"Comparison with the Strict Equality Operator","chinese":"Comparison with the Strict Equality Operator"},{"english":"Practice comparing different values","chinese":"Practice comparing different values"},{"english":"Comparison with the Inequality Operator","chinese":"Comparison with the Inequality Operator"},{"english":"Comparison with the Strict Inequality Operator","chinese":"Comparison with the Strict Inequality Operator"},{"english":"Comparison with the Greater Than Operator","chinese":"Comparison with the Greater Than Operator"},{"english":"Comparison with the Greater Than Or Equal To Operator","chinese":"Comparison with the Greater Than Or Equal To Operator"},{"english":"Comparison with the Less Than Operator","chinese":"Comparison with the Less Than Operator"},{"english":"Comparison with the Less Than Or Equal To Operator","chinese":"Comparison with the Less Than Or Equal To Operator"},{"english":"Comparisons with the Logical And Operator","chinese":"Comparisons with the Logical And Operator"},{"english":"Comparisons with the Logical Or Operator","chinese":"Comparisons with the Logical Or Operator"},{"english":"Introducing Else Statements","chinese":"Introducing Else Statements"},{"english":"Introducing Else If Statements","chinese":"Introducing Else If Statements"},{"english":"Logical Order in If Else Statements","chinese":"Logical Order in If Else Statements"},{"english":"Chaining If Else Statements","chinese":"Chaining If Else Statements"},{"english":"Golf Code","chinese":"Golf Code"},{"english":"Selecting from Many Options with Switch Statements","chinese":"Selecting from Many Options with Switch Statements"},{"english":"Adding a Default Option in Switch Statements","chinese":"Adding a Default Option in Switch Statements"},{"english":"Multiple Identical Options in Switch Statements","chinese":"Multiple Identical Options in Switch Statements"},{"english":"Replacing If Else Chains with Switch","chinese":"Replacing If Else Chains with Switch"},{"english":"Returning Boolean Values from Functions","chinese":"Returning Boolean Values from Functions"},{"english":"Return Early Pattern for Functions","chinese":"Return Early Pattern for Functions"},{"english":"Counting Cards","chinese":"Counting Cards"},{"english":"Build JavaScript Objects","chinese":"Build JavaScript Objects"},{"english":"Accessing Object Properties with Dot Notation","chinese":"Accessing Object Properties with Dot Notation"},{"english":"Accessing Object Properties with Bracket Notation","chinese":"Accessing Object Properties with Bracket Notation"},{"english":"Accessing Object Properties with Variables","chinese":"Accessing Object Properties with Variables"},{"english":"Updating Object Properties","chinese":"Updating Object Properties"},{"english":"Add New Properties to a JavaScript Object","chinese":"Add New Properties to a JavaScript Object"},{"english":"Delete Properties from a JavaScript Object","chinese":"Delete Properties from a JavaScript Object"},{"english":"Using Objects for Lookups","chinese":"Using Objects for Lookups"},{"english":"Testing Objects for Properties","chinese":"Testing Objects for Properties"},{"english":"Manipulating Complex Objects","chinese":"Manipulating Complex Objects"},{"english":"Accessing Nested Objects","chinese":"Accessing Nested Objects"},{"english":"Accessing Nested Arrays","chinese":"Accessing Nested Arrays"},{"english":"Record Collection","chinese":"Record Collection"},{"english":"Iterate with JavaScript While Loops","chinese":"Iterate with JavaScript While Loops"},{"english":"Iterate with JavaScript For Loops","chinese":"Iterate with JavaScript For Loops"},{"english":"Iterate Odd Numbers With a For Loop","chinese":"Iterate Odd Numbers With a For Loop"},{"english":"Count Backwards With a For Loop","chinese":"Count Backwards With a For Loop"},{"english":"Iterate Through an Array with a For Loop","chinese":"Iterate Through an Array with a For Loop"},{"english":"Nesting For Loops","chinese":"Nesting For Loops"},{"english":"Iterate with JavaScript Do...While Loops","chinese":"Iterate with JavaScript Do...While Loops"},{"english":"Profile Lookup","chinese":"Profile Lookup"},{"english":"Generate Random Fractions with JavaScript","chinese":"Generate Random Fractions with JavaScript"},{"english":"Generate Random Whole Numbers with JavaScript","chinese":"Generate Random Whole Numbers with JavaScript"},{"english":"Generate Random Whole Numbers within a Range","chinese":"Generate Random Whole Numbers within a Range"},{"english":"Use the parseInt Function","chinese":"Use the parseInt Function"},{"english":"Use the parseInt Function with a Radix","chinese":"Use the parseInt Function with a Radix"},{"english":"Use the Conditional (Ternary) Operator","chinese":"Use the Conditional (Ternary) Operator"},{"english":"Use Multiple Conditional (Ternary) Operators","chinese":"Use Multiple Conditional (Ternary) Operators"},{"english":"Introduction to the ES6 Challenges","chinese":"Introduction to the ES6 Challenges"},{"english":"Explore Differences Between the var and let Keywords","chinese":"Explore Differences Between the var and let Keywords"},{"english":"Compare Scopes of the var and let Keywords","chinese":"Compare Scopes of the var and let Keywords"},{"english":"Declare a Read-Only Variable with the const Keyword","chinese":"Declare a Read-Only Variable with the const Keyword"},{"english":"Mutate an Array Declared with const","chinese":"Mutate an Array Declared with const"},{"english":"Prevent Object Mutation","chinese":"Prevent Object Mutation"},{"english":"Use Arrow Functions to Write Concise Anonymous Functions","chinese":"Use Arrow Functions to Write Concise Anonymous Functions"},{"english":"Write Arrow Functions with Parameters","chinese":"Write Arrow Functions with Parameters"},{"english":"Write Higher Order Arrow Functions","chinese":"Write Higher Order Arrow Functions"},{"english":"Set Default Parameters for Your Functions","chinese":"Set Default Parameters for Your Functions"},{"english":"Use the Rest Operator with Function Parameters","chinese":"Use the Rest Operator with Function Parameters"},{"english":"Use the Spread Operator to Evaluate Arrays In-Place","chinese":"Use the Spread Operator to Evaluate Arrays In-Place"},{"english":"Use Destructuring Assignment to Assign Variables from Objects","chinese":"Use Destructuring Assignment to Assign Variables from Objects"},{"english":"Use Destructuring Assignment to Assign Variables from Nested Objects","chinese":"Use Destructuring Assignment to Assign Variables from Nested Objects"},{"english":"Use Destructuring Assignment to Assign Variables from Arrays","chinese":"Use Destructuring Assignment to Assign Variables from Arrays"},{"english":"Use Destructuring Assignment with the Rest Operator to Reassign Array Elements","chinese":"Use Destructuring Assignment with the Rest Operator to Reassign Array Elements"},{"english":"Use Destructuring Assignment to Pass an Object as a Function's Parameters","chinese":"Use Destructuring Assignment to Pass an Object as a Function's Parameters"},{"english":"Create Strings using Template Literals","chinese":"Create Strings using Template Literals"},{"english":"Write Concise Object Literal Declarations Using Simple Fields","chinese":"Write Concise Object Literal Declarations Using Simple Fields"},{"english":"Write Concise Declarative Functions with ES6","chinese":"Write Concise Declarative Functions with ES6"},{"english":"Use class Syntax to Define a Constructor Function","chinese":"Use class Syntax to Define a Constructor Function"},{"english":"Use getters and setters to Control Access to an Object","chinese":"Use getters and setters to Control Access to an Object"},{"english":"Understand the Differences Between import and require","chinese":"Understand the Differences Between import and require"},{"english":"Use export to Reuse a Code Block","chinese":"Use export to Reuse a Code Block"},{"english":"Use * to Import Everything from a File","chinese":"Use * to Import Everything from a File"},{"english":"Create an Export Fallback with export default","chinese":"Create an Export Fallback with export default"},{"english":"Import a Default Export","chinese":"Import a Default Export"},{"english":"Introduction to the Regular Expression Challenges","chinese":"Introduction to the Regular Expression Challenges"},{"english":"Using the Test Method","chinese":"Using the Test Method"},{"english":"Match Literal Strings","chinese":"Match Literal Strings"},{"english":"Match a Literal String with Different Possibilities","chinese":"Match a Literal String with Different Possibilities"},{"english":"Ignore Case While Matching","chinese":"Ignore Case While Matching"},{"english":"Extract Matches","chinese":"Extract Matches"},{"english":"Find More Than the First Match","chinese":"Find More Than the First Match"},{"english":"Match Anything with Wildcard Period","chinese":"Match Anything with Wildcard Period"},{"english":"Match Single Character with Multiple Possibilities","chinese":"Match Single Character with Multiple Possibilities"},{"english":"Match Letters of the Alphabet","chinese":"Match Letters of the Alphabet"},{"english":"Match Numbers and Letters of the Alphabet","chinese":"Match Numbers and Letters of the Alphabet"},{"english":"Match Single Characters Not Specified","chinese":"Match Single Characters Not Specified"},{"english":"Match Characters that Occur One or More Times","chinese":"Match Characters that Occur One or More Times"},{"english":"Match Characters that Occur Zero or More Times","chinese":"Match Characters that Occur Zero or More Times"},{"english":"Find Characters with Lazy Matching","chinese":"Find Characters with Lazy Matching"},{"english":"Find One or More Criminals in a Hunt","chinese":"Find One or More Criminals in a Hunt"},{"english":"Match Beginning String Patterns","chinese":"Match Beginning String Patterns"},{"english":"Match Ending String Patterns","chinese":"Match Ending String Patterns"},{"english":"Match All Letters and Numbers","chinese":"Match All Letters and Numbers"},{"english":"Match Everything But Letters and Numbers","chinese":"Match Everything But Letters and Numbers"},{"english":"Match All Numbers","chinese":"Match All Numbers"},{"english":"Match All Non-Numbers","chinese":"Match All Non-Numbers"},{"english":"Restrict Possible Usernames","chinese":"Restrict Possible Usernames"},{"english":"Match Whitespace","chinese":"Match Whitespace"},{"english":"Match Non-Whitespace Characters","chinese":"Match Non-Whitespace Characters"},{"english":"Specify Upper and Lower Number of Matches","chinese":"Specify Upper and Lower Number of Matches"},{"english":"Specify Only the Lower Number of Matches","chinese":"Specify Only the Lower Number of Matches"},{"english":"Specify Exact Number of Matches","chinese":"Specify Exact Number of Matches"},{"english":"Check for All or None","chinese":"Check for All or None"},{"english":"Positive and Negative Lookahead","chinese":"Positive and Negative Lookahead"},{"english":"Reuse Patterns Using Capture Groups","chinese":"Reuse Patterns Using Capture Groups"},{"english":"Use Capture Groups to Search and Replace","chinese":"Use Capture Groups to Search and Replace"},{"english":"Remove Whitespace from Start and End","chinese":"Remove Whitespace from Start and End"},{"english":"Introduction to the Debugging Challenges","chinese":"Introduction to the Debugging Challenges"},{"english":"Use the JavaScript Console to Check the Value of a Variable","chinese":"Use the JavaScript Console to Check the Value of a Variable"},{"english":"Understanding the Differences between the freeCodeCamp and Browser Console","chinese":"Understanding the Differences between the freeCodeCamp and Browser Console"},{"english":"Use typeof to Check the Type of a Variable","chinese":"Use typeof to Check the Type of a Variable"},{"english":"Catch Misspelled Variable and Function Names","chinese":"Catch Misspelled Variable and Function Names"},{"english":"Catch Unclosed Parentheses","chinese":"Catch Unclosed Parentheses"},{"english":"Catch Mixed Usage of Single and Double Quotes","chinese":"Catch Mixed Usage of Single and Double Quotes"},{"english":"Catch Use of Assignment Operator Instead of Equality Operator","chinese":"Catch Use of Assignment Operator Instead of Equality Operator"},{"english":"Catch Missing Open and Closing Parenthesis After a Function Call","chinese":"Catch Missing Open and Closing Parenthesis After a Function Call"},{"english":"Catch Arguments Passed in the Wrong Order When Calling a Function","chinese":"Catch Arguments Passed in the Wrong Order When Calling a Function"},{"english":"Catch Off By One Errors When Using Indexing","chinese":"Catch Off By One Errors When Using Indexing"},{"english":"Use Caution When Reinitializing Variables Inside a Loop","chinese":"Use Caution When Reinitializing Variables Inside a Loop"},{"english":"Prevent Infinite Loops with a Valid Terminal Condition","chinese":"Prevent Infinite Loops with a Valid Terminal Condition"},{"english":"Introduction to the Basic Data Structure Challenges","chinese":"Introduction to the Basic Data Structure Challenges"},{"english":"Use an Array to Store a Collection of Data","chinese":"Use an Array to Store a Collection of Data"},{"english":"Access an Array's Contents Using Bracket Notation","chinese":"Access an Array's Contents Using Bracket Notation"},{"english":"Add Items to an Array with push() and unshift()","chinese":"Add Items to an Array with push() and unshift()"},{"english":"Remove Items from an Array with pop() and shift()","chinese":"Remove Items from an Array with pop() and shift()"},{"english":"Remove Items Using splice()","chinese":"Remove Items Using splice()"},{"english":"Add Items Using splice()","chinese":"Add Items Using splice()"},{"english":"Copy Array Items Using slice()","chinese":"Copy Array Items Using slice()"},{"english":"Copy an Array with the Spread Operator","chinese":"Copy an Array with the Spread Operator"},{"english":"Combine Arrays with the Spread Operator","chinese":"Combine Arrays with the Spread Operator"},{"english":"Check For The Presence of an Element With indexOf()","chinese":"Check For The Presence of an Element With indexOf()"},{"english":"Iterate Through All an Array's Items Using For Loops","chinese":"Iterate Through All an Array's Items Using For Loops"},{"english":"Create complex multi-dimensional arrays","chinese":"Create complex multi-dimensional arrays"},{"english":"Add Key-Value Pairs to JavaScript Objects","chinese":"Add Key-Value Pairs to JavaScript Objects"},{"english":"Modify an Object Nested Within an Object","chinese":"Modify an Object Nested Within an Object"},{"english":"Access Property Names with Bracket Notation","chinese":"Access Property Names with Bracket Notation"},{"english":"Use the delete Keyword to Remove Object Properties","chinese":"Use the delete Keyword to Remove Object Properties"},{"english":"Check if an Object has a Property","chinese":"Check if an Object has a Property"},{"english":" Iterate Through the Keys of an Object with a for...in Statement","chinese":" Iterate Through the Keys of an Object with a for...in Statement"},{"english":"Generate an Array of All Object Keys with Object.keys()","chinese":"Generate an Array of All Object Keys with Object.keys()"},{"english":"Modify an Array Stored in an Object","chinese":"Modify an Array Stored in an Object"},{"english":"Introduction to Basic Algorithm Scripting","chinese":"Introduction to Basic Algorithm Scripting"},{"english":"Convert Celsius to Fahrenheit","chinese":"Convert Celsius to Fahrenheit"},{"english":"Reverse a String","chinese":"Reverse a String"},{"english":"Factorialize a Number","chinese":"Factorialize a Number"},{"english":"Find the Longest Word in a String","chinese":"Find the Longest Word in a String"},{"english":"Return Largest Numbers in Arrays","chinese":"Return Largest Numbers in Arrays"},{"english":"Confirm the Ending","chinese":"Confirm the Ending"},{"english":"Repeat a String Repeat a String","chinese":"Repeat a String Repeat a String"},{"english":"Truncate a String","chinese":"Truncate a String"},{"english":"Finders Keepers","chinese":"Finders Keepers"},{"english":"Boo who","chinese":"Boo who"},{"english":"Title Case a Sentence","chinese":"Title Case a Sentence"},{"english":"Slice and Splice","chinese":"Slice and Splice"},{"english":"Falsy Bouncer","chinese":"Falsy Bouncer"},{"english":"Where do I Belong","chinese":"Where do I Belong"},{"english":"Mutations","chinese":"Mutations"},{"english":"Chunky Monkey","chinese":"Chunky Monkey"},{"english":"Introduction to the Object Oriented Programming Challenges","chinese":"Introduction to the Object Oriented Programming Challenges"},{"english":"Create a Basic JavaScript Object","chinese":"Create a Basic JavaScript Object"},{"english":"Use Dot Notation to Access the Properties of an Object","chinese":"Use Dot Notation to Access the Properties of an Object"},{"english":"Create a Method on an Object","chinese":"Create a Method on an Object"},{"english":"Make Code More Reusable with the this Keyword","chinese":"Make Code More Reusable with the this Keyword"},{"english":"Define a Constructor Function","chinese":"Define a Constructor Function"},{"english":"Use a Constructor to Create Objects","chinese":"Use a Constructor to Create Objects"},{"english":"Extend Constructors to Receive Arguments","chinese":"Extend Constructors to Receive Arguments"},{"english":"Verify an Object's Constructor with instanceof","chinese":"Verify an Object's Constructor with instanceof"},{"english":"Understand Own Properties","chinese":"Understand Own Properties"},{"english":"Use Prototype Properties to Reduce Duplicate Code","chinese":"Use Prototype Properties to Reduce Duplicate Code"},{"english":"Iterate Over All Properties","chinese":"Iterate Over All Properties"},{"english":"Understand the Constructor Property","chinese":"Understand the Constructor Property"},{"english":"Change the Prototype to a New Object","chinese":"Change the Prototype to a New Object"},{"english":"Remember to Set the Constructor Property when Changing the Prototype","chinese":"Remember to Set the Constructor Property when Changing the Prototype"},{"english":"Understand Where an Object’s Prototype Comes From","chinese":"Understand Where an Object’s Prototype Comes From"},{"english":"Understand the Prototype Chain","chinese":"Understand the Prototype Chain"},{"english":"Use Inheritance So You Don't Repeat Yourself","chinese":"Use Inheritance So You Don't Repeat Yourself"},{"english":"Inherit Behaviors from a Supertype","chinese":"Inherit Behaviors from a Supertype"},{"english":"Set the Child's Prototype to an Instance of the Parent","chinese":"Set the Child's Prototype to an Instance of the Parent"},{"english":"Reset an Inherited Constructor Property","chinese":"Reset an Inherited Constructor Property"},{"english":"Add Methods After Inheritance","chinese":"Add Methods After Inheritance"},{"english":"Override Inherited Methods","chinese":"Override Inherited Methods"},{"english":"Use a Mixin to Add Common Behavior Between Unrelated Objects","chinese":"Use a Mixin to Add Common Behavior Between Unrelated Objects"},{"english":"Use Closure to Protect Properties Within an Object from Being Modified Externally","chinese":"Use Closure to Protect Properties Within an Object from Being Modified Externally"},{"english":"Understand the Immediately Invoked Function Expression (IIFE)","chinese":"Understand the Immediately Invoked Function Expression (IIFE)"},{"english":"Use an IIFE to Create a Module","chinese":"Use an IIFE to Create a Module"},{"english":"Introduction to the Functional Programming Challenges","chinese":"Introduction to the Functional Programming Challenges"},{"english":"Learn About Functional Programming","chinese":"Learn About Functional Programming"},{"english":"Understand Functional Programming Terminology","chinese":"Understand Functional Programming Terminology"},{"english":"Understand the Hazards of Using Imperative Code","chinese":"Understand the Hazards of Using Imperative Code"},{"english":"Avoid Mutations and Side Effects Using Functional Programming","chinese":"Avoid Mutations and Side Effects Using Functional Programming"},{"english":"Pass Arguments to Avoid External Dependence in a Function","chinese":"Pass Arguments to Avoid External Dependence in a Function"},{"english":"Refactor Global Variables Out of Functions","chinese":"Refactor Global Variables Out of Functions"},{"english":"Use the map Method to Extract Data from an Array","chinese":"Use the map Method to Extract Data from an Array"},{"english":"Implement map on a Prototype","chinese":"Implement map on a Prototype"},{"english":"Use the filter Method to Extract Data from an Array","chinese":"Use the filter Method to Extract Data from an Array"},{"english":"Implement the filter Method on a Prototype","chinese":"Implement the filter Method on a Prototype"},{"english":"Return Part of an Array Using the slice Method","chinese":"Return Part of an Array Using the slice Method"},{"english":"Remove Elements from an Array Using slice Instead of splice","chinese":"Remove Elements from an Array Using slice Instead of splice"},{"english":"Combine Two Arrays Using the concat Method","chinese":"Combine Two Arrays Using the concat Method"},{"english":"Add Elements to the End of an Array Using concat Instead of push","chinese":"Add Elements to the End of an Array Using concat Instead of push"},{"english":"Use the reduce Method to Analyze Data","chinese":"Use the reduce Method to Analyze Data"},{"english":"Sort an Array Alphabetically using the sort Method","chinese":"Sort an Array Alphabetically using the sort Method"},{"english":"Return a Sorted Array Without Changing the Original Array","chinese":"Return a Sorted Array Without Changing the Original Array"},{"english":"Split a String into an Array Using the split Method","chinese":"Split a String into an Array Using the split Method"},{"english":"Combine an Array into a String Using the join Method","chinese":"Combine an Array into a String Using the join Method"},{"english":"Apply Functional Programming to Convert Strings to URL Slugs","chinese":"Apply Functional Programming to Convert Strings to URL Slugs"},{"english":"Use the every Method to Check that Every Element in an Array Meets a Criteria","chinese":"Use the every Method to Check that Every Element in an Array Meets a Criteria"},{"english":"Use the some Method to Check that Any Elements in an Array Meet a Criteria","chinese":"Use the some Method to Check that Any Elements in an Array Meet a Criteria"},{"english":"Introduction to Currying and Partial Application","chinese":"Introduction to Currying and Partial Application"},{"english":"Introduction to the Intermediate Algorithm Scripting Challenges","chinese":"Introduction to the Intermediate Algorithm Scripting Challenges"},{"english":"Sum All Numbers in a Range","chinese":"Sum All Numbers in a Range"},{"english":"Diff Two Arrays","chinese":"Diff Two Arrays"},{"english":"Seek and Destroy","chinese":"Seek and Destroy"},{"english":"Wherefore art thou","chinese":"Wherefore art thou"},{"english":"Spinal Tap Case","chinese":"Spinal Tap Case"},{"english":"Pig Latin","chinese":"Pig Latin"},{"english":"Search and Replace","chinese":"Search and Replace"},{"english":"DNA Pairing","chinese":"DNA Pairing"},{"english":"Missing letters","chinese":"Missing letters"},{"english":"Sorted Union","chinese":"Sorted Union"},{"english":"Convert HTML Entities","chinese":"Convert HTML Entities"},{"english":"Sum All Odd Fibonacci Numbers","chinese":"Sum All Odd Fibonacci Numbers"},{"english":"Sum All Primes","chinese":"Sum All Primes"},{"english":"Smallest Common Multiple","chinese":"Smallest Common Multiple"},{"english":"Drop it","chinese":"Drop it"},{"english":"Steamroller","chinese":"Steamroller"},{"english":"Binary Agents","chinese":"Binary Agents"},{"english":"Everything Be True","chinese":"Everything Be True"},{"english":"Arguments Optional","chinese":"Arguments Optional"},{"english":"Make a Person","chinese":"Make a Person"},{"english":"Map the Debris","chinese":"Map the Debris"},{"english":"Introduction to the JavaScript Algorithms and Data Structures Projects","chinese":"Introduction to the JavaScript Algorithms and Data Structures Projects"},{"english":"Palindrome Checker","chinese":"Palindrome Checker"},{"english":"Roman Numeral Converter","chinese":"Roman Numeral Converter"},{"english":"Caesars Cipher","chinese":"Caesars Cipher"},{"english":"Telephone Number Validator","chinese":"Telephone Number Validator"},{"english":"Cash Register","chinese":"Cash Register"},{"english":"Introduction to the Bootstrap Challenges","chinese":"Introduction to the Bootstrap Challenges"},{"english":"Use Responsive Design with Bootstrap Fluid Containers","chinese":"Use Responsive Design with Bootstrap Fluid Containers"},{"english":"Make Images Mobile Responsive","chinese":"Make Images Mobile Responsive"},{"english":"Center Text with Bootstrap","chinese":"Center Text with Bootstrap"},{"english":"Create a Bootstrap Button","chinese":"Create a Bootstrap Button"},{"english":"Create a Block Element Bootstrap Button","chinese":"Create a Block Element Bootstrap Button"},{"english":"Taste the Bootstrap Button Color Rainbow","chinese":"Taste the Bootstrap Button Color Rainbow"},{"english":"Call out Optional Actions with btn-info","chinese":"Call out Optional Actions with btn-info"},{"english":"Warn Your Users of a Dangerous Action with btn-danger","chinese":"Warn Your Users of a Dangerous Action with btn-danger"},{"english":"Use the Bootstrap Grid to Put Elements Side By Side","chinese":"Use the Bootstrap Grid to Put Elements Side By Side"},{"english":"Ditch Custom CSS for Bootstrap","chinese":"Ditch Custom CSS for Bootstrap"},{"english":"Use a span to Target Inline Elements","chinese":"Use a span to Target Inline Elements"},{"english":"Create a Custom Heading","chinese":"Create a Custom Heading"},{"english":"Add Font Awesome Icons to our Buttons","chinese":"Add Font Awesome Icons to our Buttons"},{"english":"Add Font Awesome Icons to all of our Buttons","chinese":"Add Font Awesome Icons to all of our Buttons"},{"english":"Responsively Style Radio Buttons","chinese":"Responsively Style Radio Buttons"},{"english":"Responsively Style Checkboxes","chinese":"Responsively Style Checkboxes"},{"english":"Style Text Inputs as Form Controls","chinese":"Style Text Inputs as Form Controls"},{"english":"Line up Form Elements Responsively with Bootstrap","chinese":"Line up Form Elements Responsively with Bootstrap"},{"english":"Create a Bootstrap Headline","chinese":"Create a Bootstrap Headline"},{"english":"House our page within a Bootstrap container-fluid div","chinese":"House our page within a Bootstrap container-fluid div"},{"english":"Create a Bootstrap Row","chinese":"Create a Bootstrap Row"},{"english":"Split Your Bootstrap Row","chinese":"Split Your Bootstrap Row"},{"english":"Create Bootstrap Wells","chinese":"Create Bootstrap Wells"},{"english":"Add Elements within Your Bootstrap Wells","chinese":"Add Elements within Your Bootstrap Wells"},{"english":"Apply the Default Bootstrap Button Style","chinese":"Apply the Default Bootstrap Button Style"},{"english":"Create a Class to Target with jQuery Selectors","chinese":"Create a Class to Target with jQuery Selectors"},{"english":"Add id Attributes to Bootstrap Elements","chinese":"Add id Attributes to Bootstrap Elements"},{"english":"Label Bootstrap Wells","chinese":"Label Bootstrap Wells"},{"english":"Give Each Element a Unique id","chinese":"Give Each Element a Unique id"},{"english":"Label Bootstrap Buttons","chinese":"Label Bootstrap Buttons"},{"english":"Use Comments to Clarify Code","chinese":"Use Comments to Clarify Code"},{"english":"Introduction to jQuery","chinese":"Introduction to jQuery"},{"english":"Learn How Script Tags and Document Ready Work","chinese":"Learn How Script Tags and Document Ready Work"},{"english":"Target HTML Elements with Selectors Using jQuery","chinese":"Target HTML Elements with Selectors Using jQuery"},{"english":"Target Elements by Class Using jQuery","chinese":"Target Elements by Class Using jQuery"},{"english":"Target Elements by id Using jQuery","chinese":"Target Elements by id Using jQuery"},{"english":"Delete Your jQuery Functions","chinese":"Delete Your jQuery Functions"},{"english":"Target the Same Element with Multiple jQuery Selectors","chinese":"Target the Same Element with Multiple jQuery Selectors"},{"english":"Remove Classes from an Element with jQuery","chinese":"Remove Classes from an Element with jQuery"},{"english":"Change the CSS of an Element Using jQuery","chinese":"Change the CSS of an Element Using jQuery"},{"english":"Disable an Element Using jQuery","chinese":"Disable an Element Using jQuery"},{"english":"Change Text Inside an Element Using jQuery","chinese":"Change Text Inside an Element Using jQuery"},{"english":"Remove an Element Using jQuery","chinese":"Remove an Element Using jQuery"},{"english":"Use appendTo to Move Elements with jQuery","chinese":"Use appendTo to Move Elements with jQuery"},{"english":"Clone an Element Using jQuery","chinese":"Clone an Element Using jQuery"},{"english":"Target the Parent of an Element Using jQuery","chinese":"Target the Parent of an Element Using jQuery"},{"english":"Target the Children of an Element Using jQuery","chinese":"Target the Children of an Element Using jQuery"},{"english":"Target a Specific Child of an Element Using jQuery","chinese":"Target a Specific Child of an Element Using jQuery"},{"english":"Target Even Elements Using jQuery","chinese":"Target Even Elements Using jQuery"},{"english":"Use jQuery to Modify the Entire Page","chinese":"Use jQuery to Modify the Entire Page"},{"english":"Introduction to the Sass Challenges","chinese":"Introduction to the Sass Challenges"},{"english":"Store Data with Sass Variables","chinese":"Store Data with Sass Variables"},{"english":"Nest CSS with Sass","chinese":"Nest CSS with Sass"},{"english":"Create Reusable CSS with Mixins","chinese":"Create Reusable CSS with Mixins"},{"english":"Use @if and @else to Add Logic To Your Styles","chinese":"Use @if and @else to Add Logic To Your Styles"},{"english":"Use @for to Create a Sass Loop","chinese":"Use @for to Create a Sass Loop"},{"english":"Use @each to Map Over Items in a List","chinese":"Use @each to Map Over Items in a List"},{"english":"Apply a Style Until a Condition is Met with @while","chinese":"Apply a Style Until a Condition is Met with @while"},{"english":"Split Your Styles into Smaller Chunks with Partials","chinese":"Split Your Styles into Smaller Chunks with Partials"},{"english":"Extend One Set of CSS Styles to Another Element","chinese":"Extend One Set of CSS Styles to Another Element"},{"english":"Introduction to the React Challenges","chinese":"Introduction to the React Challenges"},{"english":"Create a Simple JSX Element","chinese":"Create a Simple JSX Element"},{"english":"Create a Complex JSX Element","chinese":"Create a Complex JSX Element"},{"english":"Add Comments in JSX","chinese":"Add Comments in JSX"},{"english":"Render HTML Elements to the DOM","chinese":"Render HTML Elements to the DOM"},{"english":"Define an HTML Class in JSX","chinese":"Define an HTML Class in JSX"},{"english":"Learn About Self-Closing JSX Tags","chinese":"Learn About Self-Closing JSX Tags"},{"english":"Create a Stateless Functional Component","chinese":"Create a Stateless Functional Component"},{"english":"Create a React Component","chinese":"Create a React Component"},{"english":"Create a Component with Composition","chinese":"Create a Component with Composition"},{"english":"Use React to Render Nested Components","chinese":"Use React to Render Nested Components"},{"english":"Compose React Components","chinese":"Compose React Components"},{"english":"Render a Class Component to the DOM","chinese":"Render a Class Component to the DOM"},{"english":"Write a React Component from Scratch","chinese":"Write a React Component from Scratch"},{"english":"Pass Props to a Stateless Functional Component","chinese":"Pass Props to a Stateless Functional Component"},{"english":"Pass an Array as Props","chinese":"Pass an Array as Props"},{"english":"Use Default Props","chinese":"Use Default Props"},{"english":"Override Default Props","chinese":"Override Default Props"},{"english":"Use PropTypes to Define the Props You Expect","chinese":"Use PropTypes to Define the Props You Expect"},{"english":"Access Props Using this.props","chinese":"Access Props Using this.props"},{"english":"Review Using Props with Stateless Functional Components","chinese":"Review Using Props with Stateless Functional Components"},{"english":"Create a Stateful Component","chinese":"Create a Stateful Component"},{"english":"Render State in the User Interface","chinese":"Render State in the User Interface"},{"english":"Render State in the User Interface Another Way","chinese":"Render State in the User Interface Another Way"},{"english":"Set State with this.setState","chinese":"Set State with this.setState"},{"english":"Bind 'this' to a Class Method","chinese":"Bind 'this' to a Class Method"},{"english":"Use State to Toggle an Element","chinese":"Use State to Toggle an Element"},{"english":"Write a Simple Counter","chinese":"Write a Simple Counter"},{"english":"Create a Controlled Input","chinese":"Create a Controlled Input"},{"english":"Create a Controlled Form","chinese":"Create a Controlled Form"},{"english":"Pass State as Props to Child Components","chinese":"Pass State as Props to Child Components"},{"english":"Pass a Callback as Props","chinese":"Pass a Callback as Props"},{"english":"Use the Lifecycle Method componentWillMount","chinese":"Use the Lifecycle Method componentWillMount"},{"english":"Use the Lifecycle Method componentDidMount","chinese":"Use the Lifecycle Method componentDidMount"},{"english":"Add Event Listeners","chinese":"Add Event Listeners"},{"english":"Manage Updates with Lifecycle Methods","chinese":"Manage Updates with Lifecycle Methods"},{"english":"Optimize Re-Renders with shouldComponentUpdate","chinese":"Optimize Re-Renders with shouldComponentUpdate"},{"english":"Introducing Inline Styles","chinese":"Introducing Inline Styles"},{"english":"Add Inline Styles in React","chinese":"Add Inline Styles in React"},{"english":"Use Advanced JavaScript in React Render Method","chinese":"Use Advanced JavaScript in React Render Method"},{"english":"Render with an If/Else Condition","chinese":"Render with an If/Else Condition"},{"english":"Use && for a More Concise Conditional","chinese":"Use && for a More Concise Conditional"},{"english":"Use a Ternary Expression for Conditional Rendering","chinese":"Use a Ternary Expression for Conditional Rendering"},{"english":"Render Conditionally from Props","chinese":"Render Conditionally from Props"},{"english":"Change Inline CSS Conditionally Based on Component State","chinese":"Change Inline CSS Conditionally Based on Component State"},{"english":"Use Array.map() to Dynamically Render Elements","chinese":"Use Array.map() to Dynamically Render Elements"},{"english":"Give Sibling Elements a Unique Key Attribute","chinese":"Give Sibling Elements a Unique Key Attribute"},{"english":"Use Array.filter() to Dynamically Filter an Array","chinese":"Use Array.filter() to Dynamically Filter an Array"},{"english":"Render React on the Server with renderToString","chinese":"Render React on the Server with renderToString"},{"english":"Introduction to the Redux Challenges","chinese":"Introduction to the Redux Challenges"},{"english":"Create a Redux Store","chinese":"Create a Redux Store"},{"english":"Get State from the Redux Store","chinese":"Get State from the Redux Store"},{"english":"Define a Redux Action","chinese":"Define a Redux Action"},{"english":"Define an Action Creator","chinese":"Define an Action Creator"},{"english":"Dispatch an Action Event","chinese":"Dispatch an Action Event"},{"english":"Handle an Action in the Store","chinese":"Handle an Action in the Store"},{"english":"Use a Switch Statement to Handle Multiple Actions","chinese":"Use a Switch Statement to Handle Multiple Actions"},{"english":"Use const for Action Types","chinese":"Use const for Action Types"},{"english":"Register a Store Listener","chinese":"Register a Store Listener"},{"english":"Combine Multiple Reducers","chinese":"Combine Multiple Reducers"},{"english":"Send Action Data to the Store","chinese":"Send Action Data to the Store"},{"english":"Use Middleware to Handle Asynchronous Actions","chinese":"Use Middleware to Handle Asynchronous Actions"},{"english":"Write a Counter with Redux","chinese":"Write a Counter with Redux"},{"english":"Never Mutate State","chinese":"Never Mutate State"},{"english":"Use the Spread Operator on Arrays","chinese":"Use the Spread Operator on Arrays"},{"english":"Remove an Item from an Array","chinese":"Remove an Item from an Array"},{"english":"Copy an Object with Object.assign","chinese":"Copy an Object with Object.assign"},{"english":"Introduction to the React and Redux Challenges","chinese":"Introduction to the React and Redux Challenges"},{"english":"Getting Started with React Redux","chinese":"Getting Started with React Redux"},{"english":"Manage State Locally First","chinese":"Manage State Locally First"},{"english":"Extract State Logic to Redux","chinese":"Extract State Logic to Redux"},{"english":"Use Provider to Connect Redux to React","chinese":"Use Provider to Connect Redux to React"},{"english":"Map State to Props","chinese":"Map State to Props"},{"english":"Map Dispatch to Props","chinese":"Map Dispatch to Props"},{"english":"Connect Redux to React","chinese":"Connect Redux to React"},{"english":"Connect Redux to the Messages App","chinese":"Connect Redux to the Messages App"},{"english":"Extract Local State into Redux","chinese":"Extract Local State into Redux"},{"english":"Moving Forward From Here","chinese":"Moving Forward From Here"},{"english":"Introduction to the Front End Libraries Projects","chinese":"Introduction to the Front End Libraries Projects"},{"english":"Build a Random Quote Machine","chinese":"Build a Random Quote Machine"},{"english":"Build a Markdown Previewer","chinese":"Build a Markdown Previewer"},{"english":"Build a Drum Machine","chinese":"Build a Drum Machine"},{"english":"Build a JavaScript Calculator","chinese":"Build a JavaScript Calculator"},{"english":"Build a Pomodoro Clock","chinese":"Build a Pomodoro Clock"},{"english":"Introduction to the Data Visualization with D3 Challenges","chinese":"Introduction to the Data Visualization with D3 Challenges"},{"english":"Add Document Elements with D3","chinese":"Add Document Elements with D3"},{"english":"Select a Group of Elements with D3","chinese":"Select a Group of Elements with D3"},{"english":"Work with Data in D3","chinese":"Work with Data in D3"},{"english":"Work with Dynamic Data in D3","chinese":"Work with Dynamic Data in D3"},{"english":"Add Inline Styling to Elements","chinese":"Add Inline Styling to Elements"},{"english":"Change Styles Based on Data","chinese":"Change Styles Based on Data"},{"english":"Add Classes with D3","chinese":"Add Classes with D3"},{"english":"Update the Height of an Element Dynamically","chinese":"Update the Height of an Element Dynamically"},{"english":"Change the Presentation of a Bar Chart","chinese":"Change the Presentation of a Bar Chart"},{"english":"Learn About SVG in D3","chinese":"Learn About SVG in D3"},{"english":"Display Shapes with SVG","chinese":"Display Shapes with SVG"},{"english":"Create a Bar for Each Data Point in the Set","chinese":"Create a Bar for Each Data Point in the Set"},{"english":"Dynamically Set the Coordinates for Each Bar","chinese":"Dynamically Set the Coordinates for Each Bar"},{"english":"Dynamically Change the Height of Each Bar","chinese":"Dynamically Change the Height of Each Bar"},{"english":"Invert SVG Elements","chinese":"Invert SVG Elements"},{"english":"Change the Color of an SVG Element","chinese":"Change the Color of an SVG Element"},{"english":"Add Labels to D3 Elements","chinese":"Add Labels to D3 Elements"},{"english":"Style D3 Labels","chinese":"Style D3 Labels"},{"english":"Add a Hover Effect to a D3 Element","chinese":"Add a Hover Effect to a D3 Element"},{"english":"Add a Tooltip to a D3 Element","chinese":"Add a Tooltip to a D3 Element"},{"english":"Create a Scatterplot with SVG Circles","chinese":"Create a Scatterplot with SVG Circles"},{"english":"Add Attributes to the Circle Elements","chinese":"Add Attributes to the Circle Elements"},{"english":"Add Labels to Scatter Plot Circles","chinese":"Add Labels to Scatter Plot Circles"},{"english":"Create a Linear Scale with D3","chinese":"Create a Linear Scale with D3"},{"english":"Set a Domain and a Range on a Scale","chinese":"Set a Domain and a Range on a Scale"},{"english":"Use the d3.max and d3.min Functions to Find Minimum and Maximum Values in a Dataset","chinese":"Use the d3.max and d3.min Functions to Find Minimum and Maximum Values in a Dataset"},{"english":"Use Dynamic Scales","chinese":"Use Dynamic Scales"},{"english":"Use a Pre-Defined Scale to Place Elements","chinese":"Use a Pre-Defined Scale to Place Elements"},{"english":"Add Axes to a Visualization","chinese":"Add Axes to a Visualization"},{"english":"Introduction to the JSON APIs and AJAX Challenges","chinese":"Introduction to the JSON APIs and AJAX Challenges"},{"english":"Handle Click Events with JavaScript using the onclick property","chinese":"Handle Click Events with JavaScript using the onclick property"},{"english":"Change Text with click Events","chinese":"Change Text with click Events"},{"english":"Get JSON with the JavaScript XMLHttpRequest Method","chinese":"Get JSON with the JavaScript XMLHttpRequest Method"},{"english":"Access the JSON Data from an API","chinese":"Access the JSON Data from an API"},{"english":"Convert JSON Data to HTML","chinese":"Convert JSON Data to HTML"},{"english":"Render Images from Data Sources","chinese":"Render Images from Data Sources"},{"english":"Pre-filter JSON to Get the Data You Need","chinese":"Pre-filter JSON to Get the Data You Need"},{"english":"Get Geolocation Data to Find A User's GPS Coordinates","chinese":"Get Geolocation Data to Find A User's GPS Coordinates"},{"english":"Post Data with the JavaScript XMLHttpRequest Method","chinese":"Post Data with the JavaScript XMLHttpRequest Method"},{"english":"Introduction to the Data Visualization Projects","chinese":"Introduction to the Data Visualization Projects"},{"english":"Visualize Data with a Bar Chart","chinese":"Visualize Data with a Bar Chart"},{"english":"Visualize Data with a Scatterplot Graph","chinese":"Visualize Data with a Scatterplot Graph"},{"english":"Visualize Data with a Heat Map","chinese":"Visualize Data with a Heat Map"},{"english":"Visualize Data with a Choropleth Map","chinese":"Visualize Data with a Choropleth Map"},{"english":"Visualize Data with a Treemap Diagram","chinese":"Visualize Data with a Treemap Diagram"},{"english":"Introduction to the Managing Packages with npm Challenges","chinese":"Introduction to the Managing Packages with npm Challenges"},{"english":"How to Use package.json","chinese":"How to Use package.json"},{"english":"Add a Description to Your package.json","chinese":"Add a Description to Your package.json"},{"english":"Add Keywords to Your package.json","chinese":"Add Keywords to Your package.json"},{"english":"Add a License to Your package.json","chinese":"Add a License to Your package.json"},{"english":"Add a Version to Your package.json","chinese":"Add a Version to Your package.json"},{"english":"Expand Your Project with External Packages from npm","chinese":"Expand Your Project with External Packages from npm"},{"english":"Manage npm Dependencies By Understanding Semantic Versioning","chinese":"Manage npm Dependencies By Understanding Semantic Versioning"},{"english":"Use the Tilde-Character to Always Use the Latest Patch Version of a Dependency","chinese":"Use the Tilde-Character to Always Use the Latest Patch Version of a Dependency"},{"english":"Use the Caret-Character to Use the Latest Minor Version of a Dependency","chinese":"Use the Caret-Character to Use the Latest Minor Version of a Dependency"},{"english":"Remove a Package from Your Dependencies","chinese":"Remove a Package from Your Dependencies"},{"english":"Introduction to the Basic Node and Express Challenges","chinese":"Introduction to the Basic Node and Express Challenges"},{"english":"Meet the Node console","chinese":"Meet the Node console"},{"english":"Start a Working Express Server","chinese":"Start a Working Express Server"},{"english":"Serve an HTML File","chinese":"Serve an HTML File"},{"english":"Serve Static Assets","chinese":"Serve Static Assets"},{"english":"Serve JSON on a Specific Route","chinese":"Serve JSON on a Specific Route"},{"english":"Use the .env File","chinese":"Use the .env File"},{"english":"Implement a Root-Level Request Logger Middleware","chinese":"Implement a Root-Level Request Logger Middleware"},{"english":"Chain Middleware to Create a Time Server","chinese":"Chain Middleware to Create a Time Server"},{"english":"Get Route Parameter Input from the Client","chinese":"Get Route Parameter Input from the Client"},{"english":"Get Query Parameter Input from the Client","chinese":"Get Query Parameter Input from the Client"},{"english":"Use body-parser to Parse POST Requests","chinese":"Use body-parser to Parse POST Requests"},{"english":"Get Data from POST Requests","chinese":"Get Data from POST Requests"},{"english":"Introduction to the MongoDB and Mongoose Challenges","chinese":"Introduction to the MongoDB and Mongoose Challenges"},{"english":"Install and Set Up Mongoose","chinese":"Install and Set Up Mongoose"},{"english":"Create a Model","chinese":"Create a Model"},{"english":"Create and Save a Record of a Model","chinese":"Create and Save a Record of a Model"},{"english":"Create Many Records with model.create()","chinese":"Create Many Records with model.create()"},{"english":"Use model.find() to Search Your Database","chinese":"Use model.find() to Search Your Database"},{"english":"Use model.findOne() to Return a Single Matching Document from Your Database","chinese":"Use model.findOne() to Return a Single Matching Document from Your Database"},{"english":"Use model.findById() to Search Your Database By _id","chinese":"Use model.findById() to Search Your Database By _id"},{"english":"Perform Classic Updates by Running Find","chinese":"Perform Classic Updates by Running Find"},{"english":"Perform New Updates on a Document Using model.findOneAndUpdate()","chinese":"Perform New Updates on a Document Using model.findOneAndUpdate()"},{"english":"Delete One Document Using model.findByIdAndRemove","chinese":"Delete One Document Using model.findByIdAndRemove"},{"english":"Delete Many Documents with model.remove()","chinese":"Delete Many Documents with model.remove()"},{"english":"Chain Search Query Helpers to Narrow Search Results","chinese":"Chain Search Query Helpers to Narrow Search Results"},{"english":"Introduction to the APIs and Microservices Projects","chinese":"Introduction to the APIs and Microservices Projects"},{"english":"Timestamp Microservice","chinese":"Timestamp Microservice"},{"english":"Request Header Parser Microservice","chinese":"Request Header Parser Microservice"},{"english":"URL Shortener Microservice","chinese":"URL Shortener Microservice"},{"english":"Exercise Tracker","chinese":"Exercise Tracker"},{"english":"File Metadata Microservice","chinese":"File Metadata Microservice"},{"english":"Introduction to Information Security with HelmetJS Challenges","chinese":"Introduction to Information Security with HelmetJS Challenges"},{"english":"Install and Require Helmet","chinese":"Install and Require Helmet"},{"english":"Hide Potentially Dangerous Information Using helmet.hidePoweredBy()","chinese":"Hide Potentially Dangerous Information Using helmet.hidePoweredBy()"},{"english":"Mitigate the Risk of Clickjacking with helmet.frameguard()","chinese":"Mitigate the Risk of Clickjacking with helmet.frameguard()"},{"english":"Mitigate the Risk of Cross Site Scripting (XSS) Attacks with helmet.xssFilter()","chinese":"Mitigate the Risk of Cross Site Scripting (XSS) Attacks with helmet.xssFilter()"},{"english":"Avoid Inferring the Response MIME Type with helmet.noSniff()","chinese":"Avoid Inferring the Response MIME Type with helmet.noSniff()"},{"english":"Prevent IE from Opening Untrusted HTML with helmet.ieNoOpen()","chinese":"Prevent IE from Opening Untrusted HTML with helmet.ieNoOpen()"},{"english":"Ask Browsers to Access Your Site via HTTPS Only with helmet.hsts()","chinese":"Ask Browsers to Access Your Site via HTTPS Only with helmet.hsts()"},{"english":"Disable DNS Prefetching with helmet.dnsPrefetchControl()","chinese":"Disable DNS Prefetching with helmet.dnsPrefetchControl()"},{"english":"Disable Client-Side Caching with helmet.noCache()","chinese":"Disable Client-Side Caching with helmet.noCache()"},{"english":"Set a Content Security Policy with helmet.contentSecurityPolicy()","chinese":"Set a Content Security Policy with helmet.contentSecurityPolicy()"},{"english":"Configure Helmet Using the ‘parent’ helmet() Middleware","chinese":"Configure Helmet Using the ‘parent’ helmet() Middleware"},{"english":"Understand BCrypt Hashes","chinese":"Understand BCrypt Hashes"},{"english":"Hash and Compare Passwords Asynchronously","chinese":"Hash and Compare Passwords Asynchronously"},{"english":"Hash and Compare Passwords Synchronously","chinese":"Hash and Compare Passwords Synchronously"},{"english":"Introduction to the Quality Assurance with Chai Challenges","chinese":"Introduction to the Quality Assurance with Chai Challenges"},{"english":"Learn How JavaScript Assertions Work","chinese":"Learn How JavaScript Assertions Work"},{"english":"Test if a Variable or Function is Defined","chinese":"Test if a Variable or Function is Defined"},{"english":"Use Assert.isOK and Assert.isNotOK","chinese":"Use Assert.isOK and Assert.isNotOK"},{"english":"Test for Truthiness","chinese":"Test for Truthiness"},{"english":"Use the Double Equals to Assert Equality","chinese":"Use the Double Equals to Assert Equality"},{"english":"Use the Triple Equals to Assert Strict Equality","chinese":"Use the Triple Equals to Assert Strict Equality"},{"english":"Assert Deep Equality with .deepEqual and .notDeepEqual","chinese":"Assert Deep Equality with .deepEqual and .notDeepEqual"},{"english":"Compare the Properties of Two Elements","chinese":"Compare the Properties of Two Elements"},{"english":"Test if One Value is Below or At Least as Large as Another","chinese":"Test if One Value is Below or At Least as Large as Another"},{"english":"Test if a Value Falls within a Specific Range","chinese":"Test if a Value Falls within a Specific Range"},{"english":"Test if a Value is an Array","chinese":"Test if a Value is an Array"},{"english":"Test if an Array Contains an Item","chinese":"Test if an Array Contains an Item"},{"english":"Test if a Value is a String","chinese":"Test if a Value is a String"},{"english":"Test if a String Contains a Substring","chinese":"Test if a String Contains a Substring"},{"english":"Use Regular Expressions to Test a String","chinese":"Use Regular Expressions to Test a String"},{"english":"Test if an Object has a Property","chinese":"Test if an Object has a Property"},{"english":"Test if a Value is of a Specific Data Structure Type","chinese":"Test if a Value is of a Specific Data Structure Type"},{"english":"Test if an Object is an Instance of a Constructor","chinese":"Test if an Object is an Instance of a Constructor"},{"english":"Run Functional Tests on API Endpoints using Chai-HTTP","chinese":"Run Functional Tests on API Endpoints using Chai-HTTP"},{"english":"Run Functional Tests on API Endpoints using Chai-HTTP II","chinese":"Run Functional Tests on API Endpoints using Chai-HTTP II"},{"english":"Run Functional Tests on an API Response using Chai-HTTP III - PUT method","chinese":"Run Functional Tests on an API Response using Chai-HTTP III - PUT method"},{"english":"Run Functional Tests on an API Response using Chai-HTTP IV - PUT method","chinese":"Run Functional Tests on an API Response using Chai-HTTP IV - PUT method"},{"english":"Run Functional Tests using a Headless Browser","chinese":"Run Functional Tests using a Headless Browser"},{"english":"Run Functional Tests using a Headless Browser II","chinese":"Run Functional Tests using a Headless Browser II"},{"english":"Introduction to the Advances Node and Express Challenges","chinese":"Introduction to the Advances Node and Express Challenges"},{"english":"Set up a Template Engine","chinese":"Set up a Template Engine"},{"english":"Use a Template Engine's Powers","chinese":"Use a Template Engine's Powers"},{"english":"Set up Passport","chinese":"Set up Passport"},{"english":"Serialization of a User Object","chinese":"Serialization of a User Object"},{"english":"Implement the Serialization of a Passport User","chinese":"Implement the Serialization of a Passport User"},{"english":"Authentication Strategies","chinese":"Authentication Strategies"},{"english":"How to Use Passport Strategies","chinese":"How to Use Passport Strategies"},{"english":"Create New Middleware","chinese":"Create New Middleware"},{"english":"How to Put a Profile Together","chinese":"How to Put a Profile Together"},{"english":"Logging a User Out","chinese":"Logging a User Out"},{"english":"Registration of New Users","chinese":"Registration of New Users"},{"english":"Hashing Your Passwords","chinese":"Hashing Your Passwords"},{"english":"Clean Up Your Project with Modules","chinese":"Clean Up Your Project with Modules"},{"english":"Implementation of Social Authentication","chinese":"Implementation of Social Authentication"},{"english":"Implementation of Social Authentication II","chinese":"Implementation of Social Authentication II"},{"english":"Implementation of Social Authentication III","chinese":"Implementation of Social Authentication III"},{"english":"Set up the Environment","chinese":"Set up the Environment"},{"english":"Communicate by Emitting","chinese":"Communicate by Emitting"},{"english":"Handle a Disconnect","chinese":"Handle a Disconnect"},{"english":"Authentication with Socket.IO","chinese":"Authentication with Socket.IO"},{"english":"Announce New Users","chinese":"Announce New Users"},{"english":"Send and Display Chat Messages","chinese":"Send and Display Chat Messages"},{"english":"Introduction to the Information Security and Quality Assurance Projects","chinese":"Introduction to the Information Security and Quality Assurance Projects"},{"english":"Metric-Imperial Converter","chinese":"Metric-Imperial Converter"},{"english":"Issue Tracker","chinese":"Issue Tracker"},{"english":"Personal Library","chinese":"Personal Library"},{"english":"Stock Price Checker","chinese":"Stock Price Checker"},{"english":"Anonymous Message Board","chinese":"Anonymous Message Board"},{"english":"Introduction to the Coding Interview Algorithms","chinese":"Introduction to the Coding Interview Algorithms"},{"english":"Find the Symmetric Difference","chinese":"Find the Symmetric Difference"},{"english":"Inventory Update","chinese":"Inventory Update"},{"english":"No Repeats Please","chinese":"No Repeats Please"},{"english":"Pairwise","chinese":"Pairwise"},{"english":"Implement Bubble Sort","chinese":"Implement Bubble Sort"},{"english":"Implement Selection Sort","chinese":"Implement Selection Sort"},{"english":"Implement Insertion Sort","chinese":"Implement Insertion Sort"},{"english":"Implement Quick Sort","chinese":"Implement Quick Sort"},{"english":"Implement Merge Sort","chinese":"Implement Merge Sort"},{"english":"Introduction to the Coding Interview Data Structure Questions","chinese":"Introduction to the Coding Interview Data Structure Questions"},{"english":"Typed Arrays","chinese":"Typed Arrays"},{"english":"Learn how a Stack Works","chinese":"Learn how a Stack Works"},{"english":"Create a Stack Class","chinese":"Create a Stack Class"},{"english":"Create a Queue Class","chinese":"Create a Queue Class"},{"english":"Create a Priority Queue Class","chinese":"Create a Priority Queue Class"},{"english":"Create a Circular Queue","chinese":"Create a Circular Queue"},{"english":"Create a Set Class","chinese":"Create a Set Class"},{"english":"Remove from a Set","chinese":"Remove from a Set"},{"english":"Size of the Set","chinese":"Size of the Set"},{"english":"Perform a Union on Two Sets","chinese":"Perform a Union on Two Sets"},{"english":"Perform an Intersection on Two Sets of Data","chinese":"Perform an Intersection on Two Sets of Data"},{"english":"Perform a Difference on Two Sets of Data","chinese":"Perform a Difference on Two Sets of Data"},{"english":"Perform a Subset Check on Two Sets of Data","chinese":"Perform a Subset Check on Two Sets of Data"},{"english":"Create and Add to Sets in ES6","chinese":"Create and Add to Sets in ES6"},{"english":"Remove items from a set in ES6","chinese":"Remove items from a set in ES6"},{"english":"Use .has and .size on an ES6 Set","chinese":"Use .has and .size on an ES6 Set"},{"english":"Use Spread and Notes for ES5 Set() Integration","chinese":"Use Spread and Notes for ES5 Set() Integration"},{"english":"Create a Map Data Structure","chinese":"Create a Map Data Structure"},{"english":"Create an ES6 JavaScript Map","chinese":"Create an ES6 JavaScript Map"},{"english":"Create a Hash Table","chinese":"Create a Hash Table"},{"english":"Work with Nodes in a Linked List","chinese":"Work with Nodes in a Linked List"},{"english":"Create a Linked List Class","chinese":"Create a Linked List Class"},{"english":"Remove Elements from a Linked List","chinese":"Remove Elements from a Linked List"},{"english":"Search within a Linked List","chinese":"Search within a Linked List"},{"english":"Remove Elements from a Linked List by Index","chinese":"Remove Elements from a Linked List by Index"},{"english":"Add Elements at a Specific Index in a Linked List","chinese":"Add Elements at a Specific Index in a Linked List"},{"english":"Create a Doubly Linked List","chinese":"Create a Doubly Linked List"},{"english":"Reverse a Doubly Linked List","chinese":"Reverse a Doubly Linked List"},{"english":"Find the Minimum and Maximum Value in a Binary Search Tree","chinese":"Find the Minimum and Maximum Value in a Binary Search Tree"},{"english":"Add a New Element to a Binary Search Tree","chinese":"Add a New Element to a Binary Search Tree"},{"english":"Check if an Element is Present in a Binary Search Tree","chinese":"Check if an Element is Present in a Binary Search Tree"},{"english":"Find the Minimum and Maximum Height of a Binary Search Tree","chinese":"Find the Minimum and Maximum Height of a Binary Search Tree"},{"english":"Use Depth First Search in a Binary Search Tree","chinese":"Use Depth First Search in a Binary Search Tree"},{"english":"Use Breadth First Search in a Binary Search Tree","chinese":"Use Breadth First Search in a Binary Search Tree"},{"english":"Delete a Leaf Node in a Binary Search Tree","chinese":"Delete a Leaf Node in a Binary Search Tree"},{"english":"Delete a Node with One Child in a Binary Search Tree","chinese":"Delete a Node with One Child in a Binary Search Tree"},{"english":"Delete a Node with Two Children in a Binary Search Tree","chinese":"Delete a Node with Two Children in a Binary Search Tree"},{"english":"Invert a Binary Tree","chinese":"Invert a Binary Tree"},{"english":"Create a Trie Search Tree","chinese":"Create a Trie Search Tree"},{"english":"Insert an Element into a Max Heap","chinese":"Insert an Element into a Max Heap"},{"english":"Remove an Element from a Max Heap","chinese":"Remove an Element from a Max Heap"},{"english":"Implement Heap Sort with a Min Heap","chinese":"Implement Heap Sort with a Min Heap"},{"english":"Adjacency List","chinese":"Adjacency List"},{"english":"Adjacency Matrix","chinese":"Adjacency Matrix"},{"english":"Incidence Matrix","chinese":"Incidence Matrix"},{"english":"Breadth-First Search","chinese":"Breadth-First Search"},{"english":"Depth-First Search","chinese":"Depth-First Search"},{"english":"Introduction to the Coding Interview Take Home Projects","chinese":"Introduction to the Coding Interview Take Home Projects"},{"english":"Show the Local Weather","chinese":"Show the Local Weather"},{"english":"Build a Wikipedia Viewer","chinese":"Build a Wikipedia Viewer"},{"english":"Use the Twitch JSON API","chinese":"Use the Twitch JSON API"},{"english":"Build an Image Search Abstraction Layer","chinese":"Build an Image Search Abstraction Layer"},{"english":"Build a Tic Tac Toe Game","chinese":"Build a Tic Tac Toe Game"},{"english":"Build a Simon Game","chinese":"Build a Simon Game"},{"english":"Build a Camper Leaderboard","chinese":"Build a Camper Leaderboard"},{"english":"Build a Recipe Box","chinese":"Build a Recipe Box"},{"english":"Build the Game of Life","chinese":"Build the Game of Life"},{"english":"Build a Roguelike Dungeon Crawler Game","chinese":"Build a Roguelike Dungeon Crawler Game"},{"english":"P2P Video Chat Application","chinese":"P2P Video Chat Application"},{"english":"Show National Contiguity with a Force Directed Graph","chinese":"Show National Contiguity with a Force Directed Graph"},{"english":"Map Data Across the Globe","chinese":"Map Data Across the Globe"},{"english":"Manage a Book Trading Club","chinese":"Manage a Book Trading Club"},{"english":"Build a Pinterest Clone","chinese":"Build a Pinterest Clone"},{"english":"Build a Nightlife Coordination App","chinese":"Build a Nightlife Coordination App"},{"english":"Chart the Stock Market","chinese":"Chart the Stock Market"},{"english":"Build a Voting App","chinese":"Build a Voting App"},{"english":"Build a Pong Game","chinese":"Build a Pong Game"},{"english":"Build a Light-Bright App","chinese":"Build a Light-Bright App"},{"english":"Introduction to the Rosetta Code Problems","chinese":"Introduction to the Rosetta Code Problems"},{"english":"100 doors","chinese":"100 doors"},{"english":"24 game","chinese":"24 game"},{"english":"9 billion names of God the integer","chinese":"9 billion names of God the integer"},{"english":"ABC Problem","chinese":"ABC Problem"},{"english":"Introduction to the Project Euler Problems","chinese":"Introduction to the Project Euler Problems"},{"english":"Problem 1: Multiples of 3 and 5","chinese":"Problem 1: Multiples of 3 and 5"},{"english":"Problem 2: Even Fibonacci Numbers","chinese":"Problem 2: Even Fibonacci Numbers"},{"english":"Problem 3: Largest prime factor","chinese":"Problem 3: Largest prime factor"},{"english":"Problem 4: Largest palindrome product","chinese":"Problem 4: Largest palindrome product"},{"english":"Problem 5: Smallest multiple","chinese":"Problem 5: Smallest multiple"},{"english":"Problem 6: Sum square difference","chinese":"Problem 6: Sum square difference"},{"english":"Problem 7: 10001st prime","chinese":"Problem 7: 10001st prime"},{"english":"Problem 8: Largest product in a series","chinese":"Problem 8: Largest product in a series"},{"english":"Problem 9: Special Pythagorean triplet","chinese":"Problem 9: Special Pythagorean triplet"},{"english":"Problem 10: Summation of primes","chinese":"Problem 10: Summation of primes"},{"english":"Problem 11: Largest product in a grid","chinese":"Problem 11: Largest product in a grid"},{"english":"Problem 12: Highly divisible triangular number","chinese":"Problem 12: Highly divisible triangular number"},{"english":"Problem 13: Large sum","chinese":"Problem 13: Large sum"},{"english":"Problem 14: Longest Collatz sequence","chinese":"Problem 14: Longest Collatz sequence"},{"english":"Problem 15: Lattice paths","chinese":"Problem 15: Lattice paths"},{"english":"Problem 16: Power digit sum","chinese":"Problem 16: Power digit sum"},{"english":"Problem 17: Number letter counts","chinese":"Problem 17: Number letter counts"},{"english":"Problem 18: Maximum path sum I","chinese":"Problem 18: Maximum path sum I"},{"english":"Problem 19: Counting Sundays","chinese":"Problem 19: Counting Sundays"},{"english":"Problem 20: Factorial digit sum","chinese":"Problem 20: Factorial digit sum"},{"english":"Problem 21: Amicable numbers","chinese":"Problem 21: Amicable numbers"},{"english":"Problem 22: Names scores","chinese":"Problem 22: Names scores"},{"english":"Problem 23: Non-abundant sums","chinese":"Problem 23: Non-abundant sums"},{"english":"Problem 24: Lexicographic permutations","chinese":"Problem 24: Lexicographic permutations"},{"english":"Problem 25: 1000-digit Fibonacci number","chinese":"Problem 25: 1000-digit Fibonacci number"},{"english":"Problem 26: Reciprocal cycles","chinese":"Problem 26: Reciprocal cycles"},{"english":"Problem 27: Quadratic primes","chinese":"Problem 27: Quadratic primes"},{"english":"Problem 28: Number spiral diagonals","chinese":"Problem 28: Number spiral diagonals"},{"english":"Problem 29: Distinct powers","chinese":"Problem 29: Distinct powers"},{"english":"Problem 30: Digit n powers","chinese":"Problem 30: Digit n powers"},{"english":"Problem 31: Coin sums","chinese":"Problem 31: Coin sums"},{"english":"Problem 32: Pandigital products","chinese":"Problem 32: Pandigital products"},{"english":"Problem 33: Digit cancelling fractions","chinese":"Problem 33: Digit cancelling fractions"},{"english":"Problem 34: Digit factorials","chinese":"关卡 34：各位数字的阶乘"},{"english":"Problem 35: Circular primes","chinese":"Problem 34: Digit factorials"},{"english":"Problem 36: Double-base palindromes","chinese":"Problem 36: Double-base palindromes"},{"english":"Problem 37: Truncatable primes","chinese":"Problem 37: Truncatable primes"},{"english":"Problem 38: Pandigital multiples","chinese":"Problem 38: Pandigital multiples"},{"english":"Problem 39: Integer right triangles","chinese":"Problem 39: Integer right triangles"},{"english":"Problem 40: Champernowne's constant","chinese":"roblem 40: Champernowne's constant"},{"english":"Problem 41: Pandigital prime","chinese":"Problem 41: Pandigital prime"},{"english":"Problem 42: Coded triangle numbers","chinese":"Problem 42: Coded triangle numbers"},{"english":"Problem 43: Sub-string divisibility","chinese":"Problem 43: Sub-string divisibility"},{"english":"Problem 44: Pentagon numbers","chinese":"Problem 44: Pentagon numbers"}]

/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(23);
	
	var _reactMonacoEditor = __webpack_require__(336);
	
	var _reactMonacoEditor2 = _interopRequireDefault(_reactMonacoEditor);
	
	var _redux2 = __webpack_require__(20);
	
	var _app = __webpack_require__(55);
	
	var _reselect = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  contents: _propTypes2.default.string,
	  dimensions: _propTypes2.default.object,
	  executeChallenge: _propTypes2.default.func.isRequired,
	  ext: _propTypes2.default.string,
	  fileKey: _propTypes2.default.string,
	  theme: _propTypes2.default.string,
	  updateFile: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = (0, _reselect.createSelector)(_app.userSelector, function (_ref) {
	  var _ref$theme = _ref.theme,
	      theme = _ref$theme === undefined ? 'night' : _ref$theme;
	  return { theme: theme };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    executeChallenge: _redux2.executeChallenge,
	    updateFile: _redux2.updateFile
	  }, dispatch);
	};
	
	var modeMap = {
	  css: 'css',
	  html: 'html',
	  js: 'javascript',
	  jsx: 'javascript'
	};
	
	var Editor = function (_PureComponent) {
	  _inherits(Editor, _PureComponent);
	
	  function Editor() {
	    _classCallCheck(this, Editor);
	
	    for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
	      props[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(props)));
	
	    _this.options = {
	      minimap: {
	        enabled: false
	      },
	      selectOnLineNumbers: true,
	      wordWrap: 'on',
	      scrollbar: {
	        horizontal: 'hidden',
	        vertical: 'visible',
	        verticalHasArrows: true
	      }
	    };
	
	    _this._editor = null;
	
	    _this.focusEditor = _this.focusEditor.bind(_this);
	    return _this;
	  }
	
	  Editor.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('keyup', this.focusEditor);
	  };
	
	  Editor.prototype.editorDidMount = function editorDidMount(editor, monaco) {
	    this._editor = editor;
	    this._editor.focus();
	    document.addEventListener('keyup', this.focusEditor);
	    this._editor.addAction({
	      id: 'execute-challenge',
	      label: 'Run tests',
	      keybindings: [
	      /* eslint-disable no-bitwise */
	      monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.Enter)],
	      run: this.props.executeChallenge
	    });
	  };
	
	  Editor.prototype.focusEditor = function focusEditor(e) {
	    // e key to focus editor
	    if (e.keyCode === 69) {
	      this._editor.focus();
	    }
	  };
	
	  Editor.prototype.onChange = function onChange(editorValue) {
	    var _props = this.props,
	        updateFile = _props.updateFile,
	        fileKey = _props.fileKey;
	
	    updateFile({ key: fileKey, editorValue: editorValue });
	  };
	
	  Editor.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.dimensions !== prevProps.dimensions && this._editor) {
	      this._editor.layout();
	    }
	  };
	
	  Editor.prototype.render = function render() {
	    var _props2 = this.props,
	        contents = _props2.contents,
	        ext = _props2.ext,
	        theme = _props2.theme,
	        fileKey = _props2.fileKey;
	
	    var editorTheme = theme === 'night' ? 'vs-dark' : 'vs';
	    return _react2.default.createElement(
	      'div',
	      { className: 'classic-editor editor' },
	      _react2.default.createElement('base', { href: '/' }),
	      _react2.default.createElement(_reactMonacoEditor2.default, {
	        editorDidMount: this.editorDidMount.bind(this),
	        key: editorTheme + '-' + fileKey,
	        language: modeMap[ext],
	        onChange: this.onChange.bind(this),
	        options: this.options,
	        theme: editorTheme,
	        value: contents
	      })
	    );
	  };
	
	  return Editor;
	}(_react.PureComponent);
	
	Editor.displayName = 'Editor';
	Editor.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Editor);
	module.exports = exports['default'];

/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(28);
	
	var _reselect = __webpack_require__(46);
	
	var _reactRedux = __webpack_require__(23);
	
	var _reactHelmet = __webpack_require__(150);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactReflex = __webpack_require__(4405);
	
	var _Editor = __webpack_require__(894);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _Preview = __webpack_require__(896);
	
	var _Preview2 = _interopRequireDefault(_Preview);
	
	var _SidePanel = __webpack_require__(898);
	
	var _SidePanel2 = _interopRequireDefault(_SidePanel);
	
	var _Output = __webpack_require__(370);
	
	var _Output2 = _interopRequireDefault(_Output);
	
	var _CompletionModal = __webpack_require__(192);
	
	var _CompletionModal2 = _interopRequireDefault(_CompletionModal);
	
	var _HelpModal = __webpack_require__(369);
	
	var _HelpModal2 = _interopRequireDefault(_HelpModal);
	
	var _ResetModal = __webpack_require__(897);
	
	var _ResetModal2 = _interopRequireDefault(_ResetModal);
	
	var _getWords = __webpack_require__(375);
	
	var _utils = __webpack_require__(193);
	
	var _challengeTypes = __webpack_require__(281);
	
	var _propTypes3 = __webpack_require__(122);
	
	var _redux2 = __webpack_require__(20);
	
	__webpack_require__(1213);
	
	var _decodeHTMLEntities = __webpack_require__(918);
	
	var _decodeHTMLEntities2 = _interopRequireDefault(_decodeHTMLEntities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global graphql */
	
	
	var mapStateToProps = (0, _reselect.createSelector)(_redux2.challengeFilesSelector, _redux2.challengeTestsSelector, _redux2.consoleOutputSelector, function (files, tests, output) {
	  return {
	    files: files,
	    tests: tests,
	    output: output
	  };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    createFiles: _redux2.createFiles,
	    initTests: _redux2.initTests,
	    updateChallengeMeta: _redux2.updateChallengeMeta,
	    challengeMounted: _redux2.challengeMounted,
	    updateSuccessMessage: _redux2.updateSuccessMessage
	  }, dispatch);
	};
	
	var propTypes = {
	  challengeMounted: _propTypes2.default.func.isRequired,
	  createFiles: _propTypes2.default.func.isRequired,
	  data: _propTypes2.default.shape({
	    challengeNode: _propTypes3.ChallengeNode
	  }),
	  files: _propTypes2.default.shape({
	    key: _propTypes2.default.string
	  }),
	  initTests: _propTypes2.default.func.isRequired,
	  output: _propTypes2.default.string,
	  pathContext: _propTypes2.default.shape({
	    challengeMeta: _propTypes2.default.shape({
	      nextchallengePath: _propTypes2.default.string
	    })
	  }),
	  tests: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    text: _propTypes2.default.string,
	    testString: _propTypes2.default.string
	  })),
	  updateChallengeMeta: _propTypes2.default.func.isRequired,
	  updateSuccessMessage: _propTypes2.default.func.isRequired
	};
	
	var ShowClassic = function (_PureComponent) {
	  _inherits(ShowClassic, _PureComponent);
	
	  function ShowClassic() {
	    _classCallCheck(this, ShowClassic);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	    _this.resizeProps = {
	      onStopResize: _this.onStopResize.bind(_this),
	      onResize: _this.onResize.bind(_this)
	    };
	
	    _this.state = {
	      resizing: false
	    };
	    return _this;
	  }
	
	  ShowClassic.prototype.onResize = function onResize() {
	    this.setState({ resizing: true });
	  };
	
	  ShowClassic.prototype.onStopResize = function onStopResize() {
	    this.setState({ resizing: false });
	  };
	
	  ShowClassic.prototype.componentDidMount = function componentDidMount() {
	    var _props = this.props,
	        challengeMounted = _props.challengeMounted,
	        createFiles = _props.createFiles,
	        initTests = _props.initTests,
	        updateChallengeMeta = _props.updateChallengeMeta,
	        updateSuccessMessage = _props.updateSuccessMessage,
	        _props$data$challenge = _props.data.challengeNode,
	        files = _props$data$challenge.files,
	        title = _props$data$challenge.title,
	        tests = _props$data$challenge.fields.tests,
	        challengeType = _props$data$challenge.challengeType,
	        challengeMeta = _props.pathContext.challengeMeta;
	
	    createFiles(files);
	    initTests(tests);
	    updateChallengeMeta(_extends({}, challengeMeta, { title: title, challengeType: challengeType }));
	    updateSuccessMessage((0, _getWords.randomCompliment)());
	    challengeMounted(challengeMeta.id);
	  };
	
	  ShowClassic.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTitle = prevProps.data.challengeNode.title;
	    var _props2 = this.props,
	        challengeMounted = _props2.challengeMounted,
	        createFiles = _props2.createFiles,
	        initTests = _props2.initTests,
	        updateChallengeMeta = _props2.updateChallengeMeta,
	        updateSuccessMessage = _props2.updateSuccessMessage,
	        _props2$data$challeng = _props2.data.challengeNode,
	        files = _props2$data$challeng.files,
	        currentTitle = _props2$data$challeng.title,
	        tests = _props2$data$challeng.fields.tests,
	        challengeType = _props2$data$challeng.challengeType,
	        challengeMeta = _props2.pathContext.challengeMeta;
	
	    if (prevTitle !== currentTitle) {
	      updateSuccessMessage((0, _getWords.randomCompliment)());
	      createFiles(files);
	      initTests(tests);
	      updateChallengeMeta(_extends({}, challengeMeta, {
	        title: currentTitle,
	        challengeType: challengeType
	      }));
	      challengeMounted(challengeMeta.id);
	    }
	  };
	
	  ShowClassic.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props3 = this.props,
	        _props3$data$challeng = _props3.data.challengeNode,
	        challengeType = _props3$data$challeng.challengeType,
	        _props3$data$challeng2 = _props3$data$challeng.fields,
	        blockName = _props3$data$challeng2.blockName,
	        slug = _props3$data$challeng2.slug,
	        title = _props3$data$challeng.title,
	        description = _props3$data$challeng.description,
	        files = _props3.files,
	        output = _props3.output;
	
	    var editors = Object.keys(files).map(function (key) {
	      return files[key];
	    }).map(function (file, index) {
	      return _react2.default.createElement(
	        _reactReflex.ReflexContainer,
	        { key: file.key + index, orientation: 'horizontal' },
	        index !== 0 && _react2.default.createElement(_reactReflex.ReflexSplitter, _extends({ propagate: true }, _this2.resizeProps)),
	        _react2.default.createElement(
	          _reactReflex.ReflexElement,
	          _extends({
	            flex: 1,
	            propagateDimensions: true,
	            renderOnResize: true,
	            renderOnResizeRate: 20
	          }, _this2.resizeProps),
	          _react2.default.createElement(_Editor2.default, _extends({}, file, { fileKey: file.key }))
	        ),
	        index + 1 === Object.keys(files).length && _react2.default.createElement(_reactReflex.ReflexSplitter, _extends({ propagate: true }, _this2.resizeProps)),
	        index + 1 === Object.keys(files).length ? _react2.default.createElement(
	          _reactReflex.ReflexElement,
	          _extends({
	            flex: 0.25,
	            propagateDimensions: true,
	            renderOnResize: true,
	            renderOnResizeRate: 20
	          }, _this2.resizeProps),
	          _react2.default.createElement(_Output2.default, {
	            defaultOutput: '\n/**\n* Your test output will go here.\n*/\n',
	            output: (0, _decodeHTMLEntities2.default)(output)
	          })
	        ) : null
	      );
	    });
	    var showPreview = challengeType === _challengeTypes.challengeTypes.html || challengeType === _challengeTypes.challengeTypes.modern;
	    var blockNameTitle = blockName + ': ' + title;
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: blockNameTitle + ' | Learn freeCodeCamp' }),
	      _react2.default.createElement(
	        _reactReflex.ReflexContainer,
	        { orientation: 'vertical' },
	        _react2.default.createElement(
	          _reactReflex.ReflexElement,
	          _extends({ flex: 1 }, this.resizeProps),
	          _react2.default.createElement(_SidePanel2.default, {
	            className: 'full-height',
	            description: description,
	            guideUrl: (0, _utils.createGuideUrl)(slug),
	            title: blockNameTitle
	          })
	        ),
	        _react2.default.createElement(_reactReflex.ReflexSplitter, _extends({ propagate: true }, this.resizeProps)),
	        _react2.default.createElement(
	          _reactReflex.ReflexElement,
	          _extends({ flex: 1 }, this.resizeProps),
	          editors
	        ),
	        showPreview && _react2.default.createElement(_reactReflex.ReflexSplitter, _extends({ propagate: true }, this.resizeProps)),
	        showPreview ? _react2.default.createElement(
	          _reactReflex.ReflexElement,
	          _extends({ flex: 0.7 }, this.resizeProps),
	          _react2.default.createElement(_Preview2.default, {
	            className: 'full-height',
	            disableIframe: this.state.resizing
	          })
	        ) : null
	      ),
	      _react2.default.createElement(_CompletionModal2.default, null),
	      _react2.default.createElement(_HelpModal2.default, null),
	      _react2.default.createElement(_ResetModal2.default, null)
	    );
	  };
	
	  return ShowClassic;
	}(_react.PureComponent);
	
	ShowClassic.displayName = 'ShowClassic';
	ShowClassic.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ShowClassic);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 1213:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Col = __webpack_require__(142);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Row = __webpack_require__(238);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _utils = __webpack_require__(123);
	
	__webpack_require__(413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  description: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	function renderDescription(description) {
	  if (!Array.isArray(description)) {
	    return null;
	  }
	  return description.map(function (line, index) {
	    if (_utils.descriptionRegex.test(line)) {
	      return _react2.default.createElement('div', {
	        dangerouslySetInnerHTML: { __html: line },
	        key: line.slice(-6) + index
	      });
	    }
	    return _react2.default.createElement('p', {
	      className: 'wrappable',
	      dangerouslySetInnerHTML: { __html: line },
	      key: line.slice(-6) + index
	    });
	  });
	}
	
	function ChallengeDescription(_ref) {
	  var description = _ref.description;
	
	  // TODO: Remove bootstrap
	  return _react2.default.createElement(
	    _Row2.default,
	    null,
	    _react2.default.createElement(
	      _Col2.default,
	      { className: 'challenge-instructions', xs: 12 },
	      renderDescription(description)
	    )
	  );
	}
	
	ChallengeDescription.displayName = 'ChallengeDescription';
	ChallengeDescription.propTypes = propTypes;
	
	exports.default = ChallengeDescription;
	module.exports = exports['default'];

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  children: _propTypes2.default.string,
	  isCompleted: _propTypes2.default.bool
	};
	
	function ChallengeTitle(_ref) {
	  var children = _ref.children,
	      isCompleted = _ref.isCompleted;
	
	  var icon = null;
	  if (isCompleted) {
	    icon =
	    // TODO Use SVG here
	    _react2.default.createElement('i', { className: 'ion-checkmark-circled text-primary', title: 'Completed' });
	  }
	  return _react2.default.createElement(
	    'h2',
	    { className: 'text-center challenge-title' },
	    children || 'Happy Coding!',
	    icon
	  );
	}
	
	ChallengeTitle.displayName = 'ChallengeTitle';
	ChallengeTitle.propTypes = propTypes;
	
	exports.default = ChallengeTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CompletionModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _noop = __webpack_require__(184);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _reactRedux = __webpack_require__(23);
	
	var _reselect = __webpack_require__(46);
	
	var _Button = __webpack_require__(37);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Modal = __webpack_require__(78);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _analytics = __webpack_require__(81);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _GreenPass = __webpack_require__(166);
	
	var _GreenPass2 = _interopRequireDefault(_GreenPass);
	
	var _utils = __webpack_require__(123);
	
	__webpack_require__(217);
	
	var _redux = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = (0, _reselect.createSelector)(_redux.challengeFilesSelector, _redux.challengeMetaSelector, _redux.isCompletionModalOpenSelector, _redux.successMessageSelector, function (files, _ref, isOpen, message) {
	  var title = _ref.title;
	  return {
	    files: files,
	    title: title,
	    isOpen: isOpen,
	    message: message
	  };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  var dispatchers = {
	    close: function close() {
	      return dispatch((0, _redux.closeModal)('completion'));
	    },
	    handleKeypress: function handleKeypress(e) {
	      if (e.keyCode === 13 && (e.ctrlKey || e.metaKey)) {
	        dispatch((0, _redux.submitChallenge)());
	      }
	    },
	    submitChallenge: function submitChallenge() {
	      dispatch((0, _redux.submitChallenge)());
	    }
	  };
	  return function () {
	    return dispatchers;
	  };
	};
	
	var propTypes = {
	  close: _propTypes2.default.func.isRequired,
	  files: _propTypes2.default.object.isRequired,
	  handleKeypress: _propTypes2.default.func.isRequired,
	  isOpen: _propTypes2.default.bool,
	  message: _propTypes2.default.string,
	  submitChallenge: _propTypes2.default.func.isRequired,
	  title: _propTypes2.default.string
	};
	
	var CompletionModal = exports.CompletionModal = function (_PureComponent) {
	  _inherits(CompletionModal, _PureComponent);
	
	  function CompletionModal() {
	    _classCallCheck(this, CompletionModal);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  CompletionModal.prototype.render = function render() {
	    var _props = this.props,
	        close = _props.close,
	        isOpen = _props.isOpen,
	        submitChallenge = _props.submitChallenge,
	        handleKeypress = _props.handleKeypress,
	        message = _props.message,
	        _props$files = _props.files,
	        files = _props$files === undefined ? {} : _props$files,
	        title = _props.title;
	
	    if (isOpen) {
	      _analytics2.default.modalview('/completion-modal');
	    }
	    var showDownloadButton = Object.keys(files).length;
	    var filesForDownload = Object.keys(files).map(function (key) {
	      return files[key];
	    }).reduce(function (allFiles, _ref2) {
	      var _extends2;
	
	      var path = _ref2.path,
	          contents = _ref2.contents;
	      return _extends({}, allFiles, (_extends2 = {}, _extends2[path] = contents, _extends2));
	    }, {});
	    var dashedName = (0, _utils.dasherize)(title);
	    return _react2.default.createElement(
	      _Modal2.default,
	      {
	        animation: false,
	        bsSize: 'lg',
	        dialogClassName: 'challenge-success-modal',
	        keyboard: true,
	        onHide: close,
	        onKeyDown: isOpen ? handleKeypress : _noop2.default,
	        show: isOpen
	      },
	      _react2.default.createElement(
	        _Modal2.default.Header,
	        {
	          className: 'challenge-list-header fcc-modal',
	          closeButton: true
	        },
	        _react2.default.createElement(
	          _Modal2.default.Title,
	          { className: 'text-center' },
	          message
	        )
	      ),
	      _react2.default.createElement(
	        _Modal2.default.Body,
	        { className: 'completion-modal-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'success-icon-wrapper' },
	          _react2.default.createElement(_GreenPass2.default, null)
	        )
	      ),
	      _react2.default.createElement(
	        _Modal2.default.Footer,
	        null,
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            block: true,
	            bsSize: 'large',
	            bsStyle: 'primary',
	            onClick: submitChallenge
	          },
	          'Next Lesson'
	        ),
	        showDownloadButton ? _react2.default.createElement(
	          _Button2.default,
	          {
	            block: true,
	            bsSize: 'lg',
	            bsStyle: 'primary',
	            className: 'btn-primary-invert',
	            download: dashedName + '.json',
	            href: 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(filesForDownload))
	          },
	          'Download Codes'
	        ) : null
	      )
	    );
	  };
	
	  return CompletionModal;
	}(_react.PureComponent);
	
	CompletionModal.displayName = 'CompletionModal';
	CompletionModal.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CompletionModal);

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HelpModal = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(23);
	
	var _Button = __webpack_require__(37);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Modal = __webpack_require__(78);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _analytics = __webpack_require__(81);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _redux2 = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return { isOpen: (0, _redux2.isHelpModalOpenSelector)(state) };
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ createQuestion: _redux2.createQuestion, closeHelpModal: function closeHelpModal() {
	      return (0, _redux2.closeModal)('help');
	    } }, dispatch);
	};
	
	var propTypes = {
	  closeHelpModal: _propTypes2.default.func.isRequired,
	  createQuestion: _propTypes2.default.func.isRequired,
	  isOpen: _propTypes2.default.bool
	};
	
	var RSA = 'https://quest.ac';
	
	var HelpModal = exports.HelpModal = function (_PureComponent) {
	  _inherits(HelpModal, _PureComponent);
	
	  function HelpModal() {
	    _classCallCheck(this, HelpModal);
	
	    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
	  }
	
	  HelpModal.prototype.render = function render() {
	    var _props = this.props,
	        isOpen = _props.isOpen,
	        closeHelpModal = _props.closeHelpModal,
	        createQuestion = _props.createQuestion;
	
	    if (isOpen) {
	      _analytics2.default.modalview('/help-modal');
	    }
	    return _react2.default.createElement(
	      _Modal2.default,
	      { onHide: closeHelpModal, show: isOpen },
	      _react2.default.createElement(
	        _Modal2.default.Header,
	        {
	          className: 'help-modal-header fcc-modal',
	          closeButton: true
	        },
	        _react2.default.createElement(
	          _Modal2.default.Title,
	          { className: 'text-center' },
	          'Even the master had his first step.'
	        )
	      ),
	      _react2.default.createElement(
	        _Modal2.default.Body,
	        { className: 'text-center' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Everyone can code \xA0',
	          _react2.default.createElement(
	            'a',
	            { href: RSA, target: '_blank', title: 'Read, search, ask' },
	            'Read-Search-Ask'
	          ),
	          '\xA0 You can ask the community for help!'
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            block: true,
	            bsSize: 'lg',
	            bsStyle: 'primary',
	            onClick: createQuestion
	          },
	          'Post request for help'
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            block: true,
	            bsSize: 'lg',
	            bsStyle: 'primary',
	            onClick: closeHelpModal
	          },
	          'Found a solution and I\'m good.'
	        )
	      )
	    );
	  };
	
	  return HelpModal;
	}(_react.PureComponent);
	
	HelpModal.displayName = 'HelpModal';
	HelpModal.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HelpModal);

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMonacoEditor = __webpack_require__(336);
	
	var _reactMonacoEditor2 = _interopRequireDefault(_reactMonacoEditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  defaultOutput: _propTypes2.default.string,
	  dimensions: _propTypes2.default.object,
	  height: _propTypes2.default.number,
	  output: _propTypes2.default.string
	};
	
	var options = {
	  lineNumbers: false,
	  minimap: {
	    enabled: false
	  },
	  readOnly: true,
	  wordWrap: 'on',
	  scrollBeyondLastLine: false,
	  scrollbar: {
	    horizontal: 'hidden',
	    vertical: 'visible',
	    verticalHasArrows: true
	  }
	};
	
	var Output = function (_PureComponent) {
	  _inherits(Output, _PureComponent);
	
	  function Output() {
	    _classCallCheck(this, Output);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this));
	
	    _this._editor = null;
	    return _this;
	  }
	
	  Output.prototype.editorDidMount = function editorDidMount(editor) {
	    this._editor = editor;
	  };
	
	  Output.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.dimensions !== prevProps.dimensions && this._editor) {
	      this._editor.layout();
	    }
	  };
	
	  Output.prototype.render = function render() {
	    var _props = this.props,
	        output = _props.output,
	        defaultOutput = _props.defaultOutput,
	        height = _props.height;
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement('base', { href: '/' }),
	      _react2.default.createElement(_reactMonacoEditor2.default, {
	        className: 'challenge-output',
	        editorDidMount: this.editorDidMount.bind(this),
	        height: height,
	        options: options,
	        value: output ? output : defaultOutput
	      })
	    );
	  };
	
	  return Output;
	}(_react.PureComponent);
	
	Output.displayName = 'Output';
	Output.propTypes = propTypes;
	
	exports.default = Output;
	module.exports = exports['default'];

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1214);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mainId = 'fcc-main-frame';
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  disableIframe: _propTypes2.default.bool
	};
	
	var Preview = function (_PureComponent) {
	  _inherits(Preview, _PureComponent);
	
	  function Preview() {
	    _classCallCheck(this, Preview);
	
	    for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
	      props[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(props)));
	
	    _this.state = {
	      iframeStatus: _this.props.disableIframe
	    };
	    return _this;
	  }
	
	  Preview.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.disableIframe !== nextProps.disableIframe) {
	      this.setState({ iframeStatus: !this.state.iframeStatus });
	    }
	  };
	
	  Preview.prototype.render = function render() {
	    var iframeToggle = this.state.iframeStatus ? 'disable' : 'enable';
	    return _react2.default.createElement(
	      'div',
	      { className: 'challenge-preview ' + iframeToggle + '-iframe' },
	      _react2.default.createElement('iframe', { className: 'challenge-preview-frame', id: mainId })
	    );
	  };
	
	  return Preview;
	}(_react.PureComponent);
	
	Preview.displayName = 'Preview';
	Preview.propTypes = propTypes;
	
	exports.default = Preview;
	module.exports = exports['default'];

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(23);
	
	var _reselect = __webpack_require__(46);
	
	var _Button = __webpack_require__(37);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Modal = __webpack_require__(78);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _analytics = __webpack_require__(81);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _redux2 = __webpack_require__(20);
	
	__webpack_require__(1215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  close: _propTypes2.default.func.isRequired,
	  isOpen: _propTypes2.default.bool.isRequired,
	  reset: _propTypes2.default.func.isRequired
	};
	
	var mapStateToProps = (0, _reselect.createSelector)(_redux2.isResetModalOpenSelector, function (isOpen) {
	  return {
	    isOpen: isOpen
	  };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ close: function close() {
	      return (0, _redux2.closeModal)('reset');
	    }, reset: function reset() {
	      return (0, _redux2.resetChallenge)();
	    } }, dispatch);
	};
	
	function withActions() {
	  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	
	  return function () {
	    return fns.forEach(function (fn) {
	      return fn();
	    });
	  };
	}
	
	function ResetModal(_ref) {
	  var reset = _ref.reset,
	      close = _ref.close,
	      isOpen = _ref.isOpen;
	
	  if (isOpen) {
	    _analytics2.default.modalview('/reset-modal');
	  }
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      animation: false,
	      dialogClassName: 'reset-modal',
	      keyboard: true,
	      onHide: close,
	      show: isOpen
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'reset-modal-header', closeButton: true },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { className: 'text-center' },
	        'Time Shuttle'
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { className: 'reset-modal-body' },
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'When you reset the code, the editor reset back and returns to its original state.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'em',
	            null,
	            'This can\'t be undone.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          block: true,
	          bsSize: 'large',
	          bsStyle: 'danger',
	          onClick: withActions(reset, close)
	        },
	        'Confirm on Reset'
	      )
	    )
	  );
	}
	
	ResetModal.displayName = 'ResetModal';
	ResetModal.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResetModal);
	module.exports = exports['default'];

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SidePanel = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(15);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(23);
	
	var _redux = __webpack_require__(28);
	
	var _ChallengeTitle = __webpack_require__(191);
	
	var _ChallengeTitle2 = _interopRequireDefault(_ChallengeTitle);
	
	var _ChallengeDescription = __webpack_require__(368);
	
	var _ChallengeDescription2 = _interopRequireDefault(_ChallengeDescription);
	
	var _ToolPanel = __webpack_require__(899);
	
	var _ToolPanel2 = _interopRequireDefault(_ToolPanel);
	
	var _TestSuite = __webpack_require__(371);
	
	var _TestSuite2 = _interopRequireDefault(_TestSuite);
	
	var _Spacer = __webpack_require__(165);
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _redux2 = __webpack_require__(20);
	
	var _reselect = __webpack_require__(46);
	
	__webpack_require__(1216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dict = __webpack_require__(180);
	
	var mapStateToProps = (0, _reselect.createSelector)(_redux2.challengeTestsSelector, function (tests) {
	  return {
	    tests: tests
	  };
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    initConsole: _redux2.initConsole
	  }, dispatch);
	};
	
	// const MathJax = global.MathJax;
	
	var propTypes = {
	  description: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  guideUrl: _propTypes2.default.string,
	  initConsole: _propTypes2.default.func.isRequired,
	  tests: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  title: _propTypes2.default.string
	};
	
	var SidePanel = exports.SidePanel = function (_PureComponent) {
	  _inherits(SidePanel, _PureComponent);
	
	  function SidePanel(props) {
	    _classCallCheck(this, SidePanel);
	
	    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));
	
	    _this.bindTopDiv = _this.bindTopDiv.bind(_this);
	    // MathJax.Hub.Config({
	    //   tex2jax: { inlineMath: [['$', '$'], ['\\(', '\\)']] }
	    // });
	    return _this;
	  }
	
	  SidePanel.prototype.componentDidMount = function componentDidMount() {
	    // MathJax.Hub.Queue(['Typeset', MathJax.Hub,
	    // document.querySelector('.challenge-instructions')]);
	    this.props.initConsole('');
	  };
	
	  SidePanel.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    // MathJax.Hub.Queue(['Typeset', MathJax.Hub,
	    // document.querySelector('.challenge-instructions')]);
	    var _props = this.props,
	        title = _props.title,
	        initConsole = _props.initConsole;
	
	    if (title !== prevProps.title) {
	      initConsole('');
	      var node = _reactDom2.default.findDOMNode(this.descriptionTop);
	      setTimeout(function () {
	        node.scrollIntoView({ behavior: 'smooth' });
	      }, 0);
	    }
	  };
	
	  SidePanel.prototype.bindTopDiv = function bindTopDiv(node) {
	    this.descriptionTop = node;
	  };
	
	  SidePanel.prototype.render = function render() {
	    var _props2 = this.props,
	        title = _props2.title,
	        description = _props2.description,
	        guideUrl = _props2.guideUrl,
	        tests = _props2.tests;
	
	    var arr = title.replace(': ', '|').split('|');
	    dict.forEach(function (item) {
	      if (item.english == arr[0]) {
	        arr[0] = item.chinese;
	      }
	      if (item.english == arr[1]) {
	        arr[1] = item.chinese;
	      }
	    });
	    var changedTitle = arr.join('：');
	    return _react2.default.createElement(
	      'div',
	      { className: 'instructions-panel', role: 'complementary' },
	      _react2.default.createElement('div', { ref: this.bindTopDiv }),
	      _react2.default.createElement(_Spacer2.default, null),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ChallengeTitle2.default,
	          null,
	          changedTitle
	        ),
	        _react2.default.createElement(_ChallengeDescription2.default, { description: description })
	      ),
	      _react2.default.createElement(_ToolPanel2.default, { guideUrl: guideUrl }),
	      _react2.default.createElement(_TestSuite2.default, { tests: tests })
	    );
	  };
	
	  return SidePanel;
	}(_react.PureComponent);
	
	SidePanel.displayName = 'SidePanel';
	SidePanel.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SidePanel);

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GreenPass = __webpack_require__(166);
	
	var _GreenPass2 = _interopRequireDefault(_GreenPass);
	
	var _Fail = __webpack_require__(372);
	
	var _Fail2 = _interopRequireDefault(_Fail);
	
	var _Initial = __webpack_require__(373);
	
	var _Initial2 = _interopRequireDefault(_Initial);
	
	__webpack_require__(414);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  tests: _propTypes2.default.arrayOf(_propTypes2.default.object)
	};
	
	function getAccessibleText(err, pass, text) {
	  var accessibleText = 'Waiting';
	  var cleanText = text.replace(/<\/?code>/g, '');
	
	  // Determine test status (i.e. icon)
	  if (err) {
	    accessibleText = 'Error';
	  } else if (pass) {
	    accessibleText = 'Pass';
	  }
	
	  // Append the text itself
	  return accessibleText + ' - ' + cleanText;
	}
	
	function TestSuite(_ref) {
	  var tests = _ref.tests;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'challenge-test-suite' },
	    tests.map(function (_ref2, index) {
	      var err = _ref2.err,
	          _ref2$pass = _ref2.pass,
	          pass = _ref2$pass === undefined ? false : _ref2$pass,
	          _ref2$text = _ref2.text,
	          text = _ref2$text === undefined ? '' : _ref2$text;
	
	      var isInitial = !pass && !err;
	      var statusIcon = pass && !err ? _react2.default.createElement(_GreenPass2.default, null) : _react2.default.createElement(_Fail2.default, null);
	      return _react2.default.createElement(
	        'div',
	        {
	          'aria-label': getAccessibleText(err, pass, text),
	          className: 'test-result',
	          key: text.slice(-6) + index,
	          tabIndex: '0'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'test-status-icon' },
	          isInitial ? _react2.default.createElement(_Initial2.default, null) : statusIcon
	        ),
	        _react2.default.createElement('div', {
	          'aria-hidden': 'true',
	          className: 'test-output',
	          dangerouslySetInnerHTML: { __html: text },
	          xs: 10
	        })
	      );
	    })
	  );
	}
	
	TestSuite.displayName = 'TestSuite';
	TestSuite.propTypes = propTypes;
	
	exports.default = TestSuite;
	module.exports = exports['default'];

/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redux = __webpack_require__(28);
	
	var _reactRedux = __webpack_require__(23);
	
	var _Button = __webpack_require__(37);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(1217);
	
	var _redux2 = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    executeChallenge: _redux2.executeChallenge,
	    openHelpModal: function openHelpModal() {
	      return (0, _redux2.openModal)('help');
	    },
	    openResetModal: function openResetModal() {
	      return (0, _redux2.openModal)('reset');
	    }
	  }, dispatch);
	};
	
	var propTypes = {
	  executeChallenge: _propTypes2.default.func.isRequired,
	  guideUrl: _propTypes2.default.string,
	  openHelpModal: _propTypes2.default.func.isRequired,
	  openResetModal: _propTypes2.default.func.isRequired
	};
	
	function ToolPanel(_ref) {
	  var executeChallenge = _ref.executeChallenge,
	      openHelpModal = _ref.openHelpModal,
	      openResetModal = _ref.openResetModal,
	      guideUrl = _ref.guideUrl;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'tool-panel-group' },
	      _react2.default.createElement(
	        _Button2.default,
	        { block: true, bsStyle: 'primary', onClick: executeChallenge },
	        'Run Codes'
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          block: true,
	          bsStyle: 'primary',
	          className: 'btn-primary-invert',
	          onClick: openResetModal
	        },
	        'Reset Codes'
	      )
	    )
	  );
	}
	
	ToolPanel.displayName = 'ToolPanel';
	ToolPanel.propTypes = propTypes;
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ToolPanel);
	
	/*
	<Button
	        block={true}
	        bsStyle='default'
	        className='btn-big'
	        onClick={executeChallenge}
	        >
	        Run tests (Ctrl + Enter)
	      </Button>
	      <div className='button-spacer' />
	      <Button
	        block={true}
	        bsStyle='default'
	        className='btn-big'
	        onClick={openResetModal}
	        >
	        Reset this lesson
	      </Button>
	      <div className='button-spacer' />
	      {guideUrl && (
	        <div>
	          <Button
	            block={true}
	            bsStyle='default'
	            className='btn-big'
	            href={guideUrl}
	            target='_blank'
	            >
	            Get a hint
	          </Button>
	          <div className='button-spacer' />
	        </div>
	      )}
	      <Button
	        block={true}
	        bsStyle='default'
	        className='btn-big'
	        onClick={openHelpModal}
	        >
	        Ask for help on the forum
	      </Button>
	      <div className='button-spacer' />
	*/

	module.exports = exports['default'];

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RedFail() {
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: '50',
	      viewBox: '0 0 200 200',
	      width: '50',
	      xmlns: 'http://www.w3.org/2000/svg'
	    },
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Test failed'
	      ),
	      _react2.default.createElement('circle', {
	        cx: '100',
	        cy: '99',
	        fill: '#555',
	        r: '95',
	        stroke: '#555',
	        strokeDasharray: 'null',
	        strokeLinecap: 'null',
	        strokeLinejoin: 'null'
	      }),
	      _react2.default.createElement('rect', {
	        fill: '#ffffff',
	        height: '30',
	        stroke: '#ffffff',
	        strokeDasharray: 'null',
	        strokeLinecap: 'null',
	        strokeLinejoin: 'null',
	        transform: 'rotate(-45, 100, 103.321)',
	        width: '128.85878',
	        x: '35',
	        y: '88'
	      }),
	      _react2.default.createElement('rect', {
	        fill: '#ffffff',
	        height: '30',
	        stroke: '#ffffff',
	        strokeDasharray: 'null',
	        strokeLinecap: 'null',
	        strokeLinejoin: 'null',
	        transform: 'rotate(45, 99.5, 104)',
	        width: '128.85878',
	        x: '35',
	        y: '88'
	      })
	    )
	  );
	}
	
	RedFail.displayName = 'RedFail';
	
	exports.default = RedFail;
	module.exports = exports['default'];

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Initial(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({
	      height: '50',
	      viewBox: '0 0 200 200',
	      width: '50',
	      xmlns: 'http://www.w3.org/2000/svg'
	    }, props),
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Initial'
	      ),
	      _react2.default.createElement('circle', {
	        cx: '100',
	        cy: '99',
	        fill: '#555',
	        r: '95',
	        stroke: '#555',
	        strokeDasharray: 'null',
	        strokeLinecap: 'null',
	        strokeLinejoin: 'null'
	      }),
	      _react2.default.createElement(
	        'svg',
	        {
	          height: '200',
	          viewBox: '-13 -12 50 50',
	          width: '200',
	          xmlns: 'http://www.w3.org/2000/svg'
	        },
	        _react2.default.createElement('path', {
	          d: 'M8 1c0-.552.448-1 1-1h6c.553 0 1 .448 1 1s-.447 1-1 1h-6c-' + '.552 0-1-.448-1-1zm13 20.554c0 1.284-1.023 2.446-2.424 ' + '2.446h-13.153c-1.4 0-2.423-1.162-2.423-2.445 0-.35.076-.709.' + '242-1.057l3.743-7.856c1.04-2.186 2.015-4.581 2.015-7.007v-1.' + '635h2l-.006 2c-.087 2.623-1.09 5.092-1.973 7h3.682l4.377 9h1.' + '496c.309 0 .52-.342.377-.644l-3.743-7.854c-1.046-2.197-2.12-4' + '.791-2.21-7.502v-2h2v1.635c0 2.426.975 4.82 2.016 7.006l3.743' + ' 7.856c.165.348.241.707.241 1.057zm-12-1.054c0-.829-.671-1.5-' + '1.5-1.5s-1.5.671-1.5 1.5.671 1.5 1.5 1.5 1.5-.671 1.5-1.5zm2-' + '3.5c0-.553-.448-1-1-1-.553 0-1 .447-1 1s.447 1 1 1c.552 0 1-.' + '447 1-1zm3 3c0-.552-.448-1-1-1s-1 .448-1 1 .448 1 1 1 1-.448 ' + '1-1z',
	          fill: '#fff'
	        })
	      )
	    )
	  );
	}
	
	Initial.displayName = 'Initial';
	
	exports.default = Initial;
	module.exports = exports['default'];

/***/ }),

/***/ 1214:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1215:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1216:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1217:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.randomPhrase = randomPhrase;
	exports.randomVerb = randomVerb;
	exports.randomCompliment = randomCompliment;
	
	var _words = __webpack_require__(424);
	
	var _words2 = _interopRequireDefault(_words);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function randomItem(arr) {
	  return arr[Math.floor(Math.random() * arr.length)];
	}
	
	function randomPhrase() {
	  return randomItem(_words2.default.phrases);
	}
	
	function randomVerb() {
	  return randomItem(_words2.default.verbs);
	}
	
	function randomCompliment() {
	  return randomItem(_words2.default.compliments);
	}

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.createGuideUrl = createGuideUrl;
	var guideBase = 'https://guide.freecodecamp.org/certifications';
	
	function createGuideUrl() {
	  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return guideBase + slug;
	}

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

	module.exports = {"verbs":["aced","nailed","rocked","destroyed","owned","crushed","conquered","shredded","demolished","devoured","banished","wrangled"],"compliments":["Over the top!","Down the rabbit hole we go!","Bring that rain!","Target acquired!","Feel that need for speed!","You've got guts!","We have liftoff!","To infinity and beyond!","Encore!","Onward, ho!","Challenge destroyed!","It's on like Donkey Kong!","Power level? It's over 9000!","Coding spree!","Code long and prosper.","The crowd goes wild!","One for the guinness book!","Flawless victory!","Most efficient!","Party on, Wayne!","You've got the touch!","You're on fire!","Don't hurt 'em, Hammer!","The town is now red!","To the nines!","The world rejoices!","That's the way it's done!","You rock!","Woo-hoo!","We knew you could do it!","Hyper Combo Finish!","Nothing but net!","Boom-shakalaka!","You're a shooting star!","You're unstoppable!","Way cool!","You're king of the world!","Walk on that sunshine!","Keep on trucking!","Off the charts!","There is no spoon!","Cranked it up to 11!","Escape velocity reached!","You make this look easy!","Passed with flying colors!","You've got this!","Happy, happy, joy, joy!","Tomorrow, the world!","Your powers combined!","A winner is you!","It's alive. It's alive!","Sonic Boom!","Here's looking at you, Code!","Ride like the wind!","Legen - wait for it - dary!","Ludicrous Speed! Go!","Yes we can!","Most triumphant!","One loop to rule them all!","By the power of Grayskull!","You did it!","Storm that castle!","Face-melting guitar solo!","Checkmate!","Bodacious!","Tubular!","You're outta sight!","Keep calm and code on!","Even sad panda smiles!","Even grumpy cat approves!","Kool Aid Man says oh yeah!","Bullseye!","Far out!","You're heating up!","Hasta la vista, challenge!","Terminated.","Off the hook!","Thundercats, Hooo!","Shiver me timbers!","Raise the roof!","We've underestimated you.","I also live dangerously.","Get to the choppa!","Bingo!","And you're all out of gum.","Even honeybadger cares!","Helm, Warp Nine. Engage!","Gotta code 'em all!","Spool up the FTL drive!","Cool beans!","They're in another castle.","Power UP!","Nuclear launch detected.","Pikachu chooses you!","We're gonna pump you up!","I gotta have more cow bell."],"phrases":["Shout it from on top of a mountain","Tell everyone and their dogs","Show them. Show them all!","Inspire your friends","Tell the world of your greatness","Look accomplished on social media","Share news of your grand endeavor","Establish your alibi for the past two hours","Prove to mom that computers aren't just for games","With coding power comes sharing responsibility","Have you told your friends of your coding powers?"]}

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/*
	 * Converts HTML entity codes in a string to the characters they represent.
	 *
	 * Example:
	 * `decodeHTMLEntities('Beets &amp; carrots');`
	 * will return "Beets & carrots".
	 *
	 * The regex makes sure we only replace the HTML entities in the string.
	 * For example, the regex would match "&lt;" as well as "&#58;".
	 * The decoding works by setting the innerHTML of a dummy element and then
	 * retrieving the innerText. Per the spec, innerText is a property that
	 * represents the "rendered" text content of an element.
	 *
	 * See:
	 * https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText
	 * https://developer.mozilla.org/en-US/docs/Glossary/Entity
	 *
	 */
	var decodeHTMLEntities = function decodeHTMLEntities(str) {
	  var el = document.createElement('div');
	  return str.replace(/\&[#0-9a-z]+;/gi, function (enc) {
	    el.innerHTML = enc;
	    return el.innerText;
	  });
	};
	
	exports.default = decodeHTMLEntities;
	module.exports = exports['default'];

/***/ }),

/***/ 123:
/***/ (function(module, exports) {

	'use strict';
	
	exports.dasherize = function dasherize(name) {
	  return ('' + name).toLowerCase().replace(/\s/g, '-').replace(/[^a-z0-9\-\.]/gi, '').replace(/\./g, '-').replace(/\:/g, '');
	};
	
	exports.nameify = function nameify(str) {
	  return ('' + str).replace(/[^a-zA-Z0-9\s]/g, '').replace(/\:/g, '');
	};
	
	exports.unDasherize = function unDasherize(name) {
	  return ('' + name).
	  // replace dash with space
	  replace(/\-/g, ' ')
	  // strip nonalphanumarics chars except whitespace
	  .replace(/[^a-zA-Z\d\s]/g, '').trim();
	};
	
	exports.descriptionRegex = /\<blockquote|\<ol|\<h4|\<table/;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-challenges-classic-show-js-421e740f86e50ef13c6d.js